module.exports = function (t) {
  function e(r) {
    if (i[r]) return i[r].exports;
    var n = i[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(n.exports, n, n.exports, e), n.l = !0, n.exports;
  }

  var i = {};
  return e.m = t, e.c = i, e.d = function (t, i, r) {
    e.o(t, i) || Object.defineProperty(t, i, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, e.n = function (t) {
    var i = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return e.d(i, "a", i), i;
  }, e.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, e.p = "", e(e.s = 2);
}([function (t, e) {
  var i;

  i = function () {
    return this;
  }();

  try {
    i = i || Function("return this")() || (0, eval)("this");
  } catch (t) {
    "object" === typeof window && (i = window);
  }

  t.exports = i;
}, function (t, e, i) {
  "use strict";

  function r() {}

  function n(t) {
    try {
      return t.then;
    } catch (t) {
      return g = t, y;
    }
  }

  function s(t, e) {
    try {
      return t(e);
    } catch (t) {
      return g = t, y;
    }
  }

  function a(t, e, i) {
    try {
      t(e, i);
    } catch (t) {
      return g = t, y;
    }
  }

  function o(t) {
    if ("object" !== typeof this) throw new TypeError("Promises must be constructed via new");
    if ("function" !== typeof t) throw new TypeError("Promise constructor's argument is not a function");
    this._75 = 0, this._83 = 0, this._18 = null, this._38 = null, t !== r && d(t, this);
  }

  function l(t, e, i) {
    return new t.constructor(function (n, s) {
      var a = new o(r);
      a.then(n, s), h(t, new p(e, i, a));
    });
  }

  function h(t, e) {
    for (; 3 === t._83;) {
      t = t._18;
    }

    if (o._47 && o._47(t), 0 === t._83) return 0 === t._75 ? (t._75 = 1, void (t._38 = e)) : 1 === t._75 ? (t._75 = 2, void (t._38 = [t._38, e])) : void t._38.push(e);
    u(t, e);
  }

  function u(t, e) {
    m(function () {
      var i = 1 === t._83 ? e.onFulfilled : e.onRejected;
      if (null === i) return void (1 === t._83 ? f(e.promise, t._18) : c(e.promise, t._18));
      var r = s(i, t._18);
      r === y ? c(e.promise, g) : f(e.promise, r);
    });
  }

  function f(t, e) {
    if (e === t) return c(t, new TypeError("A promise cannot be resolved with itself."));

    if (e && ("object" === typeof e || "function" === typeof e)) {
      var i = n(e);
      if (i === y) return c(t, g);
      if (i === t.then && e instanceof o) return t._83 = 3, t._18 = e, void _(t);
      if ("function" === typeof i) return void d(i.bind(e), t);
    }

    t._83 = 1, t._18 = e, _(t);
  }

  function c(t, e) {
    t._83 = 2, t._18 = e, o._71 && o._71(t, e), _(t);
  }

  function _(t) {
    if (1 === t._75 && (h(t, t._38), t._38 = null), 2 === t._75) {
      for (var e = 0; e < t._38.length; e++) {
        h(t, t._38[e]);
      }

      t._38 = null;
    }
  }

  function p(t, e, i) {
    this.onFulfilled = "function" === typeof t ? t : null, this.onRejected = "function" === typeof e ? e : null, this.promise = i;
  }

  function d(t, e) {
    var i = !1,
        r = a(t, function (t) {
      i || (i = !0, f(e, t));
    }, function (t) {
      i || (i = !0, c(e, t));
    });
    i || r !== y || (i = !0, c(e, g));
  }

  var m = i(5),
      g = null,
      y = {};
  t.exports = o, o._47 = null, o._71 = null, o._44 = r, o.prototype.then = function (t, e) {
    if (this.constructor !== o) return l(this, t, e);
    var i = new o(r);
    return h(this, new p(t, e, i)), i;
  };
}, function (t, e, i) {
  i(3), t.exports = i(9);
}, function (t, e, i) {
  "use strict";

  "undefined" === typeof Promise && (i(4).enable(), window.Promise = i(6)), i(7), Object.assign = i(8);
}, function (t, e, i) {
  "use strict";

  function r() {
    h = !1, o._47 = null, o._71 = null;
  }

  function n(t) {
    function e(e) {
      (t.allRejections || a(f[e].error, t.whitelist || l)) && (f[e].displayId = u++, t.onUnhandled ? (f[e].logged = !0, t.onUnhandled(f[e].displayId, f[e].error)) : (f[e].logged = !0, s(f[e].displayId, f[e].error)));
    }

    function i(e) {
      f[e].logged && (t.onHandled ? t.onHandled(f[e].displayId, f[e].error) : f[e].onUnhandled || (console.warn("Promise Rejection Handled (id: " + f[e].displayId + "):"), console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + f[e].displayId + ".")));
    }

    t = t || {}, h && r(), h = !0;
    var n = 0,
        u = 0,
        f = {};
    o._47 = function (t) {
      2 === t._83 && f[t._56] && (f[t._56].logged ? i(t._56) : clearTimeout(f[t._56].timeout), delete f[t._56]);
    }, o._71 = function (t, i) {
      0 === t._75 && (t._56 = n++, f[t._56] = {
        displayId: null,
        error: i,
        timeout: setTimeout(e.bind(null, t._56), a(i, l) ? 100 : 2e3),
        logged: !1
      });
    };
  }

  function s(t, e) {
    console.warn("Possible Unhandled Promise Rejection (id: " + t + "):"), ((e && (e.stack || e)) + "").split("\n").forEach(function (t) {
      console.warn("  " + t);
    });
  }

  function a(t, e) {
    return e.some(function (e) {
      return t instanceof e;
    });
  }

  var o = i(1),
      l = [ReferenceError, TypeError, RangeError],
      h = !1;
  e.disable = r, e.enable = n;
}, function (t, e, i) {
  "use strict";

  (function (e) {
    function i(t) {
      a.length || (s(), o = !0), a[a.length] = t;
    }

    function r() {
      for (; l < a.length;) {
        var t = l;

        if (l += 1, a[t].call(), l > h) {
          for (var e = 0, i = a.length - l; e < i; e++) {
            a[e] = a[e + l];
          }

          a.length -= l, l = 0;
        }
      }

      a.length = 0, l = 0, o = !1;
    }

    function n(t) {
      return function () {
        function e() {
          clearTimeout(i), clearInterval(r), t();
        }

        var i = setTimeout(e, 0),
            r = setInterval(e, 50);
      };
    }

    t.exports = i;
    var s,
        a = [],
        o = !1,
        l = 0,
        h = 1024,
        u = "undefined" !== typeof e ? e : self,
        f = u.MutationObserver || u.WebKitMutationObserver;
    s = "function" === typeof f ? function (t) {
      var e = 1,
          i = new f(t),
          r = document.createTextNode("");
      return i.observe(r, {
        characterData: !0
      }), function () {
        e = -e, r.data = e;
      };
    }(r) : n(r), i.requestFlush = s, i.makeRequestCallFromTimer = n;
  }).call(e, i(0));
}, function (t, e, i) {
  "use strict";

  function r(t) {
    var e = new n(n._44);
    return e._83 = 1, e._18 = t, e;
  }

  var n = i(1);
  t.exports = n;
  var s = r(!0),
      a = r(!1),
      o = r(null),
      l = r(void 0),
      h = r(0),
      u = r("");
  n.resolve = function (t) {
    if (t instanceof n) return t;
    if (null === t) return o;
    if (void 0 === t) return l;
    if (!0 === t) return s;
    if (!1 === t) return a;
    if (0 === t) return h;
    if ("" === t) return u;
    if ("object" === typeof t || "function" === typeof t) try {
      var e = t.then;
      if ("function" === typeof e) return new n(e.bind(t));
    } catch (t) {
      return new n(function (e, i) {
        i(t);
      });
    }
    return r(t);
  }, n.all = function (t) {
    var e = Array.prototype.slice.call(t);
    return new n(function (t, i) {
      function r(a, o) {
        if (o && ("object" === typeof o || "function" === typeof o)) {
          if (o instanceof n && o.then === n.prototype.then) {
            for (; 3 === o._83;) {
              o = o._18;
            }

            return 1 === o._83 ? r(a, o._18) : (2 === o._83 && i(o._18), void o.then(function (t) {
              r(a, t);
            }, i));
          }

          var l = o.then;

          if ("function" === typeof l) {
            return void new n(l.bind(o)).then(function (t) {
              r(a, t);
            }, i);
          }
        }

        e[a] = o, 0 === --s && t(e);
      }

      if (0 === e.length) return t([]);

      for (var s = e.length, a = 0; a < e.length; a++) {
        r(a, e[a]);
      }
    });
  }, n.reject = function (t) {
    return new n(function (e, i) {
      i(t);
    });
  }, n.race = function (t) {
    return new n(function (e, i) {
      t.forEach(function (t) {
        n.resolve(t).then(e, i);
      });
    });
  }, n.prototype.catch = function (t) {
    return this.then(null, t);
  };
}, function (t, e) {
  !function (t) {
    "use strict";

    function e(t) {
      if ("string" !== typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
      return t.toLowerCase();
    }

    function i(t) {
      return "string" !== typeof t && (t = String(t)), t;
    }

    function r(t) {
      var e = {
        next: function next() {
          var e = t.shift();
          return {
            done: void 0 === e,
            value: e
          };
        }
      };
      return g.iterable && (e[Symbol.iterator] = function () {
        return e;
      }), e;
    }

    function n(t) {
      this.map = {}, t instanceof n ? t.forEach(function (t, e) {
        this.append(e, t);
      }, this) : Array.isArray(t) ? t.forEach(function (t) {
        this.append(t[0], t[1]);
      }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
        this.append(e, t[e]);
      }, this);
    }

    function s(t) {
      if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
      t.bodyUsed = !0;
    }

    function a(t) {
      return new Promise(function (e, i) {
        t.onload = function () {
          e(t.result);
        }, t.onerror = function () {
          i(t.error);
        };
      });
    }

    function o(t) {
      var e = new FileReader(),
          i = a(e);
      return e.readAsArrayBuffer(t), i;
    }

    function l(t) {
      var e = new FileReader(),
          i = a(e);
      return e.readAsText(t), i;
    }

    function h(t) {
      for (var e = new Uint8Array(t), i = new Array(e.length), r = 0; r < e.length; r++) {
        i[r] = String.fromCharCode(e[r]);
      }

      return i.join("");
    }

    function u(t) {
      if (t.slice) return t.slice(0);
      var e = new Uint8Array(t.byteLength);
      return e.set(new Uint8Array(t)), e.buffer;
    }

    function f() {
      return this.bodyUsed = !1, this._initBody = function (t) {
        if (this._bodyInit = t, t) {
          if ("string" === typeof t) this._bodyText = t;else if (g.blob && Blob.prototype.isPrototypeOf(t)) this._bodyBlob = t;else if (g.formData && FormData.prototype.isPrototypeOf(t)) this._bodyFormData = t;else if (g.searchParams && URLSearchParams.prototype.isPrototypeOf(t)) this._bodyText = t.toString();else if (g.arrayBuffer && g.blob && v(t)) this._bodyArrayBuffer = u(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
            if (!g.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(t) && !b(t)) throw new Error("unsupported BodyInit type");
            this._bodyArrayBuffer = u(t);
          }
        } else this._bodyText = "";
        this.headers.get("content-type") || ("string" === typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : g.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
      }, g.blob && (this.blob = function () {
        var t = s(this);
        if (t) return t;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        return Promise.resolve(new Blob([this._bodyText]));
      }, this.arrayBuffer = function () {
        return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(o);
      }), this.text = function () {
        var t = s(this);
        if (t) return t;
        if (this._bodyBlob) return l(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(h(this._bodyArrayBuffer));
        if (this._bodyFormData) throw new Error("could not read FormData body as text");
        return Promise.resolve(this._bodyText);
      }, g.formData && (this.formData = function () {
        return this.text().then(p);
      }), this.json = function () {
        return this.text().then(JSON.parse);
      }, this;
    }

    function c(t) {
      var e = t.toUpperCase();
      return T.indexOf(e) > -1 ? e : t;
    }

    function _(t, e) {
      e = e || {};
      var i = e.body;

      if (t instanceof _) {
        if (t.bodyUsed) throw new TypeError("Already read");
        this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new n(t.headers)), this.method = t.method, this.mode = t.mode, i || null == t._bodyInit || (i = t._bodyInit, t.bodyUsed = !0);
      } else this.url = String(t);

      if (this.credentials = e.credentials || this.credentials || "omit", !e.headers && this.headers || (this.headers = new n(e.headers)), this.method = c(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");

      this._initBody(i);
    }

    function p(t) {
      var e = new FormData();
      return t.trim().split("&").forEach(function (t) {
        if (t) {
          var i = t.split("="),
              r = i.shift().replace(/\+/g, " "),
              n = i.join("=").replace(/\+/g, " ");
          e.append(decodeURIComponent(r), decodeURIComponent(n));
        }
      }), e;
    }

    function d(t) {
      var e = new n();
      return t.split(/\r?\n/).forEach(function (t) {
        var i = t.split(":"),
            r = i.shift().trim();

        if (r) {
          var n = i.join(":").trim();
          e.append(r, n);
        }
      }), e;
    }

    function m(t, e) {
      e || (e = {}), this.type = "default", this.status = "status" in e ? e.status : 200, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new n(e.headers), this.url = e.url || "", this._initBody(t);
    }

    if (!t.fetch) {
      var g = {
        searchParams: "URLSearchParams" in t,
        iterable: "Symbol" in t && "iterator" in Symbol,
        blob: "FileReader" in t && "Blob" in t && function () {
          try {
            return new Blob(), !0;
          } catch (t) {
            return !1;
          }
        }(),
        formData: "FormData" in t,
        arrayBuffer: "ArrayBuffer" in t
      };
      if (g.arrayBuffer) var y = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          v = function v(t) {
        return t && DataView.prototype.isPrototypeOf(t);
      },
          b = ArrayBuffer.isView || function (t) {
        return t && y.indexOf(Object.prototype.toString.call(t)) > -1;
      };
      n.prototype.append = function (t, r) {
        t = e(t), r = i(r);
        var n = this.map[t];
        this.map[t] = n ? n + "," + r : r;
      }, n.prototype.delete = function (t) {
        delete this.map[e(t)];
      }, n.prototype.get = function (t) {
        return t = e(t), this.has(t) ? this.map[t] : null;
      }, n.prototype.has = function (t) {
        return this.map.hasOwnProperty(e(t));
      }, n.prototype.set = function (t, r) {
        this.map[e(t)] = i(r);
      }, n.prototype.forEach = function (t, e) {
        for (var i in this.map) {
          this.map.hasOwnProperty(i) && t.call(e, this.map[i], i, this);
        }
      }, n.prototype.keys = function () {
        var t = [];
        return this.forEach(function (e, i) {
          t.push(i);
        }), r(t);
      }, n.prototype.values = function () {
        var t = [];
        return this.forEach(function (e) {
          t.push(e);
        }), r(t);
      }, n.prototype.entries = function () {
        var t = [];
        return this.forEach(function (e, i) {
          t.push([i, e]);
        }), r(t);
      }, g.iterable && (n.prototype[Symbol.iterator] = n.prototype.entries);
      var T = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      _.prototype.clone = function () {
        return new _(this, {
          body: this._bodyInit
        });
      }, f.call(_.prototype), f.call(m.prototype), m.prototype.clone = function () {
        return new m(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new n(this.headers),
          url: this.url
        });
      }, m.error = function () {
        var t = new m(null, {
          status: 0,
          statusText: ""
        });
        return t.type = "error", t;
      };
      var x = [301, 302, 303, 307, 308];
      m.redirect = function (t, e) {
        if (-1 === x.indexOf(e)) throw new RangeError("Invalid status code");
        return new m(null, {
          status: e,
          headers: {
            location: t
          }
        });
      }, t.Headers = n, t.Request = _, t.Response = m, t.fetch = function (t, e) {
        return new Promise(function (i, r) {
          var n = new _(t, e),
              s = new XMLHttpRequest();
          s.onload = function () {
            var t = {
              status: s.status,
              statusText: s.statusText,
              headers: d(s.getAllResponseHeaders() || "")
            };
            t.url = "responseURL" in s ? s.responseURL : t.headers.get("X-Request-URL");
            var e = "response" in s ? s.response : s.responseText;
            i(new m(e, t));
          }, s.onerror = function () {
            r(new TypeError("Network request failed"));
          }, s.ontimeout = function () {
            r(new TypeError("Network request failed"));
          }, s.open(n.method, n.url, !0), "include" === n.credentials && (s.withCredentials = !0), "responseType" in s && g.blob && (s.responseType = "blob"), n.headers.forEach(function (t, e) {
            s.setRequestHeader(e, t);
          }), s.send("undefined" === typeof n._bodyInit ? null : n._bodyInit);
        });
      }, t.fetch.polyfill = !0;
    }
  }("undefined" !== typeof self ? self : this);
}, function (t, e, i) {
  "use strict";

  function r(t) {
    if (null === t || void 0 === t) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
  }

  var n = Object.getOwnPropertySymbols,
      s = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;
  t.exports = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

      for (var e = {}, i = 0; i < 10; i++) {
        e["_" + String.fromCharCode(i)] = i;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        r[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var i, o, l = r(t), h = 1; h < arguments.length; h++) {
      i = Object(arguments[h]);

      for (var u in i) {
        s.call(i, u) && (l[u] = i[u]);
      }

      if (n) {
        o = n(i);

        for (var f = 0; f < o.length; f++) {
          a.call(i, o[f]) && (l[o[f]] = i[o[f]]);
        }
      }
    }

    return l;
  };
}, function (t, e, i) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = i(10);
  e.default = r.a;
}, function (t, e, i) {
  "use strict";

  function r(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  }

  function n(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function s(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" !== typeof e && "function" !== typeof e ? t : e;
  }

  function a(t, e) {
    if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }

  var o = i(11),
      l = i.n(o),
      h = i(12),
      u = (i.n(h), i(17)),
      f = (i.n(u), i(18)),
      c = i.n(f),
      _ = i(19),
      p = i.n(_),
      d = i(20),
      m = (i.n(d), function () {
    function t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var r = e[i];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, i, r) {
      return i && t(e.prototype, i), r && t(e, r), e;
    };
  }());

  c.a.init();

  var g = function (t) {
    function e() {
      var t, i, r, a;
      n(this, e);

      for (var o = arguments.length, l = Array(o), h = 0; h < o; h++) {
        l[h] = arguments[h];
      }

      return i = r = s(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(l))), r.state = {
        isPressed: !1
      }, r.handleTouchStart = function () {
        r.setState({
          isPressed: !0
        });
        var t = r.getScaleElement();
        t && u.TweenLite.to(t, .2, {
          scale: .96
        });
      }, r.handleTouchEnd = function () {
        r.setState({
          isPressed: !1
        });
        var t = r.getScaleElement();
        t && u.TweenLite.to(t, .2, {
          scale: 1
        });
      }, a = i, s(r, a);
    }

    return a(e, t), m(e, [{
      key: "componentDidMount",
      value: function value() {
        this.props.waves && this.attachWaves();
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        var t = this.props.waves,
            e = this.element.parentNode.classList.contains("waves-effect");
        t && !e ? this.attachWaves() : !t && e && this.destroyWaves();
      }
    }, {
      key: "attachWaves",
      value: function value() {
        var t = this.props.light;
        c.a.attach(this.element.parentNode, t ? "waves-light" : null);
      }
    }, {
      key: "destroyWaves",
      value: function value() {
        c.a.calm(this.element.parentNode), this.element.parentNode.classList.remove("waves-effect");
      }
    }, {
      key: "getScaleElement",
      value: function value() {
        var t = this.props,
            e = t.scale,
            i = t.children;
        return e && i ? this.element.childNodes : e ? this.element.parentNode : null;
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            i = e.className,
            n = e.children,
            s = e.fade,
            a = e.light,
            o = this.state.isPressed,
            h = p()(r({
          Tap: !0,
          Tap_light: a,
          Tap_fade: o && s
        }, i, i));
        return l.a.createElement("span", {
          className: h,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onMouseDown: this.handleTouchStart,
          onMouseUp: this.handleTouchEnd,
          onMouseLeave: this.handleTouchEnd,
          ref: function ref(e) {
            t.element = e;
          }
        }, n);
      }
    }]), e;
  }(o.Component);

  g.propTypes = {
    className: h.string,
    light: h.bool,
    waves: h.bool,
    fade: h.bool,
    scale: h.bool,
    children: h.node
  }, g.defaultProps = {
    className: "",
    light: !1,
    waves: !1,
    fade: !1,
    scale: !1,
    children: null
  }, e.a = g;
}, function (t, e) {
  t.exports = require("react");
}, function (t, e, i) {
  t.exports = i(13)();
}, function (t, e, i) {
  "use strict";

  var r = i(14),
      n = i(15),
      s = i(16);

  t.exports = function () {
    function t(t, e, i, r, a, o) {
      o !== s && n(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var i = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return i.checkPropTypes = r, i.PropTypes = i, i;
  };
}, function (t, e, i) {
  "use strict";

  function r(t) {
    return function () {
      return t;
    };
  }

  var n = function n() {};

  n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function () {
    return this;
  }, n.thatReturnsArgument = function (t) {
    return t;
  }, t.exports = n;
}, function (t, e, i) {
  "use strict";

  function r(t, e, i, r, s, a, o, l) {
    if (n(e), !t) {
      var h;
      if (void 0 === e) h = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var u = [i, r, s, a, o, l],
            f = 0;
        h = new Error(e.replace(/%s/g, function () {
          return u[f++];
        })), h.name = "Invariant Violation";
      }
      throw h.framesToPop = 1, h;
    }
  }

  var n = function n(t) {};

  t.exports = r;
}, function (t, e, i) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, i) {
  (function (i) {
    var r,
        n,
        s = "undefined" !== typeof t && t.exports && "undefined" !== typeof i ? i : this || window;
    (s._gsQueue || (s._gsQueue = [])).push(function () {
      "use strict";

      s._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (t, e, i) {
        var r = function r(t) {
          var e,
              i = [],
              r = t.length;

          for (e = 0; e !== r; i.push(t[e++])) {
            ;
          }

          return i;
        },
            n = function n(t, e, i) {
          var r,
              n,
              s = t.cycle;

          for (r in s) {
            n = s[r], t[r] = "function" === typeof n ? n(i, e[i]) : n[i % n.length];
          }

          delete t.cycle;
        },
            s = function s(t, e, r) {
          i.call(this, t, e, r), this._cycle = 0, this._yoyo = !0 === this.vars.yoyo || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._repeat && this._uncache(!0), this.render = s.prototype.render;
        },
            a = i._internals,
            o = a.isSelector,
            l = a.isArray,
            h = s.prototype = i.to({}, .1, {}),
            u = [];

        s.version = "1.20.3", h.constructor = s, h.kill()._gc = !1, s.killTweensOf = s.killDelayedCallsTo = i.killTweensOf, s.getTweensOf = i.getTweensOf, s.lagSmoothing = i.lagSmoothing, s.ticker = i.ticker, s.render = i.render, h.invalidate = function () {
          return this._yoyo = !0 === this.vars.yoyo || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._yoyoEase = null, this._uncache(!0), i.prototype.invalidate.call(this);
        }, h.updateTo = function (t, e) {
          var r,
              n = this.ratio,
              s = this.vars.immediateRender || t.immediateRender;
          e && this._startTime < this._timeline._time && (this._startTime = this._timeline._time, this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));

          for (r in t) {
            this.vars[r] = t[r];
          }

          if (this._initted || s) if (e) this._initted = !1, s && this.render(0, !0, !0);else if (this._gc && this._enabled(!0, !1), this._notifyPluginsOfEnabled && this._firstPT && i._onPluginEvent("_onDisable", this), this._time / this._duration > .998) {
            var a = this._totalTime;
            this.render(0, !0, !1), this._initted = !1, this.render(a, !0, !1);
          } else if (this._initted = !1, this._init(), this._time > 0 || s) for (var o, l = 1 / (1 - n), h = this._firstPT; h;) {
            o = h.s + h.c, h.c *= l, h.s = o - h.c, h = h._next;
          }
          return this;
        }, h.render = function (t, e, r) {
          this._initted || 0 === this._duration && this.vars.repeat && this.invalidate();

          var n,
              s,
              o,
              l,
              h,
              u,
              f,
              c,
              _,
              p = this._dirty ? this.totalDuration() : this._totalDuration,
              d = this._time,
              m = this._totalTime,
              g = this._cycle,
              y = this._duration,
              v = this._rawPrevTime;

          if (t >= p - 1e-7 && t >= 0 ? (this._totalTime = p, this._cycle = this._repeat, this._yoyo && 0 !== (1 & this._cycle) ? (this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = y, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1), this._reversed || (n = !0, s = "onComplete", r = r || this._timeline.autoRemoveChildren), 0 === y && (this._initted || !this.vars.lazy || r) && (this._startTime === this._timeline._duration && (t = 0), (v < 0 || t <= 0 && t >= -1e-7 || 1e-10 === v && "isPause" !== this.data) && v !== t && (r = !0, v > 1e-10 && (s = "onReverseComplete")), this._rawPrevTime = c = !e || t || v === t ? t : 1e-10)) : t < 1e-7 ? (this._totalTime = this._time = this._cycle = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== m || 0 === y && v > 0) && (s = "onReverseComplete", n = this._reversed), t < 0 && (this._active = !1, 0 === y && (this._initted || !this.vars.lazy || r) && (v >= 0 && (r = !0), this._rawPrevTime = c = !e || t || v === t ? t : 1e-10)), this._initted || (r = !0)) : (this._totalTime = this._time = t, 0 !== this._repeat && (l = y + this._repeatDelay, this._cycle = this._totalTime / l >> 0, 0 !== this._cycle && this._cycle === this._totalTime / l && m <= t && this._cycle--, this._time = this._totalTime - this._cycle * l, this._yoyo && 0 !== (1 & this._cycle) && (this._time = y - this._time, (_ = this._yoyoEase || this.vars.yoyoEase) && (this._yoyoEase || (!0 !== _ || this._initted ? this._yoyoEase = _ = !0 === _ ? this._ease : _ instanceof Ease ? _ : Ease.map[_] : (_ = this.vars.ease, this._yoyoEase = _ = _ ? _ instanceof Ease ? _ : "function" === typeof _ ? new Ease(_, this.vars.easeParams) : Ease.map[_] || i.defaultEase : i.defaultEase)), this.ratio = _ ? 1 - _.getRatio((y - this._time) / y) : 0)), this._time > y ? this._time = y : this._time < 0 && (this._time = 0)), this._easeType && !_ ? (h = this._time / y, u = this._easeType, f = this._easePower, (1 === u || 3 === u && h >= .5) && (h = 1 - h), 3 === u && (h *= 2), 1 === f ? h *= h : 2 === f ? h *= h * h : 3 === f ? h *= h * h * h : 4 === f && (h *= h * h * h * h), 1 === u ? this.ratio = 1 - h : 2 === u ? this.ratio = h : this._time / y < .5 ? this.ratio = h / 2 : this.ratio = 1 - h / 2) : _ || (this.ratio = this._ease.getRatio(this._time / y))), d === this._time && !r && g === this._cycle) return void (m !== this._totalTime && this._onUpdate && (e || this._callback("onUpdate")));

          if (!this._initted) {
            if (this._init(), !this._initted || this._gc) return;
            if (!r && this._firstPT && (!1 !== this.vars.lazy && this._duration || this.vars.lazy && !this._duration)) return this._time = d, this._totalTime = m, this._rawPrevTime = v, this._cycle = g, a.lazyTweens.push(this), void (this._lazy = [t, e]);
            !this._time || n || _ ? n && this._ease._calcEnd && !_ && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1)) : this.ratio = this._ease.getRatio(this._time / y);
          }

          for (!1 !== this._lazy && (this._lazy = !1), this._active || !this._paused && this._time !== d && t >= 0 && (this._active = !0), 0 === m && (2 === this._initted && t > 0 && this._init(), this._startAt && (t >= 0 ? this._startAt.render(t, !0, r) : s || (s = "_dummyGS")), this.vars.onStart && (0 === this._totalTime && 0 !== y || e || this._callback("onStart"))), o = this._firstPT; o;) {
            o.f ? o.t[o.p](o.c * this.ratio + o.s) : o.t[o.p] = o.c * this.ratio + o.s, o = o._next;
          }

          this._onUpdate && (t < 0 && this._startAt && this._startTime && this._startAt.render(t, !0, r), e || (this._totalTime !== m || s) && this._callback("onUpdate")), this._cycle !== g && (e || this._gc || this.vars.onRepeat && this._callback("onRepeat")), s && (this._gc && !r || (t < 0 && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(t, !0, r), n && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[s] && this._callback(s), 0 === y && 1e-10 === this._rawPrevTime && 1e-10 !== c && (this._rawPrevTime = 0)));
        }, s.to = function (t, e, i) {
          return new s(t, e, i);
        }, s.from = function (t, e, i) {
          return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, new s(t, e, i);
        }, s.fromTo = function (t, e, i, r) {
          return r.startAt = i, r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender, new s(t, e, r);
        }, s.staggerTo = s.allTo = function (t, e, a, h, f, c, _) {
          h = h || 0;

          var p,
              d,
              m,
              g,
              y = 0,
              v = [],
              b = function b() {
            a.onComplete && a.onComplete.apply(a.onCompleteScope || this, arguments), f.apply(_ || a.callbackScope || this, c || u);
          },
              T = a.cycle,
              x = a.startAt && a.startAt.cycle;

          for (l(t) || ("string" === typeof t && (t = i.selector(t) || t), o(t) && (t = r(t))), t = t || [], h < 0 && (t = r(t), t.reverse(), h *= -1), p = t.length - 1, m = 0; m <= p; m++) {
            d = {};

            for (g in a) {
              d[g] = a[g];
            }

            if (T && (n(d, t, m), null != d.duration && (e = d.duration, delete d.duration)), x) {
              x = d.startAt = {};

              for (g in a.startAt) {
                x[g] = a.startAt[g];
              }

              n(d.startAt, t, m);
            }

            d.delay = y + (d.delay || 0), m === p && f && (d.onComplete = b), v[m] = new s(t[m], e, d), y += h;
          }

          return v;
        }, s.staggerFrom = s.allFrom = function (t, e, i, r, n, a, o) {
          return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, s.staggerTo(t, e, i, r, n, a, o);
        }, s.staggerFromTo = s.allFromTo = function (t, e, i, r, n, a, o, l) {
          return r.startAt = i, r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender, s.staggerTo(t, e, r, n, a, o, l);
        }, s.delayedCall = function (t, e, i, r, n) {
          return new s(e, 0, {
            delay: t,
            onComplete: e,
            onCompleteParams: i,
            callbackScope: r,
            onReverseComplete: e,
            onReverseCompleteParams: i,
            immediateRender: !1,
            useFrames: n,
            overwrite: 0
          });
        }, s.set = function (t, e) {
          return new s(t, 0, e);
        }, s.isTweening = function (t) {
          return i.getTweensOf(t, !0).length > 0;
        };

        var f = function f(t, e) {
          for (var r = [], n = 0, s = t._first; s;) {
            s instanceof i ? r[n++] = s : (e && (r[n++] = s), r = r.concat(f(s, e)), n = r.length), s = s._next;
          }

          return r;
        },
            c = s.getAllTweens = function (e) {
          return f(t._rootTimeline, e).concat(f(t._rootFramesTimeline, e));
        };

        s.killAll = function (t, i, r, n) {
          null == i && (i = !0), null == r && (r = !0);
          var s,
              a,
              o,
              l = c(0 != n),
              h = l.length,
              u = i && r && n;

          for (o = 0; o < h; o++) {
            a = l[o], (u || a instanceof e || (s = a.target === a.vars.onComplete) && r || i && !s) && (t ? a.totalTime(a._reversed ? 0 : a.totalDuration()) : a._enabled(!1, !1));
          }
        }, s.killChildTweensOf = function (t, e) {
          if (null != t) {
            var n,
                h,
                u,
                f,
                c,
                _ = a.tweenLookup;
            if ("string" === typeof t && (t = i.selector(t) || t), o(t) && (t = r(t)), l(t)) for (f = t.length; --f > -1;) {
              s.killChildTweensOf(t[f], e);
            } else {
              n = [];

              for (u in _) {
                for (h = _[u].target.parentNode; h;) {
                  h === t && (n = n.concat(_[u].tweens)), h = h.parentNode;
                }
              }

              for (c = n.length, f = 0; f < c; f++) {
                e && n[f].totalTime(n[f].totalDuration()), n[f]._enabled(!1, !1);
              }
            }
          }
        };

        var _ = function _(t, i, r, n) {
          i = !1 !== i, r = !1 !== r, n = !1 !== n;

          for (var s, a, o = c(n), l = i && r && n, h = o.length; --h > -1;) {
            a = o[h], (l || a instanceof e || (s = a.target === a.vars.onComplete) && r || i && !s) && a.paused(t);
          }
        };

        return s.pauseAll = function (t, e, i) {
          _(!0, t, e, i);
        }, s.resumeAll = function (t, e, i) {
          _(!1, t, e, i);
        }, s.globalTimeScale = function (e) {
          var r = t._rootTimeline,
              n = i.ticker.time;
          return arguments.length ? (e = e || 1e-10, r._startTime = n - (n - r._startTime) * r._timeScale / e, r = t._rootFramesTimeline, n = i.ticker.frame, r._startTime = n - (n - r._startTime) * r._timeScale / e, r._timeScale = t._rootTimeline._timeScale = e, e) : r._timeScale;
        }, h.progress = function (t, e) {
          return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), e) : this._time / this.duration();
        }, h.totalProgress = function (t, e) {
          return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this._totalTime / this.totalDuration();
        }, h.time = function (t, e) {
          return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time;
        }, h.duration = function (e) {
          return arguments.length ? t.prototype.duration.call(this, e) : this._duration;
        }, h.totalDuration = function (t) {
          return arguments.length ? -1 === this._repeat ? this : this.duration((t - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration);
        }, h.repeat = function (t) {
          return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat;
        }, h.repeatDelay = function (t) {
          return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay;
        }, h.yoyo = function (t) {
          return arguments.length ? (this._yoyo = t, this) : this._yoyo;
        }, s;
      }, !0), s._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (t, e, i) {
        var r = function r(t) {
          e.call(this, t), this._labels = {}, this.autoRemoveChildren = !0 === this.vars.autoRemoveChildren, this.smoothChildTiming = !0 === this.vars.smoothChildTiming, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate;
          var i,
              r,
              n = this.vars;

          for (r in n) {
            i = n[r], l(i) && -1 !== i.join("").indexOf("{self}") && (n[r] = this._swapSelfInParams(i));
          }

          l(n.tweens) && this.add(n.tweens, 0, n.align, n.stagger);
        },
            n = i._internals,
            a = r._internals = {},
            o = n.isSelector,
            l = n.isArray,
            h = n.lazyTweens,
            u = n.lazyRender,
            f = s._gsDefine.globals,
            c = function c(t) {
          var e,
              i = {};

          for (e in t) {
            i[e] = t[e];
          }

          return i;
        },
            _ = function _(t, e, i) {
          var r,
              n,
              s = t.cycle;

          for (r in s) {
            n = s[r], t[r] = "function" === typeof n ? n(i, e[i]) : n[i % n.length];
          }

          delete t.cycle;
        },
            p = a.pauseCallback = function () {},
            d = function d(t) {
          var e,
              i = [],
              r = t.length;

          for (e = 0; e !== r; i.push(t[e++])) {
            ;
          }

          return i;
        },
            m = r.prototype = new e();

        return r.version = "1.20.3", m.constructor = r, m.kill()._gc = m._forcingPlayhead = m._hasPause = !1, m.to = function (t, e, r, n) {
          var s = r.repeat && f.TweenMax || i;
          return e ? this.add(new s(t, e, r), n) : this.set(t, r, n);
        }, m.from = function (t, e, r, n) {
          return this.add((r.repeat && f.TweenMax || i).from(t, e, r), n);
        }, m.fromTo = function (t, e, r, n, s) {
          var a = n.repeat && f.TweenMax || i;
          return e ? this.add(a.fromTo(t, e, r, n), s) : this.set(t, n, s);
        }, m.staggerTo = function (t, e, n, s, a, l, h, u) {
          var f,
              p,
              m = new r({
            onComplete: l,
            onCompleteParams: h,
            callbackScope: u,
            smoothChildTiming: this.smoothChildTiming
          }),
              g = n.cycle;

          for ("string" === typeof t && (t = i.selector(t) || t), t = t || [], o(t) && (t = d(t)), s = s || 0, s < 0 && (t = d(t), t.reverse(), s *= -1), p = 0; p < t.length; p++) {
            f = c(n), f.startAt && (f.startAt = c(f.startAt), f.startAt.cycle && _(f.startAt, t, p)), g && (_(f, t, p), null != f.duration && (e = f.duration, delete f.duration)), m.to(t[p], e, f, p * s);
          }

          return this.add(m, a);
        }, m.staggerFrom = function (t, e, i, r, n, s, a, o) {
          return i.immediateRender = 0 != i.immediateRender, i.runBackwards = !0, this.staggerTo(t, e, i, r, n, s, a, o);
        }, m.staggerFromTo = function (t, e, i, r, n, s, a, o, l) {
          return r.startAt = i, r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender, this.staggerTo(t, e, r, n, s, a, o, l);
        }, m.call = function (t, e, r, n) {
          return this.add(i.delayedCall(0, t, e, r), n);
        }, m.set = function (t, e, r) {
          return r = this._parseTimeOrLabel(r, 0, !0), null == e.immediateRender && (e.immediateRender = r === this._time && !this._paused), this.add(new i(t, 0, e), r);
        }, r.exportRoot = function (t, e) {
          t = t || {}, null == t.smoothChildTiming && (t.smoothChildTiming = !0);
          var n,
              s,
              a,
              o,
              l = new r(t),
              h = l._timeline;

          for (null == e && (e = !0), h._remove(l, !0), l._startTime = 0, l._rawPrevTime = l._time = l._totalTime = h._time, a = h._first; a;) {
            o = a._next, e && a instanceof i && a.target === a.vars.onComplete || (s = a._startTime - a._delay, s < 0 && (n = 1), l.add(a, s)), a = o;
          }

          return h.add(l, 0), n && l.totalDuration(), l;
        }, m.add = function (n, s, a, o) {
          var h, u, f, c, _, p;

          if ("number" !== typeof s && (s = this._parseTimeOrLabel(s, 0, !0, n)), !(n instanceof t)) {
            if (n instanceof Array || n && n.push && l(n)) {
              for (a = a || "normal", o = o || 0, h = s, u = n.length, f = 0; f < u; f++) {
                l(c = n[f]) && (c = new r({
                  tweens: c
                })), this.add(c, h), "string" !== typeof c && "function" !== typeof c && ("sequence" === a ? h = c._startTime + c.totalDuration() / c._timeScale : "start" === a && (c._startTime -= c.delay())), h += o;
              }

              return this._uncache(!0);
            }

            if ("string" === typeof n) return this.addLabel(n, s);
            if ("function" !== typeof n) throw "Cannot add " + n + " into the timeline; it is not a tween, timeline, function, or string.";
            n = i.delayedCall(0, n);
          }

          if (e.prototype.add.call(this, n, s), n._time && n.render((this.rawTime() - n._startTime) * n._timeScale, !1, !1), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()) for (_ = this, p = _.rawTime() > n._startTime; _._timeline;) {
            p && _._timeline.smoothChildTiming ? _.totalTime(_._totalTime, !0) : _._gc && _._enabled(!0, !1), _ = _._timeline;
          }
          return this;
        }, m.remove = function (e) {
          if (e instanceof t) {
            this._remove(e, !1);

            var i = e._timeline = e.vars.useFrames ? t._rootFramesTimeline : t._rootTimeline;
            return e._startTime = (e._paused ? e._pauseTime : i._time) - (e._reversed ? e.totalDuration() - e._totalTime : e._totalTime) / e._timeScale, this;
          }

          if (e instanceof Array || e && e.push && l(e)) {
            for (var r = e.length; --r > -1;) {
              this.remove(e[r]);
            }

            return this;
          }

          return "string" === typeof e ? this.removeLabel(e) : this.kill(null, e);
        }, m._remove = function (t, i) {
          return e.prototype._remove.call(this, t, i), this._last ? this._time > this.duration() && (this._time = this._duration, this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this;
        }, m.append = function (t, e) {
          return this.add(t, this._parseTimeOrLabel(null, e, !0, t));
        }, m.insert = m.insertMultiple = function (t, e, i, r) {
          return this.add(t, e || 0, i, r);
        }, m.appendMultiple = function (t, e, i, r) {
          return this.add(t, this._parseTimeOrLabel(null, e, !0, t), i, r);
        }, m.addLabel = function (t, e) {
          return this._labels[t] = this._parseTimeOrLabel(e), this;
        }, m.addPause = function (t, e, r, n) {
          var s = i.delayedCall(0, p, r, n || this);
          return s.vars.onComplete = s.vars.onReverseComplete = e, s.data = "isPause", this._hasPause = !0, this.add(s, t);
        }, m.removeLabel = function (t) {
          return delete this._labels[t], this;
        }, m.getLabelTime = function (t) {
          return null != this._labels[t] ? this._labels[t] : -1;
        }, m._parseTimeOrLabel = function (e, i, r, n) {
          var s, a;
          if (n instanceof t && n.timeline === this) this.remove(n);else if (n && (n instanceof Array || n.push && l(n))) for (a = n.length; --a > -1;) {
            n[a] instanceof t && n[a].timeline === this && this.remove(n[a]);
          }
          if (s = "number" !== typeof e || i ? this.duration() > 99999999999 ? this.recent().endTime(!1) : this._duration : 0, "string" === typeof i) return this._parseTimeOrLabel(i, r && "number" === typeof e && null == this._labels[i] ? e - s : 0, r);
          if (i = i || 0, "string" !== typeof e || !isNaN(e) && null == this._labels[e]) null == e && (e = s);else {
            if (-1 === (a = e.indexOf("="))) return null == this._labels[e] ? r ? this._labels[e] = s + i : i : this._labels[e] + i;
            i = parseInt(e.charAt(a - 1) + "1", 10) * Number(e.substr(a + 1)), e = a > 1 ? this._parseTimeOrLabel(e.substr(0, a - 1), 0, r) : s;
          }
          return Number(e) + i;
        }, m.seek = function (t, e) {
          return this.totalTime("number" === typeof t ? t : this._parseTimeOrLabel(t), !1 !== e);
        }, m.stop = function () {
          return this.paused(!0);
        }, m.gotoAndPlay = function (t, e) {
          return this.play(t, e);
        }, m.gotoAndStop = function (t, e) {
          return this.pause(t, e);
        }, m.render = function (t, e, i) {
          this._gc && this._enabled(!0, !1);

          var r,
              n,
              s,
              a,
              o,
              l,
              f,
              c = this._time,
              _ = this._dirty ? this.totalDuration() : this._totalDuration,
              p = this._startTime,
              d = this._timeScale,
              m = this._paused;

          if (c !== this._time && (t += this._time - c), t >= _ - 1e-7 && t >= 0) this._totalTime = this._time = _, this._reversed || this._hasPausedChild() || (n = !0, a = "onComplete", o = !!this._timeline.autoRemoveChildren, 0 === this._duration && (t <= 0 && t >= -1e-7 || this._rawPrevTime < 0 || 1e-10 === this._rawPrevTime) && this._rawPrevTime !== t && this._first && (o = !0, this._rawPrevTime > 1e-10 && (a = "onReverseComplete"))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : 1e-10, t = _ + 1e-4;else if (t < 1e-7) {
            if (this._totalTime = this._time = 0, (0 !== c || 0 === this._duration && 1e-10 !== this._rawPrevTime && (this._rawPrevTime > 0 || t < 0 && this._rawPrevTime >= 0)) && (a = "onReverseComplete", n = this._reversed), t < 0) this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (o = n = !0, a = "onReverseComplete") : this._rawPrevTime >= 0 && this._first && (o = !0), this._rawPrevTime = t;else {
              if (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : 1e-10, 0 === t && n) for (r = this._first; r && 0 === r._startTime;) {
                r._duration || (n = !1), r = r._next;
              }
              t = 0, this._initted || (o = !0);
            }
          } else {
            if (this._hasPause && !this._forcingPlayhead && !e) {
              if (t >= c) for (r = this._first; r && r._startTime <= t && !l;) {
                r._duration || "isPause" !== r.data || r.ratio || 0 === r._startTime && 0 === this._rawPrevTime || (l = r), r = r._next;
              } else for (r = this._last; r && r._startTime >= t && !l;) {
                r._duration || "isPause" === r.data && r._rawPrevTime > 0 && (l = r), r = r._prev;
              }
              l && (this._time = t = l._startTime, this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay));
            }

            this._totalTime = this._time = this._rawPrevTime = t;
          }

          if (this._time !== c && this._first || i || o || l) {
            if (this._initted || (this._initted = !0), this._active || !this._paused && this._time !== c && t > 0 && (this._active = !0), 0 === c && this.vars.onStart && (0 === this._time && this._duration || e || this._callback("onStart")), (f = this._time) >= c) for (r = this._first; r && (s = r._next, f === this._time && (!this._paused || m));) {
              (r._active || r._startTime <= f && !r._paused && !r._gc) && (l === r && this.pause(), r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i)), r = s;
            } else for (r = this._last; r && (s = r._prev, f === this._time && (!this._paused || m));) {
              if (r._active || r._startTime <= c && !r._paused && !r._gc) {
                if (l === r) {
                  for (l = r._prev; l && l.endTime() > this._time;) {
                    l.render(l._reversed ? l.totalDuration() - (t - l._startTime) * l._timeScale : (t - l._startTime) * l._timeScale, e, i), l = l._prev;
                  }

                  l = null, this.pause();
                }

                r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i);
              }

              r = s;
            }
            this._onUpdate && (e || (h.length && u(), this._callback("onUpdate"))), a && (this._gc || p !== this._startTime && d === this._timeScale || (0 === this._time || _ >= this.totalDuration()) && (n && (h.length && u(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[a] && this._callback(a)));
          }
        }, m._hasPausedChild = function () {
          for (var t = this._first; t;) {
            if (t._paused || t instanceof r && t._hasPausedChild()) return !0;
            t = t._next;
          }

          return !1;
        }, m.getChildren = function (t, e, r, n) {
          n = n || -9999999999;

          for (var s = [], a = this._first, o = 0; a;) {
            a._startTime < n || (a instanceof i ? !1 !== e && (s[o++] = a) : (!1 !== r && (s[o++] = a), !1 !== t && (s = s.concat(a.getChildren(!0, e, r)), o = s.length))), a = a._next;
          }

          return s;
        }, m.getTweensOf = function (t, e) {
          var r,
              n,
              s = this._gc,
              a = [],
              o = 0;

          for (s && this._enabled(!0, !0), r = i.getTweensOf(t), n = r.length; --n > -1;) {
            (r[n].timeline === this || e && this._contains(r[n])) && (a[o++] = r[n]);
          }

          return s && this._enabled(!1, !0), a;
        }, m.recent = function () {
          return this._recent;
        }, m._contains = function (t) {
          for (var e = t.timeline; e;) {
            if (e === this) return !0;
            e = e.timeline;
          }

          return !1;
        }, m.shiftChildren = function (t, e, i) {
          i = i || 0;

          for (var r, n = this._first, s = this._labels; n;) {
            n._startTime >= i && (n._startTime += t), n = n._next;
          }

          if (e) for (r in s) {
            s[r] >= i && (s[r] += t);
          }
          return this._uncache(!0);
        }, m._kill = function (t, e) {
          if (!t && !e) return this._enabled(!1, !1);

          for (var i = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), r = i.length, n = !1; --r > -1;) {
            i[r]._kill(t, e) && (n = !0);
          }

          return n;
        }, m.clear = function (t) {
          var e = this.getChildren(!1, !0, !0),
              i = e.length;

          for (this._time = this._totalTime = 0; --i > -1;) {
            e[i]._enabled(!1, !1);
          }

          return !1 !== t && (this._labels = {}), this._uncache(!0);
        }, m.invalidate = function () {
          for (var e = this._first; e;) {
            e.invalidate(), e = e._next;
          }

          return t.prototype.invalidate.call(this);
        }, m._enabled = function (t, i) {
          if (t === this._gc) for (var r = this._first; r;) {
            r._enabled(t, !0), r = r._next;
          }
          return e.prototype._enabled.call(this, t, i);
        }, m.totalTime = function (e, i, r) {
          this._forcingPlayhead = !0;
          var n = t.prototype.totalTime.apply(this, arguments);
          return this._forcingPlayhead = !1, n;
        }, m.duration = function (t) {
          return arguments.length ? (0 !== this.duration() && 0 !== t && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration);
        }, m.totalDuration = function (t) {
          if (!arguments.length) {
            if (this._dirty) {
              for (var e, i, r = 0, n = this._last, s = 999999999999; n;) {
                e = n._prev, n._dirty && n.totalDuration(), n._startTime > s && this._sortChildren && !n._paused && !this._calculatingDuration ? (this._calculatingDuration = 1, this.add(n, n._startTime - n._delay), this._calculatingDuration = 0) : s = n._startTime, n._startTime < 0 && !n._paused && (r -= n._startTime, this._timeline.smoothChildTiming && (this._startTime += n._startTime / this._timeScale, this._time -= n._startTime, this._totalTime -= n._startTime, this._rawPrevTime -= n._startTime), this.shiftChildren(-n._startTime, !1, -9999999999), s = 0), i = n._startTime + n._totalDuration / n._timeScale, i > r && (r = i), n = e;
              }

              this._duration = this._totalDuration = r, this._dirty = !1;
            }

            return this._totalDuration;
          }

          return t && this.totalDuration() ? this.timeScale(this._totalDuration / t) : this;
        }, m.paused = function (e) {
          if (!e) for (var i = this._first, r = this._time; i;) {
            i._startTime === r && "isPause" === i.data && (i._rawPrevTime = 0), i = i._next;
          }
          return t.prototype.paused.apply(this, arguments);
        }, m.usesFrames = function () {
          for (var e = this._timeline; e._timeline;) {
            e = e._timeline;
          }

          return e === t._rootFramesTimeline;
        }, m.rawTime = function (t) {
          return t && (this._paused || this._repeat && this.time() > 0 && this.totalProgress() < 1) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(t) - this._startTime) * this._timeScale;
        }, r;
      }, !0), s._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function (t, e, i) {
        var r = function r(e) {
          t.call(this, e), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = !0 === this.vars.yoyo, this._dirty = !0;
        },
            n = e._internals,
            a = n.lazyTweens,
            o = n.lazyRender,
            l = s._gsDefine.globals,
            h = new i(null, null, 1, 0),
            u = r.prototype = new t();

        return u.constructor = r, u.kill()._gc = !1, r.version = "1.20.3", u.invalidate = function () {
          return this._yoyo = !0 === this.vars.yoyo, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), t.prototype.invalidate.call(this);
        }, u.addCallback = function (t, i, r, n) {
          return this.add(e.delayedCall(0, t, r, n), i);
        }, u.removeCallback = function (t, e) {
          if (t) if (null == e) this._kill(null, t);else for (var i = this.getTweensOf(t, !1), r = i.length, n = this._parseTimeOrLabel(e); --r > -1;) {
            i[r]._startTime === n && i[r]._enabled(!1, !1);
          }
          return this;
        }, u.removePause = function (e) {
          return this.removeCallback(t._internals.pauseCallback, e);
        }, u.tweenTo = function (t, i) {
          i = i || {};
          var r,
              n,
              s,
              a = {
            ease: h,
            useFrames: this.usesFrames(),
            immediateRender: !1
          },
              o = i.repeat && l.TweenMax || e;

          for (n in i) {
            a[n] = i[n];
          }

          return a.time = this._parseTimeOrLabel(t), r = Math.abs(Number(a.time) - this._time) / this._timeScale || .001, s = new o(this, r, a), a.onStart = function () {
            s.target.paused(!0), s.vars.time !== s.target.time() && r === s.duration() && s.duration(Math.abs(s.vars.time - s.target.time()) / s.target._timeScale), i.onStart && i.onStart.apply(i.onStartScope || i.callbackScope || s, i.onStartParams || []);
          }, s;
        }, u.tweenFromTo = function (t, e, i) {
          i = i || {}, t = this._parseTimeOrLabel(t), i.startAt = {
            onComplete: this.seek,
            onCompleteParams: [t],
            callbackScope: this
          }, i.immediateRender = !1 !== i.immediateRender;
          var r = this.tweenTo(e, i);
          return r.duration(Math.abs(r.vars.time - t) / this._timeScale || .001);
        }, u.render = function (t, e, i) {
          this._gc && this._enabled(!0, !1);
          var r,
              n,
              s,
              l,
              h,
              u,
              f,
              c,
              _ = this._time,
              p = this._dirty ? this.totalDuration() : this._totalDuration,
              d = this._duration,
              m = this._totalTime,
              g = this._startTime,
              y = this._timeScale,
              v = this._rawPrevTime,
              b = this._paused,
              T = this._cycle;
          if (_ !== this._time && (t += this._time - _), t >= p - 1e-7 && t >= 0) this._locked || (this._totalTime = p, this._cycle = this._repeat), this._reversed || this._hasPausedChild() || (n = !0, l = "onComplete", h = !!this._timeline.autoRemoveChildren, 0 === this._duration && (t <= 0 && t >= -1e-7 || v < 0 || 1e-10 === v) && v !== t && this._first && (h = !0, v > 1e-10 && (l = "onReverseComplete"))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : 1e-10, this._yoyo && 0 !== (1 & this._cycle) ? this._time = t = 0 : (this._time = d, t = d + 1e-4);else if (t < 1e-7) {
            if (this._locked || (this._totalTime = this._cycle = 0), this._time = 0, (0 !== _ || 0 === d && 1e-10 !== v && (v > 0 || t < 0 && v >= 0) && !this._locked) && (l = "onReverseComplete", n = this._reversed), t < 0) this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (h = n = !0, l = "onReverseComplete") : v >= 0 && this._first && (h = !0), this._rawPrevTime = t;else {
              if (this._rawPrevTime = d || !e || t || this._rawPrevTime === t ? t : 1e-10, 0 === t && n) for (r = this._first; r && 0 === r._startTime;) {
                r._duration || (n = !1), r = r._next;
              }
              t = 0, this._initted || (h = !0);
            }
          } else if (0 === d && v < 0 && (h = !0), this._time = this._rawPrevTime = t, this._locked || (this._totalTime = t, 0 !== this._repeat && (u = d + this._repeatDelay, this._cycle = this._totalTime / u >> 0, 0 !== this._cycle && this._cycle === this._totalTime / u && m <= t && this._cycle--, this._time = this._totalTime - this._cycle * u, this._yoyo && 0 !== (1 & this._cycle) && (this._time = d - this._time), this._time > d ? (this._time = d, t = d + 1e-4) : this._time < 0 ? this._time = t = 0 : t = this._time)), this._hasPause && !this._forcingPlayhead && !e) {
            if ((t = this._time) >= _ || this._repeat && T !== this._cycle) for (r = this._first; r && r._startTime <= t && !f;) {
              r._duration || "isPause" !== r.data || r.ratio || 0 === r._startTime && 0 === this._rawPrevTime || (f = r), r = r._next;
            } else for (r = this._last; r && r._startTime >= t && !f;) {
              r._duration || "isPause" === r.data && r._rawPrevTime > 0 && (f = r), r = r._prev;
            }
            f && f._startTime < d && (this._time = t = f._startTime, this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay));
          }

          if (this._cycle !== T && !this._locked) {
            var x = this._yoyo && 0 !== (1 & T),
                w = x === (this._yoyo && 0 !== (1 & this._cycle)),
                P = this._totalTime,
                O = this._cycle,
                S = this._rawPrevTime,
                R = this._time;
            if (this._totalTime = T * d, this._cycle < T ? x = !x : this._totalTime += d, this._time = _, this._rawPrevTime = 0 === d ? v - 1e-4 : v, this._cycle = T, this._locked = !0, _ = x ? 0 : d, this.render(_, e, 0 === d), e || this._gc || this.vars.onRepeat && (this._cycle = O, this._locked = !1, this._callback("onRepeat")), _ !== this._time) return;
            if (w && (this._cycle = T, this._locked = !0, _ = x ? d + 1e-4 : -1e-4, this.render(_, !0, !1)), this._locked = !1, this._paused && !b) return;
            this._time = R, this._totalTime = P, this._cycle = O, this._rawPrevTime = S;
          }

          if (!(this._time !== _ && this._first || i || h || f)) return void (m !== this._totalTime && this._onUpdate && (e || this._callback("onUpdate")));
          if (this._initted || (this._initted = !0), this._active || !this._paused && this._totalTime !== m && t > 0 && (this._active = !0), 0 === m && this.vars.onStart && (0 === this._totalTime && this._totalDuration || e || this._callback("onStart")), (c = this._time) >= _) for (r = this._first; r && (s = r._next, c === this._time && (!this._paused || b));) {
            (r._active || r._startTime <= this._time && !r._paused && !r._gc) && (f === r && this.pause(), r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i)), r = s;
          } else for (r = this._last; r && (s = r._prev, c === this._time && (!this._paused || b));) {
            if (r._active || r._startTime <= _ && !r._paused && !r._gc) {
              if (f === r) {
                for (f = r._prev; f && f.endTime() > this._time;) {
                  f.render(f._reversed ? f.totalDuration() - (t - f._startTime) * f._timeScale : (t - f._startTime) * f._timeScale, e, i), f = f._prev;
                }

                f = null, this.pause();
              }

              r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i);
            }

            r = s;
          }
          this._onUpdate && (e || (a.length && o(), this._callback("onUpdate"))), l && (this._locked || this._gc || g !== this._startTime && y === this._timeScale || (0 === this._time || p >= this.totalDuration()) && (n && (a.length && o(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[l] && this._callback(l)));
        }, u.getActive = function (t, e, i) {
          null == t && (t = !0), null == e && (e = !0), null == i && (i = !1);
          var r,
              n,
              s = [],
              a = this.getChildren(t, e, i),
              o = 0,
              l = a.length;

          for (r = 0; r < l; r++) {
            n = a[r], n.isActive() && (s[o++] = n);
          }

          return s;
        }, u.getLabelAfter = function (t) {
          t || 0 !== t && (t = this._time);
          var e,
              i = this.getLabelsArray(),
              r = i.length;

          for (e = 0; e < r; e++) {
            if (i[e].time > t) return i[e].name;
          }

          return null;
        }, u.getLabelBefore = function (t) {
          null == t && (t = this._time);

          for (var e = this.getLabelsArray(), i = e.length; --i > -1;) {
            if (e[i].time < t) return e[i].name;
          }

          return null;
        }, u.getLabelsArray = function () {
          var t,
              e = [],
              i = 0;

          for (t in this._labels) {
            e[i++] = {
              time: this._labels[t],
              name: t
            };
          }

          return e.sort(function (t, e) {
            return t.time - e.time;
          }), e;
        }, u.invalidate = function () {
          return this._locked = !1, t.prototype.invalidate.call(this);
        }, u.progress = function (t, e) {
          return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), e) : this._time / this.duration() || 0;
        }, u.totalProgress = function (t, e) {
          return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this._totalTime / this.totalDuration() || 0;
        }, u.totalDuration = function (e) {
          return arguments.length ? -1 !== this._repeat && e ? this.timeScale(this.totalDuration() / e) : this : (this._dirty && (t.prototype.totalDuration.call(this), this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration);
        }, u.time = function (t, e) {
          return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time;
        }, u.repeat = function (t) {
          return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat;
        }, u.repeatDelay = function (t) {
          return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay;
        }, u.yoyo = function (t) {
          return arguments.length ? (this._yoyo = t, this) : this._yoyo;
        }, u.currentLabel = function (t) {
          return arguments.length ? this.seek(t, !0) : this.getLabelBefore(this._time + 1e-8);
        }, r;
      }, !0), function () {
        var t = 180 / Math.PI,
            e = [],
            i = [],
            r = [],
            n = {},
            a = s._gsDefine.globals,
            o = function o(t, e, i, r) {
          i === r && (i = r - (r - e) / 1e6), t === e && (e = t + (i - t) / 1e6), this.a = t, this.b = e, this.c = i, this.d = r, this.da = r - t, this.ca = i - t, this.ba = e - t;
        },
            l = function l(t, e, i, r) {
          var n = {
            a: t
          },
              s = {},
              a = {},
              o = {
            c: r
          },
              l = (t + e) / 2,
              h = (e + i) / 2,
              u = (i + r) / 2,
              f = (l + h) / 2,
              c = (h + u) / 2,
              _ = (c - f) / 8;

          return n.b = l + (t - l) / 4, s.b = f + _, n.c = s.a = (n.b + s.b) / 2, s.c = a.a = (f + c) / 2, a.b = c - _, o.b = u + (r - u) / 4, a.c = o.a = (a.b + o.b) / 2, [n, s, a, o];
        },
            h = function h(t, n, s, a, o) {
          var h,
              u,
              f,
              c,
              _,
              p,
              d,
              m,
              g,
              y,
              v,
              b,
              T,
              x = t.length - 1,
              w = 0,
              P = t[0].a;

          for (h = 0; h < x; h++) {
            _ = t[w], u = _.a, f = _.d, c = t[w + 1].d, o ? (v = e[h], b = i[h], T = (b + v) * n * .25 / (a ? .5 : r[h] || .5), p = f - (f - u) * (a ? .5 * n : 0 !== v ? T / v : 0), d = f + (c - f) * (a ? .5 * n : 0 !== b ? T / b : 0), m = f - (p + ((d - p) * (3 * v / (v + b) + .5) / 4 || 0))) : (p = f - (f - u) * n * .5, d = f + (c - f) * n * .5, m = f - (p + d) / 2), p += m, d += m, _.c = g = p, _.b = 0 !== h ? P : P = _.a + .6 * (_.c - _.a), _.da = f - u, _.ca = g - u, _.ba = P - u, s ? (y = l(u, P, g, f), t.splice(w, 1, y[0], y[1], y[2], y[3]), w += 4) : w++, P = d;
          }

          _ = t[w], _.b = P, _.c = P + .4 * (_.d - P), _.da = _.d - _.a, _.ca = _.c - _.a, _.ba = P - _.a, s && (y = l(_.a, P, _.c, _.d), t.splice(w, 1, y[0], y[1], y[2], y[3]));
        },
            u = function u(t, r, n, s) {
          var a,
              l,
              h,
              u,
              f,
              c,
              _ = [];
          if (s) for (t = [s].concat(t), l = t.length; --l > -1;) {
            "string" === typeof (c = t[l][r]) && "=" === c.charAt(1) && (t[l][r] = s[r] + Number(c.charAt(0) + c.substr(2)));
          }
          if ((a = t.length - 2) < 0) return _[0] = new o(t[0][r], 0, 0, t[0][r]), _;

          for (l = 0; l < a; l++) {
            h = t[l][r], u = t[l + 1][r], _[l] = new o(h, 0, 0, u), n && (f = t[l + 2][r], e[l] = (e[l] || 0) + (u - h) * (u - h), i[l] = (i[l] || 0) + (f - u) * (f - u));
          }

          return _[l] = new o(t[l][r], 0, 0, t[l + 1][r]), _;
        },
            f = function f(t, s, a, o, l, _f) {
          var c,
              _,
              p,
              d,
              m,
              g,
              y,
              v,
              b = {},
              T = [],
              x = _f || t[0];

          l = "string" === typeof l ? "," + l + "," : ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,", null == s && (s = 1);

          for (_ in t[0]) {
            T.push(_);
          }

          if (t.length > 1) {
            for (v = t[t.length - 1], y = !0, c = T.length; --c > -1;) {
              if (_ = T[c], Math.abs(x[_] - v[_]) > .05) {
                y = !1;
                break;
              }
            }

            y && (t = t.concat(), _f && t.unshift(_f), t.push(t[1]), _f = t[t.length - 3]);
          }

          for (e.length = i.length = r.length = 0, c = T.length; --c > -1;) {
            _ = T[c], n[_] = -1 !== l.indexOf("," + _ + ","), b[_] = u(t, _, n[_], _f);
          }

          for (c = e.length; --c > -1;) {
            e[c] = Math.sqrt(e[c]), i[c] = Math.sqrt(i[c]);
          }

          if (!o) {
            for (c = T.length; --c > -1;) {
              if (n[_]) for (p = b[T[c]], g = p.length - 1, d = 0; d < g; d++) {
                m = p[d + 1].da / i[d] + p[d].da / e[d] || 0, r[d] = (r[d] || 0) + m * m;
              }
            }

            for (c = r.length; --c > -1;) {
              r[c] = Math.sqrt(r[c]);
            }
          }

          for (c = T.length, d = a ? 4 : 1; --c > -1;) {
            _ = T[c], p = b[_], h(p, s, a, o, n[_]), y && (p.splice(0, d), p.splice(p.length - d, d));
          }

          return b;
        },
            c = function c(t, e, i) {
          e = e || "soft";

          var r,
              n,
              s,
              a,
              l,
              h,
              u,
              f,
              c,
              _,
              p,
              d = {},
              m = "cubic" === e ? 3 : 2,
              g = "soft" === e,
              y = [];

          if (g && i && (t = [i].concat(t)), null == t || t.length < m + 1) throw "invalid Bezier data";

          for (c in t[0]) {
            y.push(c);
          }

          for (h = y.length; --h > -1;) {
            for (c = y[h], d[c] = l = [], _ = 0, f = t.length, u = 0; u < f; u++) {
              r = null == i ? t[u][c] : "string" === typeof (p = t[u][c]) && "=" === p.charAt(1) ? i[c] + Number(p.charAt(0) + p.substr(2)) : Number(p), g && u > 1 && u < f - 1 && (l[_++] = (r + l[_ - 2]) / 2), l[_++] = r;
            }

            for (f = _ - m + 1, _ = 0, u = 0; u < f; u += m) {
              r = l[u], n = l[u + 1], s = l[u + 2], a = 2 === m ? 0 : l[u + 3], l[_++] = p = 3 === m ? new o(r, n, s, a) : new o(r, (2 * n + r) / 3, (2 * n + s) / 3, s);
            }

            l.length = _;
          }

          return d;
        },
            _ = function _(t, e, i) {
          for (var r, n, s, a, o, l, h, u, f, c, _, p = 1 / i, d = t.length; --d > -1;) {
            for (c = t[d], s = c.a, a = c.d - s, o = c.c - s, l = c.b - s, r = n = 0, u = 1; u <= i; u++) {
              h = p * u, f = 1 - h, r = n - (n = (h * h * a + 3 * f * (h * o + f * l)) * h), _ = d * i + u - 1, e[_] = (e[_] || 0) + r * r;
            }
          }
        },
            p = function p(t, e) {
          e = e >> 0 || 6;
          var i,
              r,
              n,
              s,
              a = [],
              o = [],
              l = 0,
              h = 0,
              u = e - 1,
              f = [],
              c = [];

          for (i in t) {
            _(t[i], a, e);
          }

          for (n = a.length, r = 0; r < n; r++) {
            l += Math.sqrt(a[r]), s = r % e, c[s] = l, s === u && (h += l, s = r / e >> 0, f[s] = c, o[s] = h, l = 0, c = []);
          }

          return {
            length: h,
            lengths: o,
            segments: f
          };
        },
            d = s._gsDefine.plugin({
          propName: "bezier",
          priority: -1,
          version: "1.3.8",
          API: 2,
          global: !0,
          init: function init(t, e, i) {
            this._target = t, e instanceof Array && (e = {
              values: e
            }), this._func = {}, this._mod = {}, this._props = [], this._timeRes = null == e.timeResolution ? 6 : parseInt(e.timeResolution, 10);

            var r,
                n,
                s,
                a,
                o,
                l = e.values || [],
                h = {},
                u = l[0],
                _ = e.autoRotate || i.vars.orientToBezier;

            this._autoRotate = _ ? _ instanceof Array ? _ : [["x", "y", "rotation", !0 === _ ? 0 : Number(_) || 0]] : null;

            for (r in u) {
              this._props.push(r);
            }

            for (s = this._props.length; --s > -1;) {
              r = this._props[s], this._overwriteProps.push(r), n = this._func[r] = "function" === typeof t[r], h[r] = n ? t[r.indexOf("set") || "function" !== typeof t["get" + r.substr(3)] ? r : "get" + r.substr(3)]() : parseFloat(t[r]), o || h[r] !== l[0][r] && (o = h);
            }

            if (this._beziers = "cubic" !== e.type && "quadratic" !== e.type && "soft" !== e.type ? f(l, isNaN(e.curviness) ? 1 : e.curviness, !1, "thruBasic" === e.type, e.correlate, o) : c(l, e.type, h), this._segCount = this._beziers[r].length, this._timeRes) {
              var d = p(this._beziers, this._timeRes);
              this._length = d.length, this._lengths = d.lengths, this._segments = d.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length;
            }

            if (_ = this._autoRotate) for (this._initialRotations = [], _[0] instanceof Array || (this._autoRotate = _ = [_]), s = _.length; --s > -1;) {
              for (a = 0; a < 3; a++) {
                r = _[s][a], this._func[r] = "function" === typeof t[r] && t[r.indexOf("set") || "function" !== typeof t["get" + r.substr(3)] ? r : "get" + r.substr(3)];
              }

              r = _[s][2], this._initialRotations[s] = (this._func[r] ? this._func[r].call(this._target) : this._target[r]) || 0, this._overwriteProps.push(r);
            }
            return this._startRatio = i.vars.runBackwards ? 1 : 0, !0;
          },
          set: function set(e) {
            var i,
                r,
                n,
                s,
                a,
                o,
                l,
                h,
                u,
                f,
                c = this._segCount,
                _ = this._func,
                p = this._target,
                d = e !== this._startRatio;

            if (this._timeRes) {
              if (u = this._lengths, f = this._curSeg, e *= this._length, n = this._li, e > this._l2 && n < c - 1) {
                for (h = c - 1; n < h && (this._l2 = u[++n]) <= e;) {
                  ;
                }

                this._l1 = u[n - 1], this._li = n, this._curSeg = f = this._segments[n], this._s2 = f[this._s1 = this._si = 0];
              } else if (e < this._l1 && n > 0) {
                for (; n > 0 && (this._l1 = u[--n]) >= e;) {
                  ;
                }

                0 === n && e < this._l1 ? this._l1 = 0 : n++, this._l2 = u[n], this._li = n, this._curSeg = f = this._segments[n], this._s1 = f[(this._si = f.length - 1) - 1] || 0, this._s2 = f[this._si];
              }

              if (i = n, e -= this._l1, n = this._si, e > this._s2 && n < f.length - 1) {
                for (h = f.length - 1; n < h && (this._s2 = f[++n]) <= e;) {
                  ;
                }

                this._s1 = f[n - 1], this._si = n;
              } else if (e < this._s1 && n > 0) {
                for (; n > 0 && (this._s1 = f[--n]) >= e;) {
                  ;
                }

                0 === n && e < this._s1 ? this._s1 = 0 : n++, this._s2 = f[n], this._si = n;
              }

              o = (n + (e - this._s1) / (this._s2 - this._s1)) * this._prec || 0;
            } else i = e < 0 ? 0 : e >= 1 ? c - 1 : c * e >> 0, o = (e - i * (1 / c)) * c;

            for (r = 1 - o, n = this._props.length; --n > -1;) {
              s = this._props[n], a = this._beziers[s][i], l = (o * o * a.da + 3 * r * (o * a.ca + r * a.ba)) * o + a.a, this._mod[s] && (l = this._mod[s](l, p)), _[s] ? p[s](l) : p[s] = l;
            }

            if (this._autoRotate) {
              var m,
                  g,
                  y,
                  v,
                  b,
                  T,
                  x,
                  w = this._autoRotate;

              for (n = w.length; --n > -1;) {
                s = w[n][2], T = w[n][3] || 0, x = !0 === w[n][4] ? 1 : t, a = this._beziers[w[n][0]], m = this._beziers[w[n][1]], a && m && (a = a[i], m = m[i], g = a.a + (a.b - a.a) * o, v = a.b + (a.c - a.b) * o, g += (v - g) * o, v += (a.c + (a.d - a.c) * o - v) * o, y = m.a + (m.b - m.a) * o, b = m.b + (m.c - m.b) * o, y += (b - y) * o, b += (m.c + (m.d - m.c) * o - b) * o, l = d ? Math.atan2(b - y, v - g) * x + T : this._initialRotations[n], this._mod[s] && (l = this._mod[s](l, p)), _[s] ? p[s](l) : p[s] = l);
              }
            }
          }
        }),
            m = d.prototype;

        d.bezierThrough = f, d.cubicToQuadratic = l, d._autoCSS = !0, d.quadraticToCubic = function (t, e, i) {
          return new o(t, (2 * e + t) / 3, (2 * e + i) / 3, i);
        }, d._cssRegister = function () {
          var t = a.CSSPlugin;

          if (t) {
            var e = t._internals,
                i = e._parseToProxy,
                r = e._setPluginRatio,
                n = e.CSSPropTween;

            e._registerComplexSpecialProp("bezier", {
              parser: function parser(t, e, s, a, o, l) {
                e instanceof Array && (e = {
                  values: e
                }), l = new d();

                var h,
                    u,
                    f,
                    c = e.values,
                    _ = c.length - 1,
                    p = [],
                    m = {};

                if (_ < 0) return o;

                for (h = 0; h <= _; h++) {
                  f = i(t, c[h], a, o, l, _ !== h), p[h] = f.end;
                }

                for (u in e) {
                  m[u] = e[u];
                }

                return m.values = p, o = new n(t, "bezier", 0, 0, f.pt, 2), o.data = f, o.plugin = l, o.setRatio = r, 0 === m.autoRotate && (m.autoRotate = !0), !m.autoRotate || m.autoRotate instanceof Array || (h = !0 === m.autoRotate ? 0 : Number(m.autoRotate), m.autoRotate = null != f.end.left ? [["left", "top", "rotation", h, !1]] : null != f.end.x && [["x", "y", "rotation", h, !1]]), m.autoRotate && (a._transform || a._enableTransforms(!1), f.autoRotate = a._target._gsTransform, f.proxy.rotation = f.autoRotate.rotation || 0, a._overwriteProps.push("rotation")), l._onInitTween(f.proxy, m, a._tween), o;
              }
            });
          }
        }, m._mod = function (t) {
          for (var e, i = this._overwriteProps, r = i.length; --r > -1;) {
            (e = t[i[r]]) && "function" === typeof e && (this._mod[i[r]] = e);
          }
        }, m._kill = function (t) {
          var e,
              i,
              r = this._props;

          for (e in this._beziers) {
            if (e in t) for (delete this._beziers[e], delete this._func[e], i = r.length; --i > -1;) {
              r[i] === e && r.splice(i, 1);
            }
          }

          if (r = this._autoRotate) for (i = r.length; --i > -1;) {
            t[r[i][2]] && r.splice(i, 1);
          }
          return this._super._kill.call(this, t);
        };
      }(), s._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function (t, e) {
        var i,
            r,
            n,
            a,
            o = function o() {
          t.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = o.prototype.setRatio;
        },
            l = s._gsDefine.globals,
            h = {},
            u = o.prototype = new t("css");

        u.constructor = o, o.version = "1.20.3", o.API = 2, o.defaultTransformPerspective = 0, o.defaultSkewType = "compensated", o.defaultSmoothOrigin = !0, u = "px", o.suffixMap = {
          top: u,
          right: u,
          bottom: u,
          left: u,
          width: u,
          height: u,
          fontSize: u,
          padding: u,
          margin: u,
          perspective: u,
          lineHeight: ""
        };

        var f,
            c,
            _,
            p,
            d,
            m,
            g,
            y,
            v = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
            b = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
            T = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
            x = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
            w = /(?:\d|\-|\+|=|#|\.)*/g,
            P = /opacity *= *([^)]*)/i,
            O = /opacity:([^;]*)/i,
            S = /alpha\(opacity *=.+?\)/i,
            R = /^(rgb|hsl)/,
            A = /([A-Z])/g,
            k = /-([a-z])/gi,
            C = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
            D = function D(t, e) {
          return e.toUpperCase();
        },
            E = /(?:Left|Right|Width)/i,
            M = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
            F = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
            L = /,(?=[^\)]*(?:\(|$))/gi,
            j = /[\s,\(]/i,
            I = Math.PI / 180,
            N = 180 / Math.PI,
            z = {},
            B = {
          style: {}
        },
            X = s.document || {
          createElement: function createElement() {
            return B;
          }
        },
            U = function U(t, e) {
          return X.createElementNS ? X.createElementNS(e || "http://www.w3.org/1999/xhtml", t) : X.createElement(t);
        },
            Y = U("div"),
            q = U("img"),
            V = o._internals = {
          _specialProps: h
        },
            W = (s.navigator || {}).userAgent || "",
            H = function () {
          var t = W.indexOf("Android"),
              e = U("a");
          return _ = -1 !== W.indexOf("Safari") && -1 === W.indexOf("Chrome") && (-1 === t || parseFloat(W.substr(t + 8, 2)) > 3), d = _ && parseFloat(W.substr(W.indexOf("Version/") + 8, 2)) < 6, p = -1 !== W.indexOf("Firefox"), (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(W) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(W)) && (m = parseFloat(RegExp.$1)), !!e && (e.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(e.style.opacity));
        }(),
            G = function G(t) {
          return P.test("string" === typeof t ? t : (t.currentStyle ? t.currentStyle.filter : t.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
        },
            Z = function Z(t) {
          s.console && console.log(t);
        },
            $ = "",
            Q = "",
            K = function K(t, e) {
          e = e || Y;
          var i,
              r,
              n = e.style;
          if (void 0 !== n[t]) return t;

          for (t = t.charAt(0).toUpperCase() + t.substr(1), i = ["O", "Moz", "ms", "Ms", "Webkit"], r = 5; --r > -1 && void 0 === n[i[r] + t];) {
            ;
          }

          return r >= 0 ? (Q = 3 === r ? "ms" : i[r], $ = "-" + Q.toLowerCase() + "-", Q + t) : null;
        },
            J = X.defaultView ? X.defaultView.getComputedStyle : function () {},
            tt = o.getStyle = function (t, e, i, r, n) {
          var s;
          return H || "opacity" !== e ? (!r && t.style[e] ? s = t.style[e] : (i = i || J(t)) ? s = i[e] || i.getPropertyValue(e) || i.getPropertyValue(e.replace(A, "-$1").toLowerCase()) : t.currentStyle && (s = t.currentStyle[e]), null == n || s && "none" !== s && "auto" !== s && "auto auto" !== s ? s : n) : G(t);
        },
            et = V.convertToPixels = function (t, i, r, n, s) {
          if ("px" === n || !n && "lineHeight" !== i) return r;
          if ("auto" === n || !r) return 0;

          var a,
              l,
              h,
              u = E.test(i),
              f = t,
              c = Y.style,
              _ = r < 0,
              p = 1 === r;

          if (_ && (r = -r), p && (r *= 100), "lineHeight" !== i || n) {
            if ("%" === n && -1 !== i.indexOf("border")) a = r / 100 * (u ? t.clientWidth : t.clientHeight);else {
              if (c.cssText = "border:0 solid red;position:" + tt(t, "position") + ";line-height:0;", "%" !== n && f.appendChild && "v" !== n.charAt(0) && "rem" !== n) c[u ? "borderLeftWidth" : "borderTopWidth"] = r + n;else {
                if (f = t.parentNode || X.body, -1 !== tt(f, "display").indexOf("flex") && (c.position = "absolute"), l = f._gsCache, h = e.ticker.frame, l && u && l.time === h) return l.width * r / 100;
                c[u ? "width" : "height"] = r + n;
              }
              f.appendChild(Y), a = parseFloat(Y[u ? "offsetWidth" : "offsetHeight"]), f.removeChild(Y), u && "%" === n && !1 !== o.cacheWidths && (l = f._gsCache = f._gsCache || {}, l.time = h, l.width = a / r * 100), 0 !== a || s || (a = et(t, i, r, n, !0));
            }
          } else l = J(t).lineHeight, t.style.lineHeight = r, a = parseFloat(J(t).lineHeight), t.style.lineHeight = l;
          return p && (a /= 100), _ ? -a : a;
        },
            it = V.calculateOffset = function (t, e, i) {
          if ("absolute" !== tt(t, "position", i)) return 0;
          var r = "left" === e ? "Left" : "Top",
              n = tt(t, "margin" + r, i);
          return t["offset" + r] - (et(t, e, parseFloat(n), n.replace(w, "")) || 0);
        },
            rt = function rt(t, e) {
          var i,
              r,
              n,
              s = {};
          if (e = e || J(t, null)) {
            if (i = e.length) for (; --i > -1;) {
              n = e[i], -1 !== n.indexOf("-transform") && Ct !== n || (s[n.replace(k, D)] = e.getPropertyValue(n));
            } else for (i in e) {
              -1 !== i.indexOf("Transform") && kt !== i || (s[i] = e[i]);
            }
          } else if (e = t.currentStyle || t.style) for (i in e) {
            "string" === typeof i && void 0 === s[i] && (s[i.replace(k, D)] = e[i]);
          }
          return H || (s.opacity = G(t)), r = qt(t, e, !1), s.rotation = r.rotation, s.skewX = r.skewX, s.scaleX = r.scaleX, s.scaleY = r.scaleY, s.x = r.x, s.y = r.y, Et && (s.z = r.z, s.rotationX = r.rotationX, s.rotationY = r.rotationY, s.scaleZ = r.scaleZ), s.filters && delete s.filters, s;
        },
            nt = function nt(t, e, i, r, n) {
          var s,
              a,
              o,
              l = {},
              h = t.style;

          for (a in i) {
            "cssText" !== a && "length" !== a && isNaN(a) && (e[a] !== (s = i[a]) || n && n[a]) && -1 === a.indexOf("Origin") && ("number" !== typeof s && "string" !== typeof s || (l[a] = "auto" !== s || "left" !== a && "top" !== a ? "" !== s && "auto" !== s && "none" !== s || "string" !== typeof e[a] || "" === e[a].replace(x, "") ? s : 0 : it(t, a), void 0 !== h[a] && (o = new vt(h, a, h[a], o))));
          }

          if (r) for (a in r) {
            "className" !== a && (l[a] = r[a]);
          }
          return {
            difs: l,
            firstMPT: o
          };
        },
            st = {
          width: ["Left", "Right"],
          height: ["Top", "Bottom"]
        },
            at = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
            ot = function ot(t, e, i) {
          if ("svg" === (t.nodeName + "").toLowerCase()) return (i || J(t))[e] || 0;
          if (t.getCTM && Xt(t)) return t.getBBox()[e] || 0;
          var r = parseFloat("width" === e ? t.offsetWidth : t.offsetHeight),
              n = st[e],
              s = n.length;

          for (i = i || J(t, null); --s > -1;) {
            r -= parseFloat(tt(t, "padding" + n[s], i, !0)) || 0, r -= parseFloat(tt(t, "border" + n[s] + "Width", i, !0)) || 0;
          }

          return r;
        },
            lt = function lt(t, e) {
          if ("contain" === t || "auto" === t || "auto auto" === t) return t + " ";
          null != t && "" !== t || (t = "0 0");
          var i,
              r = t.split(" "),
              n = -1 !== t.indexOf("left") ? "0%" : -1 !== t.indexOf("right") ? "100%" : r[0],
              s = -1 !== t.indexOf("top") ? "0%" : -1 !== t.indexOf("bottom") ? "100%" : r[1];

          if (r.length > 3 && !e) {
            for (r = t.split(", ").join(",").split(","), t = [], i = 0; i < r.length; i++) {
              t.push(lt(r[i]));
            }

            return t.join(",");
          }

          return null == s ? s = "center" === n ? "50%" : "0" : "center" === s && (s = "50%"), ("center" === n || isNaN(parseFloat(n)) && -1 === (n + "").indexOf("=")) && (n = "50%"), t = n + " " + s + (r.length > 2 ? " " + r[2] : ""), e && (e.oxp = -1 !== n.indexOf("%"), e.oyp = -1 !== s.indexOf("%"), e.oxr = "=" === n.charAt(1), e.oyr = "=" === s.charAt(1), e.ox = parseFloat(n.replace(x, "")), e.oy = parseFloat(s.replace(x, "")), e.v = t), e || t;
        },
            ht = function ht(t, e) {
          return "function" === typeof t && (t = t(y, g)), "string" === typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e) || 0;
        },
            ut = function ut(t, e) {
          return "function" === typeof t && (t = t(y, g)), null == t ? e : "string" === typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) + e : parseFloat(t) || 0;
        },
            ft = function ft(t, e, i, r) {
          var n, s, a, o, l;
          return "function" === typeof t && (t = t(y, g)), null == t ? o = e : "number" === typeof t ? o = t : (n = 360, s = t.split("_"), l = "=" === t.charAt(1), a = (l ? parseInt(t.charAt(0) + "1", 10) * parseFloat(s[0].substr(2)) : parseFloat(s[0])) * (-1 === t.indexOf("rad") ? 1 : N) - (l ? 0 : e), s.length && (r && (r[i] = e + a), -1 !== t.indexOf("short") && (a %= n) !== a % (n / 2) && (a = a < 0 ? a + n : a - n), -1 !== t.indexOf("_cw") && a < 0 ? a = (a + 9999999999 * n) % n - (a / n | 0) * n : -1 !== t.indexOf("ccw") && a > 0 && (a = (a - 9999999999 * n) % n - (a / n | 0) * n)), o = e + a), o < 1e-6 && o > -1e-6 && (o = 0), o;
        },
            ct = {
          aqua: [0, 255, 255],
          lime: [0, 255, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, 255],
          navy: [0, 0, 128],
          white: [255, 255, 255],
          fuchsia: [255, 0, 255],
          olive: [128, 128, 0],
          yellow: [255, 255, 0],
          orange: [255, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [255, 0, 0],
          pink: [255, 192, 203],
          cyan: [0, 255, 255],
          transparent: [255, 255, 255, 0]
        },
            _t = function _t(t, e, i) {
          return t = t < 0 ? t + 1 : t > 1 ? t - 1 : t, 255 * (6 * t < 1 ? e + (i - e) * t * 6 : t < .5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) + .5 | 0;
        },
            pt = o.parseColor = function (t, e) {
          var i, r, n, s, a, o, l, h, u, f, c;
          if (t) {
            if ("number" === typeof t) i = [t >> 16, t >> 8 & 255, 255 & t];else {
              if ("," === t.charAt(t.length - 1) && (t = t.substr(0, t.length - 1)), ct[t]) i = ct[t];else if ("#" === t.charAt(0)) 4 === t.length && (r = t.charAt(1), n = t.charAt(2), s = t.charAt(3), t = "#" + r + r + n + n + s + s), t = parseInt(t.substr(1), 16), i = [t >> 16, t >> 8 & 255, 255 & t];else if ("hsl" === t.substr(0, 3)) {
                if (i = c = t.match(v), e) {
                  if (-1 !== t.indexOf("=")) return t.match(b);
                } else a = Number(i[0]) % 360 / 360, o = Number(i[1]) / 100, l = Number(i[2]) / 100, n = l <= .5 ? l * (o + 1) : l + o - l * o, r = 2 * l - n, i.length > 3 && (i[3] = Number(i[3])), i[0] = _t(a + 1 / 3, r, n), i[1] = _t(a, r, n), i[2] = _t(a - 1 / 3, r, n);
              } else i = t.match(v) || ct.transparent;
              i[0] = Number(i[0]), i[1] = Number(i[1]), i[2] = Number(i[2]), i.length > 3 && (i[3] = Number(i[3]));
            }
          } else i = ct.black;
          return e && !c && (r = i[0] / 255, n = i[1] / 255, s = i[2] / 255, h = Math.max(r, n, s), u = Math.min(r, n, s), l = (h + u) / 2, h === u ? a = o = 0 : (f = h - u, o = l > .5 ? f / (2 - h - u) : f / (h + u), a = h === r ? (n - s) / f + (n < s ? 6 : 0) : h === n ? (s - r) / f + 2 : (r - n) / f + 4, a *= 60), i[0] = a + .5 | 0, i[1] = 100 * o + .5 | 0, i[2] = 100 * l + .5 | 0), i;
        },
            dt = function dt(t, e) {
          var i,
              r,
              n,
              s = t.match(mt) || [],
              a = 0,
              o = "";
          if (!s.length) return t;

          for (i = 0; i < s.length; i++) {
            r = s[i], n = t.substr(a, t.indexOf(r, a) - a), a += n.length + r.length, r = pt(r, e), 3 === r.length && r.push(1), o += n + (e ? "hsla(" + r[0] + "," + r[1] + "%," + r[2] + "%," + r[3] : "rgba(" + r.join(",")) + ")";
          }

          return o + t.substr(a);
        },
            mt = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";

        for (u in ct) {
          mt += "|" + u + "\\b";
        }

        mt = new RegExp(mt + ")", "gi"), o.colorStringFilter = function (t) {
          var e,
              i = t[0] + " " + t[1];
          mt.test(i) && (e = -1 !== i.indexOf("hsl(") || -1 !== i.indexOf("hsla("), t[0] = dt(t[0], e), t[1] = dt(t[1], e)), mt.lastIndex = 0;
        }, e.defaultStringFilter || (e.defaultStringFilter = o.colorStringFilter);

        var gt = function gt(t, e, i, r) {
          if (null == t) return function (t) {
            return t;
          };
          var n,
              s = e ? (t.match(mt) || [""])[0] : "",
              a = t.split(s).join("").match(T) || [],
              o = t.substr(0, t.indexOf(a[0])),
              l = ")" === t.charAt(t.length - 1) ? ")" : "",
              h = -1 !== t.indexOf(" ") ? " " : ",",
              u = a.length,
              f = u > 0 ? a[0].replace(v, "") : "";
          return u ? n = e ? function (t) {
            var e, c, _, p;

            if ("number" === typeof t) t += f;else if (r && L.test(t)) {
              for (p = t.replace(L, "|").split("|"), _ = 0; _ < p.length; _++) {
                p[_] = n(p[_]);
              }

              return p.join(",");
            }
            if (e = (t.match(mt) || [s])[0], c = t.split(e).join("").match(T) || [], _ = c.length, u > _--) for (; ++_ < u;) {
              c[_] = i ? c[(_ - 1) / 2 | 0] : a[_];
            }
            return o + c.join(h) + h + e + l + (-1 !== t.indexOf("inset") ? " inset" : "");
          } : function (t) {
            var e, s, c;
            if ("number" === typeof t) t += f;else if (r && L.test(t)) {
              for (s = t.replace(L, "|").split("|"), c = 0; c < s.length; c++) {
                s[c] = n(s[c]);
              }

              return s.join(",");
            }
            if (e = t.match(T) || [], c = e.length, u > c--) for (; ++c < u;) {
              e[c] = i ? e[(c - 1) / 2 | 0] : a[c];
            }
            return o + e.join(h) + l;
          } : function (t) {
            return t;
          };
        },
            yt = function yt(t) {
          return t = t.split(","), function (e, i, r, n, s, a, o) {
            var l,
                h = (i + "").split(" ");

            for (o = {}, l = 0; l < 4; l++) {
              o[t[l]] = h[l] = h[l] || h[(l - 1) / 2 >> 0];
            }

            return n.parse(e, o, s, a);
          };
        },
            vt = (V._setPluginRatio = function (t) {
          this.plugin.setRatio(t);

          for (var e, i, r, n, s, a = this.data, o = a.proxy, l = a.firstMPT; l;) {
            e = o[l.v], l.r ? e = Math.round(e) : e < 1e-6 && e > -1e-6 && (e = 0), l.t[l.p] = e, l = l._next;
          }

          if (a.autoRotate && (a.autoRotate.rotation = a.mod ? a.mod(o.rotation, this.t) : o.rotation), 1 === t || 0 === t) for (l = a.firstMPT, s = 1 === t ? "e" : "b"; l;) {
            if (i = l.t, i.type) {
              if (1 === i.type) {
                for (n = i.xs0 + i.s + i.xs1, r = 1; r < i.l; r++) {
                  n += i["xn" + r] + i["xs" + (r + 1)];
                }

                i[s] = n;
              }
            } else i[s] = i.s + i.xs0;

            l = l._next;
          }
        }, function (t, e, i, r, n) {
          this.t = t, this.p = e, this.v = i, this.r = n, r && (r._prev = this, this._next = r);
        }),
            bt = (V._parseToProxy = function (t, e, i, r, n, s) {
          var a,
              o,
              l,
              h,
              u,
              f = r,
              c = {},
              _ = {},
              p = i._transform,
              d = z;

          for (i._transform = null, z = e, r = u = i.parse(t, e, r, n), z = d, s && (i._transform = p, f && (f._prev = null, f._prev && (f._prev._next = null))); r && r !== f;) {
            if (r.type <= 1 && (o = r.p, _[o] = r.s + r.c, c[o] = r.s, s || (h = new vt(r, "s", o, h, r.r), r.c = 0), 1 === r.type)) for (a = r.l; --a > 0;) {
              l = "xn" + a, o = r.p + "_" + l, _[o] = r.data[l], c[o] = r[l], s || (h = new vt(r, l, o, h, r.rxp[l]));
            }
            r = r._next;
          }

          return {
            proxy: c,
            end: _,
            firstMPT: h,
            pt: u
          };
        }, V.CSSPropTween = function (t, e, r, n, s, o, l, h, u, f, c) {
          this.t = t, this.p = e, this.s = r, this.c = n, this.n = l || e, t instanceof bt || a.push(this.n), this.r = h, this.type = o || 0, u && (this.pr = u, i = !0), this.b = void 0 === f ? r : f, this.e = void 0 === c ? r + n : c, s && (this._next = s, s._prev = this);
        }),
            Tt = function Tt(t, e, i, r, n, s) {
          var a = new bt(t, e, i, r - i, n, -1, s);
          return a.b = i, a.e = a.xs0 = r, a;
        },
            xt = o.parseComplex = function (t, e, i, r, n, s, a, l, h, u) {
          i = i || s || "", "function" === typeof r && (r = r(y, g)), a = new bt(t, e, 0, 0, a, u ? 2 : 1, null, !1, l, i, r), r += "", n && mt.test(r + i) && (r = [i, r], o.colorStringFilter(r), i = r[0], r = r[1]);

          var c,
              _,
              p,
              d,
              m,
              T,
              x,
              w,
              P,
              O,
              S,
              R,
              A,
              k = i.split(", ").join(",").split(" "),
              C = r.split(", ").join(",").split(" "),
              D = k.length,
              E = !1 !== f;

          for (-1 === r.indexOf(",") && -1 === i.indexOf(",") || (-1 !== (r + i).indexOf("rgb") || -1 !== (r + i).indexOf("hsl") ? (k = k.join(" ").replace(L, ", ").split(" "), C = C.join(" ").replace(L, ", ").split(" ")) : (k = k.join(" ").split(",").join(", ").split(" "), C = C.join(" ").split(",").join(", ").split(" ")), D = k.length), D !== C.length && (k = (s || "").split(" "), D = k.length), a.plugin = h, a.setRatio = u, mt.lastIndex = 0, c = 0; c < D; c++) {
            if (d = k[c], m = C[c], (w = parseFloat(d)) || 0 === w) a.appendXtra("", w, ht(m, w), m.replace(b, ""), E && -1 !== m.indexOf("px"), !0);else if (n && mt.test(d)) R = m.indexOf(")") + 1, R = ")" + (R ? m.substr(R) : ""), A = -1 !== m.indexOf("hsl") && H, O = m, d = pt(d, A), m = pt(m, A), P = d.length + m.length > 6, P && !H && 0 === m[3] ? (a["xs" + a.l] += a.l ? " transparent" : "transparent", a.e = a.e.split(C[c]).join("transparent")) : (H || (P = !1), A ? a.appendXtra(O.substr(0, O.indexOf("hsl")) + (P ? "hsla(" : "hsl("), d[0], ht(m[0], d[0]), ",", !1, !0).appendXtra("", d[1], ht(m[1], d[1]), "%,", !1).appendXtra("", d[2], ht(m[2], d[2]), P ? "%," : "%" + R, !1) : a.appendXtra(O.substr(0, O.indexOf("rgb")) + (P ? "rgba(" : "rgb("), d[0], m[0] - d[0], ",", !0, !0).appendXtra("", d[1], m[1] - d[1], ",", !0).appendXtra("", d[2], m[2] - d[2], P ? "," : R, !0), P && (d = d.length < 4 ? 1 : d[3], a.appendXtra("", d, (m.length < 4 ? 1 : m[3]) - d, R, !1))), mt.lastIndex = 0;else if (T = d.match(v)) {
              if (!(x = m.match(b)) || x.length !== T.length) return a;

              for (p = 0, _ = 0; _ < T.length; _++) {
                S = T[_], O = d.indexOf(S, p), a.appendXtra(d.substr(p, O - p), Number(S), ht(x[_], S), "", E && "px" === d.substr(O + S.length, 2), 0 === _), p = O + S.length;
              }

              a["xs" + a.l] += d.substr(p);
            } else a["xs" + a.l] += a.l || a["xs" + a.l] ? " " + m : m;
          }

          if (-1 !== r.indexOf("=") && a.data) {
            for (R = a.xs0 + a.data.s, c = 1; c < a.l; c++) {
              R += a["xs" + c] + a.data["xn" + c];
            }

            a.e = R + a["xs" + c];
          }

          return a.l || (a.type = -1, a.xs0 = a.e), a.xfirst || a;
        },
            wt = 9;

        for (u = bt.prototype, u.l = u.pr = 0; --wt > 0;) {
          u["xn" + wt] = 0, u["xs" + wt] = "";
        }

        u.xs0 = "", u._next = u._prev = u.xfirst = u.data = u.plugin = u.setRatio = u.rxp = null, u.appendXtra = function (t, e, i, r, n, s) {
          var a = this,
              o = a.l;
          return a["xs" + o] += s && (o || a["xs" + o]) ? " " + t : t || "", i || 0 === o || a.plugin ? (a.l++, a.type = a.setRatio ? 2 : 1, a["xs" + a.l] = r || "", o > 0 ? (a.data["xn" + o] = e + i, a.rxp["xn" + o] = n, a["xn" + o] = e, a.plugin || (a.xfirst = new bt(a, "xn" + o, e, i, a.xfirst || a, 0, a.n, n, a.pr), a.xfirst.xs0 = 0), a) : (a.data = {
            s: e + i
          }, a.rxp = {}, a.s = e, a.c = i, a.r = n, a)) : (a["xs" + o] += e + (r || ""), a);
        };

        var Pt = function Pt(t, e) {
          e = e || {}, this.p = e.prefix ? K(t) || t : t, h[t] = h[this.p] = this, this.format = e.formatter || gt(e.defaultValue, e.color, e.collapsible, e.multi), e.parser && (this.parse = e.parser), this.clrs = e.color, this.multi = e.multi, this.keyword = e.keyword, this.dflt = e.defaultValue, this.pr = e.priority || 0;
        },
            Ot = V._registerComplexSpecialProp = function (t, e, i) {
          "object" !== typeof e && (e = {
            parser: i
          });
          var r,
              n = t.split(","),
              s = e.defaultValue;

          for (i = i || [s], r = 0; r < n.length; r++) {
            e.prefix = 0 === r && e.prefix, e.defaultValue = i[r] || s, new Pt(n[r], e);
          }
        },
            St = V._registerPluginProp = function (t) {
          if (!h[t]) {
            var e = t.charAt(0).toUpperCase() + t.substr(1) + "Plugin";
            Ot(t, {
              parser: function parser(t, i, r, n, s, a, o) {
                var u = l.com.greensock.plugins[e];
                return u ? (u._cssRegister(), h[r].parse(t, i, r, n, s, a, o)) : (Z("Error: " + e + " js file not loaded."), s);
              }
            });
          }
        };

        u = Pt.prototype, u.parseComplex = function (t, e, i, r, n, s) {
          var a,
              o,
              l,
              h,
              u,
              f,
              c = this.keyword;

          if (this.multi && (L.test(i) || L.test(e) ? (o = e.replace(L, "|").split("|"), l = i.replace(L, "|").split("|")) : c && (o = [e], l = [i])), l) {
            for (h = l.length > o.length ? l.length : o.length, a = 0; a < h; a++) {
              e = o[a] = o[a] || this.dflt, i = l[a] = l[a] || this.dflt, c && (u = e.indexOf(c), f = i.indexOf(c), u !== f && (-1 === f ? o[a] = o[a].split(c).join("") : -1 === u && (o[a] += " " + c)));
            }

            e = o.join(", "), i = l.join(", ");
          }

          return xt(t, this.p, e, i, this.clrs, this.dflt, r, this.pr, n, s);
        }, u.parse = function (t, e, i, r, s, a, o) {
          return this.parseComplex(t.style, this.format(tt(t, this.p, n, !1, this.dflt)), this.format(e), s, a);
        }, o.registerSpecialProp = function (t, e, i) {
          Ot(t, {
            parser: function parser(t, r, n, s, a, o, l) {
              var h = new bt(t, n, 0, 0, a, 2, n, !1, i);
              return h.plugin = o, h.setRatio = e(t, r, s._tween, n), h;
            },
            priority: i
          });
        }, o.useSVGTransformAttr = !0;

        var Rt,
            At = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
            kt = K("transform"),
            Ct = $ + "transform",
            Dt = K("transformOrigin"),
            Et = null !== K("perspective"),
            Mt = V.Transform = function () {
          this.perspective = parseFloat(o.defaultTransformPerspective) || 0, this.force3D = !(!1 === o.defaultForce3D || !Et) && (o.defaultForce3D || "auto");
        },
            Ft = s.SVGElement,
            Lt = function Lt(t, e, i) {
          var r,
              n = X.createElementNS("http://www.w3.org/2000/svg", t),
              s = /([a-z])([A-Z])/g;

          for (r in i) {
            n.setAttributeNS(null, r.replace(s, "$1-$2").toLowerCase(), i[r]);
          }

          return e.appendChild(n), n;
        },
            jt = X.documentElement || {},
            It = function () {
          var t,
              e,
              i,
              r = m || /Android/i.test(W) && !s.chrome;
          return X.createElementNS && !r && (t = Lt("svg", jt), e = Lt("rect", t, {
            width: 100,
            height: 50,
            x: 100
          }), i = e.getBoundingClientRect().width, e.style[Dt] = "50% 50%", e.style[kt] = "scaleX(0.5)", r = i === e.getBoundingClientRect().width && !(p && Et), jt.removeChild(t)), r;
        }(),
            Nt = function Nt(t, e, i, r, n, s) {
          var a,
              l,
              h,
              u,
              f,
              c,
              _,
              p,
              d,
              m,
              g,
              y,
              v,
              b,
              T = t._gsTransform,
              x = Yt(t, !0);

          T && (v = T.xOrigin, b = T.yOrigin), (!r || (a = r.split(" ")).length < 2) && (_ = t.getBBox(), 0 === _.x && 0 === _.y && _.width + _.height === 0 && (_ = {
            x: parseFloat(t.hasAttribute("x") ? t.getAttribute("x") : t.hasAttribute("cx") ? t.getAttribute("cx") : 0) || 0,
            y: parseFloat(t.hasAttribute("y") ? t.getAttribute("y") : t.hasAttribute("cy") ? t.getAttribute("cy") : 0) || 0,
            width: 0,
            height: 0
          }), e = lt(e).split(" "), a = [(-1 !== e[0].indexOf("%") ? parseFloat(e[0]) / 100 * _.width : parseFloat(e[0])) + _.x, (-1 !== e[1].indexOf("%") ? parseFloat(e[1]) / 100 * _.height : parseFloat(e[1])) + _.y]), i.xOrigin = u = parseFloat(a[0]), i.yOrigin = f = parseFloat(a[1]), r && x !== Ut && (c = x[0], _ = x[1], p = x[2], d = x[3], m = x[4], g = x[5], (y = c * d - _ * p) && (l = u * (d / y) + f * (-p / y) + (p * g - d * m) / y, h = u * (-_ / y) + f * (c / y) - (c * g - _ * m) / y, u = i.xOrigin = a[0] = l, f = i.yOrigin = a[1] = h)), T && (s && (i.xOffset = T.xOffset, i.yOffset = T.yOffset, T = i), n || !1 !== n && !1 !== o.defaultSmoothOrigin ? (l = u - v, h = f - b, T.xOffset += l * x[0] + h * x[2] - l, T.yOffset += l * x[1] + h * x[3] - h) : T.xOffset = T.yOffset = 0), s || t.setAttribute("data-svg-origin", a.join(" "));
        },
            zt = function zt(t) {
          var e,
              i = U("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
              r = this.parentNode,
              n = this.nextSibling,
              s = this.style.cssText;
          if (jt.appendChild(i), i.appendChild(this), this.style.display = "block", t) try {
            e = this.getBBox(), this._originalGetBBox = this.getBBox, this.getBBox = zt;
          } catch (t) {} else this._originalGetBBox && (e = this._originalGetBBox());
          return n ? r.insertBefore(this, n) : r.appendChild(this), jt.removeChild(i), this.style.cssText = s, e;
        },
            Bt = function Bt(t) {
          try {
            return t.getBBox();
          } catch (e) {
            return zt.call(t, !0);
          }
        },
            Xt = function Xt(t) {
          return !(!Ft || !t.getCTM || t.parentNode && !t.ownerSVGElement || !Bt(t));
        },
            Ut = [1, 0, 0, 1, 0, 0],
            Yt = function Yt(t, e) {
          var i,
              r,
              n,
              s,
              a,
              o,
              l = t._gsTransform || new Mt(),
              h = t.style;
          if (kt ? r = tt(t, Ct, null, !0) : t.currentStyle && (r = t.currentStyle.filter.match(M), r = r && 4 === r.length ? [r[0].substr(4), Number(r[2].substr(4)), Number(r[1].substr(4)), r[3].substr(4), l.x || 0, l.y || 0].join(",") : ""), i = !r || "none" === r || "matrix(1, 0, 0, 1, 0, 0)" === r, !kt || !(o = !J(t) || "none" === J(t).display) && t.parentNode || (o && (s = h.display, h.display = "block"), t.parentNode || (a = 1, jt.appendChild(t)), r = tt(t, Ct, null, !0), i = !r || "none" === r || "matrix(1, 0, 0, 1, 0, 0)" === r, s ? h.display = s : o && Gt(h, "display"), a && jt.removeChild(t)), (l.svg || t.getCTM && Xt(t)) && (i && -1 !== (h[kt] + "").indexOf("matrix") && (r = h[kt], i = 0), n = t.getAttribute("transform"), i && n && (-1 !== n.indexOf("matrix") ? (r = n, i = 0) : -1 !== n.indexOf("translate") && (r = "matrix(1,0,0,1," + n.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")", i = 0))), i) return Ut;

          for (n = (r || "").match(v) || [], wt = n.length; --wt > -1;) {
            s = Number(n[wt]), n[wt] = (a = s - (s |= 0)) ? (1e5 * a + (a < 0 ? -.5 : .5) | 0) / 1e5 + s : s;
          }

          return e && n.length > 6 ? [n[0], n[1], n[4], n[5], n[12], n[13]] : n;
        },
            qt = V.getTransform = function (t, i, r, n) {
          if (t._gsTransform && r && !n) return t._gsTransform;

          var s,
              a,
              l,
              h,
              u,
              f,
              c = r ? t._gsTransform || new Mt() : new Mt(),
              _ = c.scaleX < 0,
              p = Et ? parseFloat(tt(t, Dt, i, !1, "0 0 0").split(" ")[2]) || c.zOrigin || 0 : 0,
              d = parseFloat(o.defaultTransformPerspective) || 0;

          if (c.svg = !(!t.getCTM || !Xt(t)), c.svg && (Nt(t, tt(t, Dt, i, !1, "50% 50%") + "", c, t.getAttribute("data-svg-origin")), Rt = o.useSVGTransformAttr || It), (s = Yt(t)) !== Ut) {
            if (16 === s.length) {
              var m,
                  g,
                  y,
                  v,
                  b,
                  T = s[0],
                  x = s[1],
                  w = s[2],
                  P = s[3],
                  O = s[4],
                  S = s[5],
                  R = s[6],
                  A = s[7],
                  k = s[8],
                  C = s[9],
                  D = s[10],
                  E = s[12],
                  M = s[13],
                  F = s[14],
                  L = s[11],
                  j = Math.atan2(R, D);
              c.zOrigin && (F = -c.zOrigin, E = k * F - s[12], M = C * F - s[13], F = D * F + c.zOrigin - s[14]), c.rotationX = j * N, j && (v = Math.cos(-j), b = Math.sin(-j), m = O * v + k * b, g = S * v + C * b, y = R * v + D * b, k = O * -b + k * v, C = S * -b + C * v, D = R * -b + D * v, L = A * -b + L * v, O = m, S = g, R = y), j = Math.atan2(-w, D), c.rotationY = j * N, j && (v = Math.cos(-j), b = Math.sin(-j), m = T * v - k * b, g = x * v - C * b, y = w * v - D * b, C = x * b + C * v, D = w * b + D * v, L = P * b + L * v, T = m, x = g, w = y), j = Math.atan2(x, T), c.rotation = j * N, j && (v = Math.cos(j), b = Math.sin(j), m = T * v + x * b, g = O * v + S * b, y = k * v + C * b, x = x * v - T * b, S = S * v - O * b, C = C * v - k * b, T = m, O = g, k = y), c.rotationX && Math.abs(c.rotationX) + Math.abs(c.rotation) > 359.9 && (c.rotationX = c.rotation = 0, c.rotationY = 180 - c.rotationY), j = Math.atan2(O, S), c.scaleX = (1e5 * Math.sqrt(T * T + x * x + w * w) + .5 | 0) / 1e5, c.scaleY = (1e5 * Math.sqrt(S * S + R * R) + .5 | 0) / 1e5, c.scaleZ = (1e5 * Math.sqrt(k * k + C * C + D * D) + .5 | 0) / 1e5, T /= c.scaleX, O /= c.scaleY, x /= c.scaleX, S /= c.scaleY, Math.abs(j) > 2e-5 ? (c.skewX = j * N, O = 0, "simple" !== c.skewType && (c.scaleY *= 1 / Math.cos(j))) : c.skewX = 0, c.perspective = L ? 1 / (L < 0 ? -L : L) : 0, c.x = E, c.y = M, c.z = F, c.svg && (c.x -= c.xOrigin - (c.xOrigin * T - c.yOrigin * O), c.y -= c.yOrigin - (c.yOrigin * x - c.xOrigin * S));
            } else if (!Et || n || !s.length || c.x !== s[4] || c.y !== s[5] || !c.rotationX && !c.rotationY) {
              var I = s.length >= 6,
                  z = I ? s[0] : 1,
                  B = s[1] || 0,
                  X = s[2] || 0,
                  U = I ? s[3] : 1;
              c.x = s[4] || 0, c.y = s[5] || 0, l = Math.sqrt(z * z + B * B), h = Math.sqrt(U * U + X * X), u = z || B ? Math.atan2(B, z) * N : c.rotation || 0, f = X || U ? Math.atan2(X, U) * N + u : c.skewX || 0, c.scaleX = l, c.scaleY = h, c.rotation = u, c.skewX = f, Et && (c.rotationX = c.rotationY = c.z = 0, c.perspective = d, c.scaleZ = 1), c.svg && (c.x -= c.xOrigin - (c.xOrigin * z + c.yOrigin * X), c.y -= c.yOrigin - (c.xOrigin * B + c.yOrigin * U));
            }

            Math.abs(c.skewX) > 90 && Math.abs(c.skewX) < 270 && (_ ? (c.scaleX *= -1, c.skewX += c.rotation <= 0 ? 180 : -180, c.rotation += c.rotation <= 0 ? 180 : -180) : (c.scaleY *= -1, c.skewX += c.skewX <= 0 ? 180 : -180)), c.zOrigin = p;

            for (a in c) {
              c[a] < 2e-5 && c[a] > -2e-5 && (c[a] = 0);
            }
          }

          return r && (t._gsTransform = c, c.svg && (Rt && t.style[kt] ? e.delayedCall(.001, function () {
            Gt(t.style, kt);
          }) : !Rt && t.getAttribute("transform") && e.delayedCall(.001, function () {
            t.removeAttribute("transform");
          }))), c;
        },
            Vt = function Vt(t) {
          var e,
              i,
              r = this.data,
              n = -r.rotation * I,
              s = n + r.skewX * I,
              a = (Math.cos(n) * r.scaleX * 1e5 | 0) / 1e5,
              o = (Math.sin(n) * r.scaleX * 1e5 | 0) / 1e5,
              l = (Math.sin(s) * -r.scaleY * 1e5 | 0) / 1e5,
              h = (Math.cos(s) * r.scaleY * 1e5 | 0) / 1e5,
              u = this.t.style,
              f = this.t.currentStyle;

          if (f) {
            i = o, o = -l, l = -i, e = f.filter, u.filter = "";

            var c,
                _,
                p = this.t.offsetWidth,
                d = this.t.offsetHeight,
                g = "absolute" !== f.position,
                y = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + o + ", M21=" + l + ", M22=" + h,
                v = r.x + p * r.xPercent / 100,
                b = r.y + d * r.yPercent / 100;

            if (null != r.ox && (c = (r.oxp ? p * r.ox * .01 : r.ox) - p / 2, _ = (r.oyp ? d * r.oy * .01 : r.oy) - d / 2, v += c - (c * a + _ * o), b += _ - (c * l + _ * h)), g ? (c = p / 2, _ = d / 2, y += ", Dx=" + (c - (c * a + _ * o) + v) + ", Dy=" + (_ - (c * l + _ * h) + b) + ")") : y += ", sizingMethod='auto expand')", -1 !== e.indexOf("DXImageTransform.Microsoft.Matrix(") ? u.filter = e.replace(F, y) : u.filter = y + " " + e, 0 !== t && 1 !== t || 1 === a && 0 === o && 0 === l && 1 === h && (g && -1 === y.indexOf("Dx=0, Dy=0") || P.test(e) && 100 !== parseFloat(RegExp.$1) || -1 === e.indexOf(e.indexOf("Alpha")) && u.removeAttribute("filter")), !g) {
              var T,
                  x,
                  O,
                  S = m < 8 ? 1 : -1;

              for (c = r.ieOffsetX || 0, _ = r.ieOffsetY || 0, r.ieOffsetX = Math.round((p - ((a < 0 ? -a : a) * p + (o < 0 ? -o : o) * d)) / 2 + v), r.ieOffsetY = Math.round((d - ((h < 0 ? -h : h) * d + (l < 0 ? -l : l) * p)) / 2 + b), wt = 0; wt < 4; wt++) {
                x = at[wt], T = f[x], i = -1 !== T.indexOf("px") ? parseFloat(T) : et(this.t, x, parseFloat(T), T.replace(w, "")) || 0, O = i !== r[x] ? wt < 2 ? -r.ieOffsetX : -r.ieOffsetY : wt < 2 ? c - r.ieOffsetX : _ - r.ieOffsetY, u[x] = (r[x] = Math.round(i - O * (0 === wt || 2 === wt ? 1 : S))) + "px";
              }
            }
          }
        },
            Wt = V.set3DTransformRatio = V.setTransformRatio = function (t) {
          var e,
              i,
              r,
              n,
              s,
              a,
              o,
              l,
              h,
              u,
              f,
              c,
              _,
              d,
              m,
              g,
              y,
              v,
              b,
              T,
              x,
              w,
              P,
              O = this.data,
              S = this.t.style,
              R = O.rotation,
              A = O.rotationX,
              k = O.rotationY,
              C = O.scaleX,
              D = O.scaleY,
              E = O.scaleZ,
              M = O.x,
              F = O.y,
              L = O.z,
              j = O.svg,
              N = O.perspective,
              z = O.force3D,
              B = O.skewY,
              X = O.skewX;

          if (B && (X += B, R += B), ((1 === t || 0 === t) && "auto" === z && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !z) && !L && !N && !k && !A && 1 === E || Rt && j || !Et) return void (R || X || j ? (R *= I, w = X * I, P = 1e5, i = Math.cos(R) * C, s = Math.sin(R) * C, r = Math.sin(R - w) * -D, a = Math.cos(R - w) * D, w && "simple" === O.skewType && (e = Math.tan(w - B * I), e = Math.sqrt(1 + e * e), r *= e, a *= e, B && (e = Math.tan(B * I), e = Math.sqrt(1 + e * e), i *= e, s *= e)), j && (M += O.xOrigin - (O.xOrigin * i + O.yOrigin * r) + O.xOffset, F += O.yOrigin - (O.xOrigin * s + O.yOrigin * a) + O.yOffset, Rt && (O.xPercent || O.yPercent) && (m = this.t.getBBox(), M += .01 * O.xPercent * m.width, F += .01 * O.yPercent * m.height), m = 1e-6, M < m && M > -m && (M = 0), F < m && F > -m && (F = 0)), b = (i * P | 0) / P + "," + (s * P | 0) / P + "," + (r * P | 0) / P + "," + (a * P | 0) / P + "," + M + "," + F + ")", j && Rt ? this.t.setAttribute("transform", "matrix(" + b) : S[kt] = (O.xPercent || O.yPercent ? "translate(" + O.xPercent + "%," + O.yPercent + "%) matrix(" : "matrix(") + b) : S[kt] = (O.xPercent || O.yPercent ? "translate(" + O.xPercent + "%," + O.yPercent + "%) matrix(" : "matrix(") + C + ",0,0," + D + "," + M + "," + F + ")");
          if (p && (m = 1e-4, C < m && C > -m && (C = E = 2e-5), D < m && D > -m && (D = E = 2e-5), !N || O.z || O.rotationX || O.rotationY || (N = 0)), R || X) R *= I, g = i = Math.cos(R), y = s = Math.sin(R), X && (R -= X * I, g = Math.cos(R), y = Math.sin(R), "simple" === O.skewType && (e = Math.tan((X - B) * I), e = Math.sqrt(1 + e * e), g *= e, y *= e, O.skewY && (e = Math.tan(B * I), e = Math.sqrt(1 + e * e), i *= e, s *= e))), r = -y, a = g;else {
            if (!(k || A || 1 !== E || N || j)) return void (S[kt] = (O.xPercent || O.yPercent ? "translate(" + O.xPercent + "%," + O.yPercent + "%) translate3d(" : "translate3d(") + M + "px," + F + "px," + L + "px)" + (1 !== C || 1 !== D ? " scale(" + C + "," + D + ")" : ""));
            i = a = 1, r = s = 0;
          }
          u = 1, n = o = l = h = f = c = 0, _ = N ? -1 / N : 0, d = O.zOrigin, m = 1e-6, T = ",", x = "0", R = k * I, R && (g = Math.cos(R), y = Math.sin(R), l = -y, f = _ * -y, n = i * y, o = s * y, u = g, _ *= g, i *= g, s *= g), R = A * I, R && (g = Math.cos(R), y = Math.sin(R), e = r * g + n * y, v = a * g + o * y, h = u * y, c = _ * y, n = r * -y + n * g, o = a * -y + o * g, u *= g, _ *= g, r = e, a = v), 1 !== E && (n *= E, o *= E, u *= E, _ *= E), 1 !== D && (r *= D, a *= D, h *= D, c *= D), 1 !== C && (i *= C, s *= C, l *= C, f *= C), (d || j) && (d && (M += n * -d, F += o * -d, L += u * -d + d), j && (M += O.xOrigin - (O.xOrigin * i + O.yOrigin * r) + O.xOffset, F += O.yOrigin - (O.xOrigin * s + O.yOrigin * a) + O.yOffset), M < m && M > -m && (M = x), F < m && F > -m && (F = x), L < m && L > -m && (L = 0)), b = O.xPercent || O.yPercent ? "translate(" + O.xPercent + "%," + O.yPercent + "%) matrix3d(" : "matrix3d(", b += (i < m && i > -m ? x : i) + T + (s < m && s > -m ? x : s) + T + (l < m && l > -m ? x : l), b += T + (f < m && f > -m ? x : f) + T + (r < m && r > -m ? x : r) + T + (a < m && a > -m ? x : a), A || k || 1 !== E ? (b += T + (h < m && h > -m ? x : h) + T + (c < m && c > -m ? x : c) + T + (n < m && n > -m ? x : n), b += T + (o < m && o > -m ? x : o) + T + (u < m && u > -m ? x : u) + T + (_ < m && _ > -m ? x : _) + T) : b += ",0,0,0,0,1,0,", b += M + T + F + T + L + T + (N ? 1 + -L / N : 1) + ")", S[kt] = b;
        };

        u = Mt.prototype, u.x = u.y = u.z = u.skewX = u.skewY = u.rotation = u.rotationX = u.rotationY = u.zOrigin = u.xPercent = u.yPercent = u.xOffset = u.yOffset = 0, u.scaleX = u.scaleY = u.scaleZ = 1, Ot("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
          parser: function parser(t, e, i, r, s, a, l) {
            if (r._lastParsedTransform === l) return s;
            r._lastParsedTransform = l;
            var h,
                u = l.scale && "function" === typeof l.scale ? l.scale : 0;
            "function" === typeof l[i] && (h = l[i], l[i] = e), u && (l.scale = u(y, t));

            var f,
                c,
                _,
                p,
                d,
                m,
                v,
                b,
                T,
                x = t._gsTransform,
                w = t.style,
                P = At.length,
                O = l,
                S = {},
                R = qt(t, n, !0, O.parseTransform),
                A = O.transform && ("function" === typeof O.transform ? O.transform(y, g) : O.transform);

            if (R.skewType = O.skewType || R.skewType || o.defaultSkewType, r._transform = R, A && "string" === typeof A && kt) c = Y.style, c[kt] = A, c.display = "block", c.position = "absolute", X.body.appendChild(Y), f = qt(Y, null, !1), "simple" === R.skewType && (f.scaleY *= Math.cos(f.skewX * I)), R.svg && (m = R.xOrigin, v = R.yOrigin, f.x -= R.xOffset, f.y -= R.yOffset, (O.transformOrigin || O.svgOrigin) && (A = {}, Nt(t, lt(O.transformOrigin), A, O.svgOrigin, O.smoothOrigin, !0), m = A.xOrigin, v = A.yOrigin, f.x -= A.xOffset - R.xOffset, f.y -= A.yOffset - R.yOffset), (m || v) && (b = Yt(Y, !0), f.x -= m - (m * b[0] + v * b[2]), f.y -= v - (m * b[1] + v * b[3]))), X.body.removeChild(Y), f.perspective || (f.perspective = R.perspective), null != O.xPercent && (f.xPercent = ut(O.xPercent, R.xPercent)), null != O.yPercent && (f.yPercent = ut(O.yPercent, R.yPercent));else if ("object" === typeof O) {
              if (f = {
                scaleX: ut(null != O.scaleX ? O.scaleX : O.scale, R.scaleX),
                scaleY: ut(null != O.scaleY ? O.scaleY : O.scale, R.scaleY),
                scaleZ: ut(O.scaleZ, R.scaleZ),
                x: ut(O.x, R.x),
                y: ut(O.y, R.y),
                z: ut(O.z, R.z),
                xPercent: ut(O.xPercent, R.xPercent),
                yPercent: ut(O.yPercent, R.yPercent),
                perspective: ut(O.transformPerspective, R.perspective)
              }, null != (d = O.directionalRotation)) if ("object" === typeof d) for (c in d) {
                O[c] = d[c];
              } else O.rotation = d;
              "string" === typeof O.x && -1 !== O.x.indexOf("%") && (f.x = 0, f.xPercent = ut(O.x, R.xPercent)), "string" === typeof O.y && -1 !== O.y.indexOf("%") && (f.y = 0, f.yPercent = ut(O.y, R.yPercent)), f.rotation = ft("rotation" in O ? O.rotation : "shortRotation" in O ? O.shortRotation + "_short" : "rotationZ" in O ? O.rotationZ : R.rotation, R.rotation, "rotation", S), Et && (f.rotationX = ft("rotationX" in O ? O.rotationX : "shortRotationX" in O ? O.shortRotationX + "_short" : R.rotationX || 0, R.rotationX, "rotationX", S), f.rotationY = ft("rotationY" in O ? O.rotationY : "shortRotationY" in O ? O.shortRotationY + "_short" : R.rotationY || 0, R.rotationY, "rotationY", S)), f.skewX = ft(O.skewX, R.skewX), f.skewY = ft(O.skewY, R.skewY);
            }

            for (Et && null != O.force3D && (R.force3D = O.force3D, p = !0), _ = R.force3D || R.z || R.rotationX || R.rotationY || f.z || f.rotationX || f.rotationY || f.perspective, _ || null == O.scale || (f.scaleZ = 1); --P > -1;) {
              T = At[P], ((A = f[T] - R[T]) > 1e-6 || A < -1e-6 || null != O[T] || null != z[T]) && (p = !0, s = new bt(R, T, R[T], A, s), T in S && (s.e = S[T]), s.xs0 = 0, s.plugin = a, r._overwriteProps.push(s.n));
            }

            return A = O.transformOrigin, R.svg && (A || O.svgOrigin) && (m = R.xOffset, v = R.yOffset, Nt(t, lt(A), f, O.svgOrigin, O.smoothOrigin), s = Tt(R, "xOrigin", (x ? R : f).xOrigin, f.xOrigin, s, "transformOrigin"), s = Tt(R, "yOrigin", (x ? R : f).yOrigin, f.yOrigin, s, "transformOrigin"), m === R.xOffset && v === R.yOffset || (s = Tt(R, "xOffset", x ? m : R.xOffset, R.xOffset, s, "transformOrigin"), s = Tt(R, "yOffset", x ? v : R.yOffset, R.yOffset, s, "transformOrigin")), A = "0px 0px"), (A || Et && _ && R.zOrigin) && (kt ? (p = !0, T = Dt, A = (A || tt(t, T, n, !1, "50% 50%")) + "", s = new bt(w, T, 0, 0, s, -1, "transformOrigin"), s.b = w[T], s.plugin = a, Et ? (c = R.zOrigin, A = A.split(" "), R.zOrigin = (A.length > 2 && (0 === c || "0px" !== A[2]) ? parseFloat(A[2]) : c) || 0, s.xs0 = s.e = A[0] + " " + (A[1] || "50%") + " 0px", s = new bt(R, "zOrigin", 0, 0, s, -1, s.n), s.b = c, s.xs0 = s.e = R.zOrigin) : s.xs0 = s.e = A) : lt(A + "", R)), p && (r._transformType = R.svg && Rt || !_ && 3 !== this._transformType ? 2 : 3), h && (l[i] = h), u && (l.scale = u), s;
          },
          prefix: !0
        }), Ot("boxShadow", {
          defaultValue: "0px 0px 0px 0px #999",
          prefix: !0,
          color: !0,
          multi: !0,
          keyword: "inset"
        }), Ot("borderRadius", {
          defaultValue: "0px",
          parser: function parser(t, e, i, s, a, o) {
            e = this.format(e);

            var l,
                h,
                u,
                f,
                c,
                _,
                p,
                d,
                m,
                g,
                y,
                v,
                b,
                T,
                x,
                w,
                P = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                O = t.style;

            for (m = parseFloat(t.offsetWidth), g = parseFloat(t.offsetHeight), l = e.split(" "), h = 0; h < P.length; h++) {
              this.p.indexOf("border") && (P[h] = K(P[h])), c = f = tt(t, P[h], n, !1, "0px"), -1 !== c.indexOf(" ") && (f = c.split(" "), c = f[0], f = f[1]), _ = u = l[h], p = parseFloat(c), v = c.substr((p + "").length), b = "=" === _.charAt(1), b ? (d = parseInt(_.charAt(0) + "1", 10), _ = _.substr(2), d *= parseFloat(_), y = _.substr((d + "").length - (d < 0 ? 1 : 0)) || "") : (d = parseFloat(_), y = _.substr((d + "").length)), "" === y && (y = r[i] || v), y !== v && (T = et(t, "borderLeft", p, v), x = et(t, "borderTop", p, v), "%" === y ? (c = T / m * 100 + "%", f = x / g * 100 + "%") : "em" === y ? (w = et(t, "borderLeft", 1, "em"), c = T / w + "em", f = x / w + "em") : (c = T + "px", f = x + "px"), b && (_ = parseFloat(c) + d + y, u = parseFloat(f) + d + y)), a = xt(O, P[h], c + " " + f, _ + " " + u, !1, "0px", a);
            }

            return a;
          },
          prefix: !0,
          formatter: gt("0px 0px 0px 0px", !1, !0)
        }), Ot("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
          defaultValue: "0px",
          parser: function parser(t, e, i, r, s, a) {
            return xt(t.style, i, this.format(tt(t, i, n, !1, "0px 0px")), this.format(e), !1, "0px", s);
          },
          prefix: !0,
          formatter: gt("0px 0px", !1, !0)
        }), Ot("backgroundPosition", {
          defaultValue: "0 0",
          parser: function parser(t, e, i, r, s, a) {
            var o,
                l,
                h,
                u,
                f,
                c,
                _ = "background-position",
                p = n || J(t, null),
                d = this.format((p ? m ? p.getPropertyValue(_ + "-x") + " " + p.getPropertyValue(_ + "-y") : p.getPropertyValue(_) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"),
                g = this.format(e);

            if (-1 !== d.indexOf("%") !== (-1 !== g.indexOf("%")) && g.split(",").length < 2 && (c = tt(t, "backgroundImage").replace(C, "")) && "none" !== c) {
              for (o = d.split(" "), l = g.split(" "), q.setAttribute("src", c), h = 2; --h > -1;) {
                d = o[h], (u = -1 !== d.indexOf("%")) !== (-1 !== l[h].indexOf("%")) && (f = 0 === h ? t.offsetWidth - q.width : t.offsetHeight - q.height, o[h] = u ? parseFloat(d) / 100 * f + "px" : parseFloat(d) / f * 100 + "%");
              }

              d = o.join(" ");
            }

            return this.parseComplex(t.style, d, g, s, a);
          },
          formatter: lt
        }), Ot("backgroundSize", {
          defaultValue: "0 0",
          formatter: function formatter(t) {
            return t += "", lt(-1 === t.indexOf(" ") ? t + " " + t : t);
          }
        }), Ot("perspective", {
          defaultValue: "0px",
          prefix: !0
        }), Ot("perspectiveOrigin", {
          defaultValue: "50% 50%",
          prefix: !0
        }), Ot("transformStyle", {
          prefix: !0
        }), Ot("backfaceVisibility", {
          prefix: !0
        }), Ot("userSelect", {
          prefix: !0
        }), Ot("margin", {
          parser: yt("marginTop,marginRight,marginBottom,marginLeft")
        }), Ot("padding", {
          parser: yt("paddingTop,paddingRight,paddingBottom,paddingLeft")
        }), Ot("clip", {
          defaultValue: "rect(0px,0px,0px,0px)",
          parser: function parser(t, e, i, r, s, a) {
            var o, l, h;
            return m < 9 ? (l = t.currentStyle, h = m < 8 ? " " : ",", o = "rect(" + l.clipTop + h + l.clipRight + h + l.clipBottom + h + l.clipLeft + ")", e = this.format(e).split(",").join(h)) : (o = this.format(tt(t, this.p, n, !1, this.dflt)), e = this.format(e)), this.parseComplex(t.style, o, e, s, a);
          }
        }), Ot("textShadow", {
          defaultValue: "0px 0px 0px #999",
          color: !0,
          multi: !0
        }), Ot("autoRound,strictUnits", {
          parser: function parser(t, e, i, r, n) {
            return n;
          }
        }), Ot("border", {
          defaultValue: "0px solid #000",
          parser: function parser(t, e, i, r, s, a) {
            var o = tt(t, "borderTopWidth", n, !1, "0px"),
                l = this.format(e).split(" "),
                h = l[0].replace(w, "");
            return "px" !== h && (o = parseFloat(o) / et(t, "borderTopWidth", 1, h) + h), this.parseComplex(t.style, this.format(o + " " + tt(t, "borderTopStyle", n, !1, "solid") + " " + tt(t, "borderTopColor", n, !1, "#000")), l.join(" "), s, a);
          },
          color: !0,
          formatter: function formatter(t) {
            var e = t.split(" ");
            return e[0] + " " + (e[1] || "solid") + " " + (t.match(mt) || ["#000"])[0];
          }
        }), Ot("borderWidth", {
          parser: yt("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
        }), Ot("float,cssFloat,styleFloat", {
          parser: function parser(t, e, i, r, n, s) {
            var a = t.style,
                o = "cssFloat" in a ? "cssFloat" : "styleFloat";
            return new bt(a, o, 0, 0, n, -1, i, !1, 0, a[o], e);
          }
        });

        var Ht = function Ht(t) {
          var e,
              i = this.t,
              r = i.filter || tt(this.data, "filter") || "",
              n = this.s + this.c * t | 0;
          100 === n && (-1 === r.indexOf("atrix(") && -1 === r.indexOf("radient(") && -1 === r.indexOf("oader(") ? (i.removeAttribute("filter"), e = !tt(this.data, "filter")) : (i.filter = r.replace(S, ""), e = !0)), e || (this.xn1 && (i.filter = r = r || "alpha(opacity=" + n + ")"), -1 === r.indexOf("pacity") ? 0 === n && this.xn1 || (i.filter = r + " alpha(opacity=" + n + ")") : i.filter = r.replace(P, "opacity=" + n));
        };

        Ot("opacity,alpha,autoAlpha", {
          defaultValue: "1",
          parser: function parser(t, e, i, r, s, a) {
            var o = parseFloat(tt(t, "opacity", n, !1, "1")),
                l = t.style,
                h = "autoAlpha" === i;
            return "string" === typeof e && "=" === e.charAt(1) && (e = ("-" === e.charAt(0) ? -1 : 1) * parseFloat(e.substr(2)) + o), h && 1 === o && "hidden" === tt(t, "visibility", n) && 0 !== e && (o = 0), H ? s = new bt(l, "opacity", o, e - o, s) : (s = new bt(l, "opacity", 100 * o, 100 * (e - o), s), s.xn1 = h ? 1 : 0, l.zoom = 1, s.type = 2, s.b = "alpha(opacity=" + s.s + ")", s.e = "alpha(opacity=" + (s.s + s.c) + ")", s.data = t, s.plugin = a, s.setRatio = Ht), h && (s = new bt(l, "visibility", 0, 0, s, -1, null, !1, 0, 0 !== o ? "inherit" : "hidden", 0 === e ? "hidden" : "inherit"), s.xs0 = "inherit", r._overwriteProps.push(s.n), r._overwriteProps.push(i)), s;
          }
        });

        var Gt = function Gt(t, e) {
          e && (t.removeProperty ? ("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6) || (e = "-" + e), t.removeProperty(e.replace(A, "-$1").toLowerCase())) : t.removeAttribute(e));
        },
            Zt = function Zt(t) {
          if (this.t._gsClassPT = this, 1 === t || 0 === t) {
            this.t.setAttribute("class", 0 === t ? this.b : this.e);

            for (var e = this.data, i = this.t.style; e;) {
              e.v ? i[e.p] = e.v : Gt(i, e.p), e = e._next;
            }

            1 === t && this.t._gsClassPT === this && (this.t._gsClassPT = null);
          } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
        };

        Ot("className", {
          parser: function parser(t, e, r, s, a, o, l) {
            var h,
                u,
                f,
                c,
                _,
                p = t.getAttribute("class") || "",
                d = t.style.cssText;

            if (a = s._classNamePT = new bt(t, r, 0, 0, a, 2), a.setRatio = Zt, a.pr = -11, i = !0, a.b = p, u = rt(t, n), f = t._gsClassPT) {
              for (c = {}, _ = f.data; _;) {
                c[_.p] = 1, _ = _._next;
              }

              f.setRatio(1);
            }

            return t._gsClassPT = a, a.e = "=" !== e.charAt(1) ? e : p.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ("+" === e.charAt(0) ? " " + e.substr(2) : ""), t.setAttribute("class", a.e), h = nt(t, u, rt(t), l, c), t.setAttribute("class", p), a.data = h.firstMPT, t.style.cssText = d, a = a.xfirst = s.parse(t, h.difs, a, o);
          }
        });

        var $t = function $t(t) {
          if ((1 === t || 0 === t) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
            var e,
                i,
                r,
                n,
                s,
                a = this.t.style,
                o = h.transform.parse;
            if ("all" === this.e) a.cssText = "", n = !0;else for (e = this.e.split(" ").join("").split(","), r = e.length; --r > -1;) {
              i = e[r], h[i] && (h[i].parse === o ? n = !0 : i = "transformOrigin" === i ? Dt : h[i].p), Gt(a, i);
            }
            n && (Gt(a, kt), (s = this.t._gsTransform) && (s.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform));
          }
        };

        for (Ot("clearProps", {
          parser: function parser(t, e, r, n, s) {
            return s = new bt(t, r, 0, 0, s, 2), s.setRatio = $t, s.e = e, s.pr = -10, s.data = n._tween, i = !0, s;
          }
        }), u = "bezier,throwProps,physicsProps,physics2D".split(","), wt = u.length; wt--;) {
          St(u[wt]);
        }

        u = o.prototype, u._firstPT = u._lastParsedTransform = u._transform = null, u._onInitTween = function (t, e, s, l) {
          if (!t.nodeType) return !1;
          this._target = g = t, this._tween = s, this._vars = e, y = l, f = e.autoRound, i = !1, r = e.suffixMap || o.suffixMap, n = J(t, ""), a = this._overwriteProps;
          var u,
              p,
              m,
              v,
              b,
              T,
              x,
              w,
              P,
              S = t.style;

          if (c && "" === S.zIndex && ("auto" !== (u = tt(t, "zIndex", n)) && "" !== u || this._addLazySet(S, "zIndex", 0)), "string" === typeof e && (v = S.cssText, u = rt(t, n), S.cssText = v + ";" + e, u = nt(t, u, rt(t)).difs, !H && O.test(e) && (u.opacity = parseFloat(RegExp.$1)), e = u, S.cssText = v), e.className ? this._firstPT = p = h.className.parse(t, e.className, "className", this, null, null, e) : this._firstPT = p = this.parse(t, e, null), this._transformType) {
            for (P = 3 === this._transformType, kt ? _ && (c = !0, "" === S.zIndex && ("auto" !== (x = tt(t, "zIndex", n)) && "" !== x || this._addLazySet(S, "zIndex", 0)), d && this._addLazySet(S, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (P ? "visible" : "hidden"))) : S.zoom = 1, m = p; m && m._next;) {
              m = m._next;
            }

            w = new bt(t, "transform", 0, 0, null, 2), this._linkCSSP(w, null, m), w.setRatio = kt ? Wt : Vt, w.data = this._transform || qt(t, n, !0), w.tween = s, w.pr = -1, a.pop();
          }

          if (i) {
            for (; p;) {
              for (T = p._next, m = v; m && m.pr > p.pr;) {
                m = m._next;
              }

              (p._prev = m ? m._prev : b) ? p._prev._next = p : v = p, (p._next = m) ? m._prev = p : b = p, p = T;
            }

            this._firstPT = v;
          }

          return !0;
        }, u.parse = function (t, e, i, s) {
          var a,
              o,
              l,
              u,
              c,
              _,
              p,
              d,
              m,
              v,
              b = t.style;

          for (a in e) {
            if (_ = e[a], "function" === typeof _ && (_ = _(y, g)), o = h[a]) i = o.parse(t, _, a, this, i, s, e);else {
              if ("--" === a.substr(0, 2)) {
                this._tween._propLookup[a] = this._addTween.call(this._tween, t.style, "setProperty", J(t).getPropertyValue(a) + "", _ + "", a, !1, a);
                continue;
              }

              c = tt(t, a, n) + "", m = "string" === typeof _, "color" === a || "fill" === a || "stroke" === a || -1 !== a.indexOf("Color") || m && R.test(_) ? (m || (_ = pt(_), _ = (_.length > 3 ? "rgba(" : "rgb(") + _.join(",") + ")"), i = xt(b, a, c, _, !0, "transparent", i, 0, s)) : m && j.test(_) ? i = xt(b, a, c, _, !0, null, i, 0, s) : (l = parseFloat(c), p = l || 0 === l ? c.substr((l + "").length) : "", "" !== c && "auto" !== c || ("width" === a || "height" === a ? (l = ot(t, a, n), p = "px") : "left" === a || "top" === a ? (l = it(t, a, n), p = "px") : (l = "opacity" !== a ? 0 : 1, p = "")), v = m && "=" === _.charAt(1), v ? (u = parseInt(_.charAt(0) + "1", 10), _ = _.substr(2), u *= parseFloat(_), d = _.replace(w, "")) : (u = parseFloat(_), d = m ? _.replace(w, "") : ""), "" === d && (d = a in r ? r[a] : p), _ = u || 0 === u ? (v ? u + l : u) + d : e[a], p !== d && ("" === d && "lineHeight" !== a || (u || 0 === u) && l && (l = et(t, a, l, p), "%" === d ? (l /= et(t, a, 100, "%") / 100, !0 !== e.strictUnits && (c = l + "%")) : "em" === d || "rem" === d || "vw" === d || "vh" === d ? l /= et(t, a, 1, d) : "px" !== d && (u = et(t, a, u, d), d = "px"), v && (u || 0 === u) && (_ = u + l + d))), v && (u += l), !l && 0 !== l || !u && 0 !== u ? void 0 !== b[a] && (_ || _ + "" !== "NaN" && null != _) ? (i = new bt(b, a, u || l || 0, 0, i, -1, a, !1, 0, c, _), i.xs0 = "none" !== _ || "display" !== a && -1 === a.indexOf("Style") ? _ : c) : Z("invalid " + a + " tween value: " + e[a]) : (i = new bt(b, a, l, u - l, i, 0, a, !1 !== f && ("px" === d || "zIndex" === a), 0, c, _), i.xs0 = d));
            }
            s && i && !i.plugin && (i.plugin = s);
          }

          return i;
        }, u.setRatio = function (t) {
          var e,
              i,
              r,
              n = this._firstPT;
          if (1 !== t || this._tween._time !== this._tween._duration && 0 !== this._tween._time) {
            if (t || this._tween._time !== this._tween._duration && 0 !== this._tween._time || -1e-6 === this._tween._rawPrevTime) for (; n;) {
              if (e = n.c * t + n.s, n.r ? e = Math.round(e) : e < 1e-6 && e > -1e-6 && (e = 0), n.type) {
                if (1 === n.type) {
                  if (2 === (r = n.l)) n.t[n.p] = n.xs0 + e + n.xs1 + n.xn1 + n.xs2;else if (3 === r) n.t[n.p] = n.xs0 + e + n.xs1 + n.xn1 + n.xs2 + n.xn2 + n.xs3;else if (4 === r) n.t[n.p] = n.xs0 + e + n.xs1 + n.xn1 + n.xs2 + n.xn2 + n.xs3 + n.xn3 + n.xs4;else if (5 === r) n.t[n.p] = n.xs0 + e + n.xs1 + n.xn1 + n.xs2 + n.xn2 + n.xs3 + n.xn3 + n.xs4 + n.xn4 + n.xs5;else {
                    for (i = n.xs0 + e + n.xs1, r = 1; r < n.l; r++) {
                      i += n["xn" + r] + n["xs" + (r + 1)];
                    }

                    n.t[n.p] = i;
                  }
                } else -1 === n.type ? n.t[n.p] = n.xs0 : n.setRatio && n.setRatio(t);
              } else n.t[n.p] = e + n.xs0;
              n = n._next;
            } else for (; n;) {
              2 !== n.type ? n.t[n.p] = n.b : n.setRatio(t), n = n._next;
            }
          } else for (; n;) {
            if (2 !== n.type) {
              if (n.r && -1 !== n.type) {
                if (e = Math.round(n.s + n.c), n.type) {
                  if (1 === n.type) {
                    for (r = n.l, i = n.xs0 + e + n.xs1, r = 1; r < n.l; r++) {
                      i += n["xn" + r] + n["xs" + (r + 1)];
                    }

                    n.t[n.p] = i;
                  }
                } else n.t[n.p] = e + n.xs0;
              } else n.t[n.p] = n.e;
            } else n.setRatio(t);
            n = n._next;
          }
        }, u._enableTransforms = function (t) {
          this._transform = this._transform || qt(this._target, n, !0), this._transformType = this._transform.svg && Rt || !t && 3 !== this._transformType ? 2 : 3;
        };

        var Qt = function Qt(t) {
          this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0);
        };

        u._addLazySet = function (t, e, i) {
          var r = this._firstPT = new bt(t, e, 0, 0, this._firstPT, 2);
          r.e = i, r.setRatio = Qt, r.data = this;
        }, u._linkCSSP = function (t, e, i, r) {
          return t && (e && (e._prev = t), t._next && (t._next._prev = t._prev), t._prev ? t._prev._next = t._next : this._firstPT === t && (this._firstPT = t._next, r = !0), i ? i._next = t : r || null !== this._firstPT || (this._firstPT = t), t._next = e, t._prev = i), t;
        }, u._mod = function (t) {
          for (var e = this._firstPT; e;) {
            "function" === typeof t[e.p] && t[e.p] === Math.round && (e.r = 1), e = e._next;
          }
        }, u._kill = function (e) {
          var i,
              r,
              n,
              s = e;

          if (e.autoAlpha || e.alpha) {
            s = {};

            for (r in e) {
              s[r] = e[r];
            }

            s.opacity = 1, s.autoAlpha && (s.visibility = 1);
          }

          for (e.className && (i = this._classNamePT) && (n = i.xfirst, n && n._prev ? this._linkCSSP(n._prev, i._next, n._prev._prev) : n === this._firstPT && (this._firstPT = i._next), i._next && this._linkCSSP(i._next, i._next._next, n._prev), this._classNamePT = null), i = this._firstPT; i;) {
            i.plugin && i.plugin !== r && i.plugin._kill && (i.plugin._kill(e), r = i.plugin), i = i._next;
          }

          return t.prototype._kill.call(this, s);
        };

        var Kt = function Kt(t, e, i) {
          var r, n, s, a;
          if (t.slice) for (n = t.length; --n > -1;) {
            Kt(t[n], e, i);
          } else for (r = t.childNodes, n = r.length; --n > -1;) {
            s = r[n], a = s.type, s.style && (e.push(rt(s)), i && i.push(s)), 1 !== a && 9 !== a && 11 !== a || !s.childNodes.length || Kt(s, e, i);
          }
        };

        return o.cascadeTo = function (t, i, r) {
          var n,
              s,
              a,
              o,
              l = e.to(t, i, r),
              h = [l],
              u = [],
              f = [],
              c = [],
              _ = e._internals.reservedProps;

          for (t = l._targets || l.target, Kt(t, u, c), l.render(i, !0, !0), Kt(t, f), l.render(0, !0, !0), l._enabled(!0), n = c.length; --n > -1;) {
            if (s = nt(c[n], u[n], f[n]), s.firstMPT) {
              s = s.difs;

              for (a in r) {
                _[a] && (s[a] = r[a]);
              }

              o = {};

              for (a in s) {
                o[a] = u[n][a];
              }

              h.push(e.fromTo(c[n], i, o, s));
            }
          }

          return h;
        }, t.activate([o]), o;
      }, !0), function () {
        var t = s._gsDefine.plugin({
          propName: "roundProps",
          version: "1.6.0",
          priority: -1,
          API: 2,
          init: function init(t, e, i) {
            return this._tween = i, !0;
          }
        }),
            e = function e(t) {
          for (; t;) {
            t.f || t.blob || (t.m = Math.round), t = t._next;
          }
        },
            i = t.prototype;

        i._onInitAllProps = function () {
          for (var t, i, r, n = this._tween, s = n.vars.roundProps.join ? n.vars.roundProps : n.vars.roundProps.split(","), a = s.length, o = {}, l = n._propLookup.roundProps; --a > -1;) {
            o[s[a]] = Math.round;
          }

          for (a = s.length; --a > -1;) {
            for (t = s[a], i = n._firstPT; i;) {
              r = i._next, i.pg ? i.t._mod(o) : i.n === t && (2 === i.f && i.t ? e(i.t._firstPT) : (this._add(i.t, t, i.s, i.c), r && (r._prev = i._prev), i._prev ? i._prev._next = r : n._firstPT === i && (n._firstPT = r), i._next = i._prev = null, n._propLookup[t] = l)), i = r;
            }
          }

          return !1;
        }, i._add = function (t, e, i, r) {
          this._addTween(t, e, i, i + r, e, Math.round), this._overwriteProps.push(e);
        };
      }(), function () {
        s._gsDefine.plugin({
          propName: "attr",
          API: 2,
          version: "0.6.1",
          init: function init(t, e, i, r) {
            var n, s;
            if ("function" !== typeof t.setAttribute) return !1;

            for (n in e) {
              s = e[n], "function" === typeof s && (s = s(r, t)), this._addTween(t, "setAttribute", t.getAttribute(n) + "", s + "", n, !1, n), this._overwriteProps.push(n);
            }

            return !0;
          }
        });
      }(), s._gsDefine.plugin({
        propName: "directionalRotation",
        version: "0.3.1",
        API: 2,
        init: function init(t, e, i, r) {
          "object" !== typeof e && (e = {
            rotation: e
          }), this.finals = {};
          var n,
              s,
              a,
              o,
              l,
              h,
              u = !0 === e.useRadians ? 2 * Math.PI : 360;

          for (n in e) {
            "useRadians" !== n && (o = e[n], "function" === typeof o && (o = o(r, t)), h = (o + "").split("_"), s = h[0], a = parseFloat("function" !== typeof t[n] ? t[n] : t[n.indexOf("set") || "function" !== typeof t["get" + n.substr(3)] ? n : "get" + n.substr(3)]()), o = this.finals[n] = "string" === typeof s && "=" === s.charAt(1) ? a + parseInt(s.charAt(0) + "1", 10) * Number(s.substr(2)) : Number(s) || 0, l = o - a, h.length && (s = h.join("_"), -1 !== s.indexOf("short") && (l %= u) !== l % (u / 2) && (l = l < 0 ? l + u : l - u), -1 !== s.indexOf("_cw") && l < 0 ? l = (l + 9999999999 * u) % u - (l / u | 0) * u : -1 !== s.indexOf("ccw") && l > 0 && (l = (l - 9999999999 * u) % u - (l / u | 0) * u)), (l > 1e-6 || l < -1e-6) && (this._addTween(t, n, a, a + l, n), this._overwriteProps.push(n)));
          }

          return !0;
        },
        set: function set(t) {
          var e;
          if (1 !== t) this._super.setRatio.call(this, t);else for (e = this._firstPT; e;) {
            e.f ? e.t[e.p](this.finals[e.p]) : e.t[e.p] = this.finals[e.p], e = e._next;
          }
        }
      })._autoCSS = !0, s._gsDefine("easing.Back", ["easing.Ease"], function (t) {
        var e,
            i,
            r,
            n = s.GreenSockGlobals || s,
            a = n.com.greensock,
            o = 2 * Math.PI,
            l = Math.PI / 2,
            h = a._class,
            u = function u(e, i) {
          var r = h("easing." + e, function () {}, !0),
              n = r.prototype = new t();
          return n.constructor = r, n.getRatio = i, r;
        },
            f = t.register || function () {},
            c = function c(t, e, i, r, n) {
          var s = h("easing." + t, {
            easeOut: new e(),
            easeIn: new i(),
            easeInOut: new r()
          }, !0);
          return f(s, t), s;
        },
            _ = function _(t, e, i) {
          this.t = t, this.v = e, i && (this.next = i, i.prev = this, this.c = i.v - e, this.gap = i.t - t);
        },
            p = function p(e, i) {
          var r = h("easing." + e, function (t) {
            this._p1 = t || 0 === t ? t : 1.70158, this._p2 = 1.525 * this._p1;
          }, !0),
              n = r.prototype = new t();
          return n.constructor = r, n.getRatio = i, n.config = function (t) {
            return new r(t);
          }, r;
        },
            d = c("Back", p("BackOut", function (t) {
          return (t -= 1) * t * ((this._p1 + 1) * t + this._p1) + 1;
        }), p("BackIn", function (t) {
          return t * t * ((this._p1 + 1) * t - this._p1);
        }), p("BackInOut", function (t) {
          return (t *= 2) < 1 ? .5 * t * t * ((this._p2 + 1) * t - this._p2) : .5 * ((t -= 2) * t * ((this._p2 + 1) * t + this._p2) + 2);
        })),
            m = h("easing.SlowMo", function (t, e, i) {
          e = e || 0 === e ? e : .7, null == t ? t = .7 : t > 1 && (t = 1), this._p = 1 !== t ? e : 0, this._p1 = (1 - t) / 2, this._p2 = t, this._p3 = this._p1 + this._p2, this._calcEnd = !0 === i;
        }, !0),
            g = m.prototype = new t();

        return g.constructor = m, g.getRatio = function (t) {
          var e = t + (.5 - t) * this._p;
          return t < this._p1 ? this._calcEnd ? 1 - (t = 1 - t / this._p1) * t : e - (t = 1 - t / this._p1) * t * t * t * e : t > this._p3 ? this._calcEnd ? 1 === t ? 0 : 1 - (t = (t - this._p3) / this._p1) * t : e + (t - e) * (t = (t - this._p3) / this._p1) * t * t * t : this._calcEnd ? 1 : e;
        }, m.ease = new m(.7, .7), g.config = m.config = function (t, e, i) {
          return new m(t, e, i);
        }, e = h("easing.SteppedEase", function (t, e) {
          t = t || 1, this._p1 = 1 / t, this._p2 = t + (e ? 0 : 1), this._p3 = e ? 1 : 0;
        }, !0), g = e.prototype = new t(), g.constructor = e, g.getRatio = function (t) {
          return t < 0 ? t = 0 : t >= 1 && (t = .999999999), ((this._p2 * t | 0) + this._p3) * this._p1;
        }, g.config = e.config = function (t, i) {
          return new e(t, i);
        }, i = h("easing.RoughEase", function (e) {
          e = e || {};

          for (var i, r, n, s, a, o, l = e.taper || "none", h = [], u = 0, f = 0 | (e.points || 20), c = f, p = !1 !== e.randomize, d = !0 === e.clamp, m = e.template instanceof t ? e.template : null, g = "number" === typeof e.strength ? .4 * e.strength : .4; --c > -1;) {
            i = p ? Math.random() : 1 / f * c, r = m ? m.getRatio(i) : i, "none" === l ? n = g : "out" === l ? (s = 1 - i, n = s * s * g) : "in" === l ? n = i * i * g : i < .5 ? (s = 2 * i, n = s * s * .5 * g) : (s = 2 * (1 - i), n = s * s * .5 * g), p ? r += Math.random() * n - .5 * n : c % 2 ? r += .5 * n : r -= .5 * n, d && (r > 1 ? r = 1 : r < 0 && (r = 0)), h[u++] = {
              x: i,
              y: r
            };
          }

          for (h.sort(function (t, e) {
            return t.x - e.x;
          }), o = new _(1, 1, null), c = f; --c > -1;) {
            a = h[c], o = new _(a.x, a.y, o);
          }

          this._prev = new _(0, 0, 0 !== o.t ? o : o.next);
        }, !0), g = i.prototype = new t(), g.constructor = i, g.getRatio = function (t) {
          var e = this._prev;

          if (t > e.t) {
            for (; e.next && t >= e.t;) {
              e = e.next;
            }

            e = e.prev;
          } else for (; e.prev && t <= e.t;) {
            e = e.prev;
          }

          return this._prev = e, e.v + (t - e.t) / e.gap * e.c;
        }, g.config = function (t) {
          return new i(t);
        }, i.ease = new i(), c("Bounce", u("BounceOut", function (t) {
          return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
        }), u("BounceIn", function (t) {
          return (t = 1 - t) < 1 / 2.75 ? 1 - 7.5625 * t * t : t < 2 / 2.75 ? 1 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : t < 2.5 / 2.75 ? 1 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 1 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375);
        }), u("BounceInOut", function (t) {
          var e = t < .5;
          return t = e ? 1 - 2 * t : 2 * t - 1, t < 1 / 2.75 ? t *= 7.5625 * t : t = t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375, e ? .5 * (1 - t) : .5 * t + .5;
        })), c("Circ", u("CircOut", function (t) {
          return Math.sqrt(1 - (t -= 1) * t);
        }), u("CircIn", function (t) {
          return -(Math.sqrt(1 - t * t) - 1);
        }), u("CircInOut", function (t) {
          return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        })), r = function r(e, i, _r) {
          var n = h("easing." + e, function (t, e) {
            this._p1 = t >= 1 ? t : 1, this._p2 = (e || _r) / (t < 1 ? t : 1), this._p3 = this._p2 / o * (Math.asin(1 / this._p1) || 0), this._p2 = o / this._p2;
          }, !0),
              s = n.prototype = new t();
          return s.constructor = n, s.getRatio = i, s.config = function (t, e) {
            return new n(t, e);
          }, n;
        }, c("Elastic", r("ElasticOut", function (t) {
          return this._p1 * Math.pow(2, -10 * t) * Math.sin((t - this._p3) * this._p2) + 1;
        }, .3), r("ElasticIn", function (t) {
          return -this._p1 * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2);
        }, .3), r("ElasticInOut", function (t) {
          return (t *= 2) < 1 ? this._p1 * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2) * -.5 : this._p1 * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2) * .5 + 1;
        }, .45)), c("Expo", u("ExpoOut", function (t) {
          return 1 - Math.pow(2, -10 * t);
        }), u("ExpoIn", function (t) {
          return Math.pow(2, 10 * (t - 1)) - .001;
        }), u("ExpoInOut", function (t) {
          return (t *= 2) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
        })), c("Sine", u("SineOut", function (t) {
          return Math.sin(t * l);
        }), u("SineIn", function (t) {
          return 1 - Math.cos(t * l);
        }), u("SineInOut", function (t) {
          return -.5 * (Math.cos(Math.PI * t) - 1);
        })), h("easing.EaseLookup", {
          find: function find(e) {
            return t.map[e];
          }
        }, !0), f(n.SlowMo, "SlowMo", "ease,"), f(i, "RoughEase", "ease,"), f(e, "SteppedEase", "ease,"), d;
      }, !0);
    }), s._gsDefine && s._gsQueue.pop()(), function (i, s) {
      "use strict";

      var a = {},
          o = i.document,
          l = i.GreenSockGlobals = i.GreenSockGlobals || i;

      if (!l.TweenLite) {
        var h,
            u,
            f,
            c,
            _,
            p = function p(t) {
          var e,
              i = t.split("."),
              r = l;

          for (e = 0; e < i.length; e++) {
            r[i[e]] = r = r[i[e]] || {};
          }

          return r;
        },
            d = p("com.greensock"),
            m = function m(t) {
          var e,
              i = [],
              r = t.length;

          for (e = 0; e !== r; i.push(t[e++])) {
            ;
          }

          return i;
        },
            g = function g() {},
            y = function () {
          var t = Object.prototype.toString,
              e = t.call([]);
          return function (i) {
            return null != i && (i instanceof Array || "object" === typeof i && !!i.push && t.call(i) === e);
          };
        }(),
            v = {},
            b = function b(i, s, o, h) {
          this.sc = v[i] ? v[i].sc : [], v[i] = this, this.gsClass = null, this.func = o;
          var u = [];
          this.check = function (f) {
            for (var c, _, d, m, g = s.length, y = g; --g > -1;) {
              (c = v[s[g]] || new b(s[g], [])).gsClass ? (u[g] = c.gsClass, y--) : f && c.sc.push(this);
            }

            if (0 === y && o) {
              if (_ = ("com.greensock." + i).split("."), d = _.pop(), m = p(_.join("."))[d] = this.gsClass = o.apply(o, u), h) if (l[d] = a[d] = m, "undefined" !== typeof t && t.exports) {
                if ("TweenMax" === i) {
                  t.exports = a.TweenMax = m;

                  for (g in a) {
                    m[g] = a[g];
                  }
                } else a.TweenMax && (a.TweenMax[d] = m);
              } else r = [], void 0 !== (n = function () {
                return m;
              }.apply(e, r)) && (t.exports = n);

              for (g = 0; g < this.sc.length; g++) {
                this.sc[g].check();
              }
            }
          }, this.check(!0);
        },
            T = i._gsDefine = function (t, e, i, r) {
          return new b(t, e, i, r);
        },
            x = d._class = function (t, e, i) {
          return e = e || function () {}, T(t, [], function () {
            return e;
          }, i), e;
        };

        T.globals = l;

        var w = [0, 0, 1, 1],
            P = x("easing.Ease", function (t, e, i, r) {
          this._func = t, this._type = i || 0, this._power = r || 0, this._params = e ? w.concat(e) : w;
        }, !0),
            O = P.map = {},
            S = P.register = function (t, e, i, r) {
          for (var n, s, a, o, l = e.split(","), h = l.length, u = (i || "easeIn,easeOut,easeInOut").split(","); --h > -1;) {
            for (s = l[h], n = r ? x("easing." + s, null, !0) : d.easing[s] || {}, a = u.length; --a > -1;) {
              o = u[a], O[s + "." + o] = O[o + s] = n[o] = t.getRatio ? t : t[o] || new t();
            }
          }
        };

        for (f = P.prototype, f._calcEnd = !1, f.getRatio = function (t) {
          if (this._func) return this._params[0] = t, this._func.apply(null, this._params);
          var e = this._type,
              i = this._power,
              r = 1 === e ? 1 - t : 2 === e ? t : t < .5 ? 2 * t : 2 * (1 - t);
          return 1 === i ? r *= r : 2 === i ? r *= r * r : 3 === i ? r *= r * r * r : 4 === i && (r *= r * r * r * r), 1 === e ? 1 - r : 2 === e ? r : t < .5 ? r / 2 : 1 - r / 2;
        }, h = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], u = h.length; --u > -1;) {
          f = h[u] + ",Power" + u, S(new P(null, null, 1, u), f, "easeOut", !0), S(new P(null, null, 2, u), f, "easeIn" + (0 === u ? ",easeNone" : "")), S(new P(null, null, 3, u), f, "easeInOut");
        }

        O.linear = d.easing.Linear.easeIn, O.swing = d.easing.Quad.easeInOut;
        var R = x("events.EventDispatcher", function (t) {
          this._listeners = {}, this._eventTarget = t || this;
        });
        f = R.prototype, f.addEventListener = function (t, e, i, r, n) {
          n = n || 0;
          var s,
              a,
              o = this._listeners[t],
              l = 0;

          for (this !== c || _ || c.wake(), null == o && (this._listeners[t] = o = []), a = o.length; --a > -1;) {
            s = o[a], s.c === e && s.s === i ? o.splice(a, 1) : 0 === l && s.pr < n && (l = a + 1);
          }

          o.splice(l, 0, {
            c: e,
            s: i,
            up: r,
            pr: n
          });
        }, f.removeEventListener = function (t, e) {
          var i,
              r = this._listeners[t];
          if (r) for (i = r.length; --i > -1;) {
            if (r[i].c === e) return void r.splice(i, 1);
          }
        }, f.dispatchEvent = function (t) {
          var e,
              i,
              r,
              n = this._listeners[t];
          if (n) for (e = n.length, e > 1 && (n = n.slice(0)), i = this._eventTarget; --e > -1;) {
            (r = n[e]) && (r.up ? r.c.call(r.s || i, {
              type: t,
              target: i
            }) : r.c.call(r.s || i));
          }
        };

        var A = i.requestAnimationFrame,
            k = i.cancelAnimationFrame,
            C = Date.now || function () {
          return new Date().getTime();
        },
            D = C();

        for (h = ["ms", "moz", "webkit", "o"], u = h.length; --u > -1 && !A;) {
          A = i[h[u] + "RequestAnimationFrame"], k = i[h[u] + "CancelAnimationFrame"] || i[h[u] + "CancelRequestAnimationFrame"];
        }

        x("Ticker", function (t, e) {
          var i,
              r,
              n,
              s,
              a,
              l = this,
              h = C(),
              u = !(!1 === e || !A) && "auto",
              f = 500,
              p = 33,
              d = function d(t) {
            var e,
                o,
                u = C() - D;
            u > f && (h += u - p), D += u, l.time = (D - h) / 1e3, e = l.time - a, (!i || e > 0 || !0 === t) && (l.frame++, a += e + (e >= s ? .004 : s - e), o = !0), !0 !== t && (n = r(d)), o && l.dispatchEvent("tick");
          };

          R.call(l), l.time = l.frame = 0, l.tick = function () {
            d(!0);
          }, l.lagSmoothing = function (t, e) {
            if (!arguments.length) return f < 1e10;
            f = t || 1e10, p = Math.min(e, f, 0);
          }, l.sleep = function () {
            null != n && (u && k ? k(n) : clearTimeout(n), r = g, n = null, l === c && (_ = !1));
          }, l.wake = function (t) {
            null !== n ? l.sleep() : t ? h += -D + (D = C()) : l.frame > 10 && (D = C() - f + 5), r = 0 === i ? g : u && A ? A : function (t) {
              return setTimeout(t, 1e3 * (a - l.time) + 1 | 0);
            }, l === c && (_ = !0), d(2);
          }, l.fps = function (t) {
            if (!arguments.length) return i;
            i = t, s = 1 / (i || 60), a = this.time + s, l.wake();
          }, l.useRAF = function (t) {
            if (!arguments.length) return u;
            l.sleep(), u = t, l.fps(i);
          }, l.fps(t), setTimeout(function () {
            "auto" === u && l.frame < 5 && "hidden" !== o.visibilityState && l.useRAF(!1);
          }, 1500);
        }), f = d.Ticker.prototype = new d.events.EventDispatcher(), f.constructor = d.Ticker;
        var E = x("core.Animation", function (t, e) {
          if (this.vars = e = e || {}, this._duration = this._totalDuration = t || 0, this._delay = Number(e.delay) || 0, this._timeScale = 1, this._active = !0 === e.immediateRender, this.data = e.data, this._reversed = !0 === e.reversed, K) {
            _ || c.wake();
            var i = this.vars.useFrames ? Q : K;
            i.add(this, i._time), this.vars.paused && this.paused(!0);
          }
        });
        c = E.ticker = new d.Ticker(), f = E.prototype, f._dirty = f._gc = f._initted = f._paused = !1, f._totalTime = f._time = 0, f._rawPrevTime = -1, f._next = f._last = f._onUpdate = f._timeline = f.timeline = null, f._paused = !1;

        var M = function M() {
          _ && C() - D > 2e3 && ("hidden" !== o.visibilityState || !c.lagSmoothing()) && c.wake();
          var t = setTimeout(M, 2e3);
          t.unref && t.unref();
        };

        M(), f.play = function (t, e) {
          return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
        }, f.pause = function (t, e) {
          return null != t && this.seek(t, e), this.paused(!0);
        }, f.resume = function (t, e) {
          return null != t && this.seek(t, e), this.paused(!1);
        }, f.seek = function (t, e) {
          return this.totalTime(Number(t), !1 !== e);
        }, f.restart = function (t, e) {
          return this.reversed(!1).paused(!1).totalTime(t ? -this._delay : 0, !1 !== e, !0);
        }, f.reverse = function (t, e) {
          return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
        }, f.render = function (t, e, i) {}, f.invalidate = function () {
          return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, !this._gc && this.timeline || this._enabled(!0), this;
        }, f.isActive = function () {
          var t,
              e = this._timeline,
              i = this._startTime;
          return !e || !this._gc && !this._paused && e.isActive() && (t = e.rawTime(!0)) >= i && t < i + this.totalDuration() / this._timeScale - 1e-7;
        }, f._enabled = function (t, e) {
          return _ || c.wake(), this._gc = !t, this._active = this.isActive(), !0 !== e && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1;
        }, f._kill = function (t, e) {
          return this._enabled(!1, !1);
        }, f.kill = function (t, e) {
          return this._kill(t, e), this;
        }, f._uncache = function (t) {
          for (var e = t ? this : this.timeline; e;) {
            e._dirty = !0, e = e.timeline;
          }

          return this;
        }, f._swapSelfInParams = function (t) {
          for (var e = t.length, i = t.concat(); --e > -1;) {
            "{self}" === t[e] && (i[e] = this);
          }

          return i;
        }, f._callback = function (t) {
          var e = this.vars,
              i = e[t],
              r = e[t + "Params"],
              n = e[t + "Scope"] || e.callbackScope || this;

          switch (r ? r.length : 0) {
            case 0:
              i.call(n);
              break;

            case 1:
              i.call(n, r[0]);
              break;

            case 2:
              i.call(n, r[0], r[1]);
              break;

            default:
              i.apply(n, r);
          }
        }, f.eventCallback = function (t, e, i, r) {
          if ("on" === (t || "").substr(0, 2)) {
            var n = this.vars;
            if (1 === arguments.length) return n[t];
            null == e ? delete n[t] : (n[t] = e, n[t + "Params"] = y(i) && -1 !== i.join("").indexOf("{self}") ? this._swapSelfInParams(i) : i, n[t + "Scope"] = r), "onUpdate" === t && (this._onUpdate = e);
          }

          return this;
        }, f.delay = function (t) {
          return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), this._delay = t, this) : this._delay;
        }, f.duration = function (t) {
          return arguments.length ? (this._duration = this._totalDuration = t, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== t && this.totalTime(this._totalTime * (t / this._duration), !0), this) : (this._dirty = !1, this._duration);
        }, f.totalDuration = function (t) {
          return this._dirty = !1, arguments.length ? this.duration(t) : this._totalDuration;
        }, f.time = function (t, e) {
          return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time;
        }, f.totalTime = function (t, e, i) {
          if (_ || c.wake(), !arguments.length) return this._totalTime;

          if (this._timeline) {
            if (t < 0 && !i && (t += this.totalDuration()), this._timeline.smoothChildTiming) {
              this._dirty && this.totalDuration();
              var r = this._totalDuration,
                  n = this._timeline;
              if (t > r && !i && (t = r), this._startTime = (this._paused ? this._pauseTime : n._time) - (this._reversed ? r - t : t) / this._timeScale, n._dirty || this._uncache(!1), n._timeline) for (; n._timeline;) {
                n._timeline._time !== (n._startTime + n._totalTime) / n._timeScale && n.totalTime(n._totalTime, !0), n = n._timeline;
              }
            }

            this._gc && this._enabled(!0, !1), this._totalTime === t && 0 !== this._duration || (N.length && tt(), this.render(t, e, !1), N.length && tt());
          }

          return this;
        }, f.progress = f.totalProgress = function (t, e) {
          var i = this.duration();
          return arguments.length ? this.totalTime(i * t, e) : i ? this._time / i : this.ratio;
        }, f.startTime = function (t) {
          return arguments.length ? (t !== this._startTime && (this._startTime = t, this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime;
        }, f.endTime = function (t) {
          return this._startTime + (0 != t ? this.totalDuration() : this.duration()) / this._timeScale;
        }, f.timeScale = function (t) {
          if (!arguments.length) return this._timeScale;
          var e, i;

          for (t = t || 1e-10, this._timeline && this._timeline.smoothChildTiming && (e = this._pauseTime, i = e || 0 === e ? e : this._timeline.totalTime(), this._startTime = i - (i - this._startTime) * this._timeScale / t), this._timeScale = t, i = this.timeline; i && i.timeline;) {
            i._dirty = !0, i.totalDuration(), i = i.timeline;
          }

          return this;
        }, f.reversed = function (t) {
          return arguments.length ? (t != this._reversed && (this._reversed = t, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed;
        }, f.paused = function (t) {
          if (!arguments.length) return this._paused;
          var e,
              i,
              r = this._timeline;
          return t != this._paused && r && (_ || t || c.wake(), e = r.rawTime(), i = e - this._pauseTime, !t && r.smoothChildTiming && (this._startTime += i, this._uncache(!1)), this._pauseTime = t ? e : null, this._paused = t, this._active = this.isActive(), !t && 0 !== i && this._initted && this.duration() && (e = r.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale, this.render(e, e === this._totalTime, !0))), this._gc && !t && this._enabled(!0, !1), this;
        };
        var F = x("core.SimpleTimeline", function (t) {
          E.call(this, 0, t), this.autoRemoveChildren = this.smoothChildTiming = !0;
        });
        f = F.prototype = new E(), f.constructor = F, f.kill()._gc = !1, f._first = f._last = f._recent = null, f._sortChildren = !1, f.add = f.insert = function (t, e, i, r) {
          var n, s;
          if (t._startTime = Number(e || 0) + t._delay, t._paused && this !== t._timeline && (t._pauseTime = t._startTime + (this.rawTime() - t._startTime) / t._timeScale), t.timeline && t.timeline._remove(t, !0), t.timeline = t._timeline = this, t._gc && t._enabled(!0, !0), n = this._last, this._sortChildren) for (s = t._startTime; n && n._startTime > s;) {
            n = n._prev;
          }
          return n ? (t._next = n._next, n._next = t) : (t._next = this._first, this._first = t), t._next ? t._next._prev = t : this._last = t, t._prev = n, this._recent = t, this._timeline && this._uncache(!0), this;
        }, f._remove = function (t, e) {
          return t.timeline === this && (e || t._enabled(!1, !0), t._prev ? t._prev._next = t._next : this._first === t && (this._first = t._next), t._next ? t._next._prev = t._prev : this._last === t && (this._last = t._prev), t._next = t._prev = t.timeline = null, t === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this;
        }, f.render = function (t, e, i) {
          var r,
              n = this._first;

          for (this._totalTime = this._time = this._rawPrevTime = t; n;) {
            r = n._next, (n._active || t >= n._startTime && !n._paused && !n._gc) && (n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)), n = r;
          }
        }, f.rawTime = function () {
          return _ || c.wake(), this._totalTime;
        };

        var L = x("TweenLite", function (t, e, r) {
          if (E.call(this, e, r), this.render = L.prototype.render, null == t) throw "Cannot tween a null target.";
          this.target = t = "string" !== typeof t ? t : L.selector(t) || t;
          var n,
              s,
              a,
              o = t.jquery || t.length && t !== i && t[0] && (t[0] === i || t[0].nodeType && t[0].style && !t.nodeType),
              l = this.vars.overwrite;
          if (this._overwrite = l = null == l ? $[L.defaultOverwrite] : "number" === typeof l ? l >> 0 : $[l], (o || t instanceof Array || t.push && y(t)) && "number" !== typeof t[0]) for (this._targets = a = m(t), this._propLookup = [], this._siblings = [], n = 0; n < a.length; n++) {
            s = a[n], s ? "string" !== typeof s ? s.length && s !== i && s[0] && (s[0] === i || s[0].nodeType && s[0].style && !s.nodeType) ? (a.splice(n--, 1), this._targets = a = a.concat(m(s))) : (this._siblings[n] = et(s, this, !1), 1 === l && this._siblings[n].length > 1 && rt(s, this, null, 1, this._siblings[n])) : "string" === typeof (s = a[n--] = L.selector(s)) && a.splice(n + 1, 1) : a.splice(n--, 1);
          } else this._propLookup = {}, this._siblings = et(t, this, !1), 1 === l && this._siblings.length > 1 && rt(t, this, null, 1, this._siblings);
          (this.vars.immediateRender || 0 === e && 0 === this._delay && !1 !== this.vars.immediateRender) && (this._time = -1e-10, this.render(Math.min(0, -this._delay)));
        }, !0),
            j = function j(t) {
          return t && t.length && t !== i && t[0] && (t[0] === i || t[0].nodeType && t[0].style && !t.nodeType);
        },
            I = function I(t, e) {
          var i,
              r = {};

          for (i in t) {
            Z[i] || i in e && "transform" !== i && "x" !== i && "y" !== i && "width" !== i && "height" !== i && "className" !== i && "border" !== i || !(!W[i] || W[i] && W[i]._autoCSS) || (r[i] = t[i], delete t[i]);
          }

          t.css = r;
        };

        f = L.prototype = new E(), f.constructor = L, f.kill()._gc = !1, f.ratio = 0, f._firstPT = f._targets = f._overwrittenProps = f._startAt = null, f._notifyPluginsOfEnabled = f._lazy = !1, L.version = "1.20.3", L.defaultEase = f._ease = new P(null, null, 1, 1), L.defaultOverwrite = "auto", L.ticker = c, L.autoSleep = 120, L.lagSmoothing = function (t, e) {
          c.lagSmoothing(t, e);
        }, L.selector = i.$ || i.jQuery || function (t) {
          var e = i.$ || i.jQuery;
          return e ? (L.selector = e, e(t)) : "undefined" === typeof o ? t : o.querySelectorAll ? o.querySelectorAll(t) : o.getElementById("#" === t.charAt(0) ? t.substr(1) : t);
        };

        var N = [],
            z = {},
            B = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
            X = /[\+-]=-?[\.\d]/,
            U = function U(t) {
          for (var e, i = this._firstPT; i;) {
            e = i.blob ? 1 === t && null != this.end ? this.end : t ? this.join("") : this.start : i.c * t + i.s, i.m ? e = i.m(e, this._target || i.t) : e < 1e-6 && e > -1e-6 && !i.blob && (e = 0), i.f ? i.fp ? i.t[i.p](i.fp, e) : i.t[i.p](e) : i.t[i.p] = e, i = i._next;
          }
        },
            Y = function Y(t, e, i, r) {
          var n,
              s,
              a,
              o,
              l,
              h,
              u,
              f = [],
              c = 0,
              _ = "",
              p = 0;

          for (f.start = t, f.end = e, t = f[0] = t + "", e = f[1] = e + "", i && (i(f), t = f[0], e = f[1]), f.length = 0, n = t.match(B) || [], s = e.match(B) || [], r && (r._next = null, r.blob = 1, f._firstPT = f._applyPT = r), l = s.length, o = 0; o < l; o++) {
            u = s[o], h = e.substr(c, e.indexOf(u, c) - c), _ += h || !o ? h : ",", c += h.length, p ? p = (p + 1) % 5 : "rgba(" === h.substr(-5) && (p = 1), u === n[o] || n.length <= o ? _ += u : (_ && (f.push(_), _ = ""), a = parseFloat(n[o]), f.push(a), f._firstPT = {
              _next: f._firstPT,
              t: f,
              p: f.length - 1,
              s: a,
              c: ("=" === u.charAt(1) ? parseInt(u.charAt(0) + "1", 10) * parseFloat(u.substr(2)) : parseFloat(u) - a) || 0,
              f: 0,
              m: p && p < 4 ? Math.round : 0
            }), c += u.length;
          }

          return _ += e.substr(c), _ && f.push(_), f.setRatio = U, X.test(e) && (f.end = null), f;
        },
            q = function q(t, e, i, r, n, s, a, o, l) {
          "function" === typeof r && (r = r(l || 0, t));

          var h,
              u = typeof t[e],
              f = "function" !== u ? "" : e.indexOf("set") || "function" !== typeof t["get" + e.substr(3)] ? e : "get" + e.substr(3),
              c = "get" !== i ? i : f ? a ? t[f](a) : t[f]() : t[e],
              _ = "string" === typeof r && "=" === r.charAt(1),
              p = {
            t: t,
            p: e,
            s: c,
            f: "function" === u,
            pg: 0,
            n: n || e,
            m: s ? "function" === typeof s ? s : Math.round : 0,
            pr: 0,
            c: _ ? parseInt(r.charAt(0) + "1", 10) * parseFloat(r.substr(2)) : parseFloat(r) - c || 0
          };

          if (("number" !== typeof c || "number" !== typeof r && !_) && (a || isNaN(c) || !_ && isNaN(r) || "boolean" === typeof c || "boolean" === typeof r ? (p.fp = a, h = Y(c, _ ? parseFloat(p.s) + p.c : r, o || L.defaultStringFilter, p), p = {
            t: h,
            p: "setRatio",
            s: 0,
            c: 1,
            f: 2,
            pg: 0,
            n: n || e,
            pr: 0,
            m: 0
          }) : (p.s = parseFloat(c), _ || (p.c = parseFloat(r) - p.s || 0))), p.c) return (p._next = this._firstPT) && (p._next._prev = p), this._firstPT = p, p;
        },
            V = L._internals = {
          isArray: y,
          isSelector: j,
          lazyTweens: N,
          blobDif: Y
        },
            W = L._plugins = {},
            H = V.tweenLookup = {},
            G = 0,
            Z = V.reservedProps = {
          ease: 1,
          delay: 1,
          overwrite: 1,
          onComplete: 1,
          onCompleteParams: 1,
          onCompleteScope: 1,
          useFrames: 1,
          runBackwards: 1,
          startAt: 1,
          onUpdate: 1,
          onUpdateParams: 1,
          onUpdateScope: 1,
          onStart: 1,
          onStartParams: 1,
          onStartScope: 1,
          onReverseComplete: 1,
          onReverseCompleteParams: 1,
          onReverseCompleteScope: 1,
          onRepeat: 1,
          onRepeatParams: 1,
          onRepeatScope: 1,
          easeParams: 1,
          yoyo: 1,
          immediateRender: 1,
          repeat: 1,
          repeatDelay: 1,
          data: 1,
          paused: 1,
          reversed: 1,
          autoCSS: 1,
          lazy: 1,
          onOverwrite: 1,
          callbackScope: 1,
          stringFilter: 1,
          id: 1,
          yoyoEase: 1
        },
            $ = {
          none: 0,
          all: 1,
          auto: 2,
          concurrent: 3,
          allOnStart: 4,
          preexisting: 5,
          true: 1,
          false: 0
        },
            Q = E._rootFramesTimeline = new F(),
            K = E._rootTimeline = new F(),
            J = 30,
            tt = V.lazyRender = function () {
          var t,
              e = N.length;

          for (z = {}; --e > -1;) {
            (t = N[e]) && !1 !== t._lazy && (t.render(t._lazy[0], t._lazy[1], !0), t._lazy = !1);
          }

          N.length = 0;
        };

        K._startTime = c.time, Q._startTime = c.frame, K._active = Q._active = !0, setTimeout(tt, 1), E._updateRoot = L.render = function () {
          var t, e, i;

          if (N.length && tt(), K.render((c.time - K._startTime) * K._timeScale, !1, !1), Q.render((c.frame - Q._startTime) * Q._timeScale, !1, !1), N.length && tt(), c.frame >= J) {
            J = c.frame + (parseInt(L.autoSleep, 10) || 120);

            for (i in H) {
              for (e = H[i].tweens, t = e.length; --t > -1;) {
                e[t]._gc && e.splice(t, 1);
              }

              0 === e.length && delete H[i];
            }

            if ((!(i = K._first) || i._paused) && L.autoSleep && !Q._first && 1 === c._listeners.tick.length) {
              for (; i && i._paused;) {
                i = i._next;
              }

              i || c.sleep();
            }
          }
        }, c.addEventListener("tick", E._updateRoot);

        var et = function et(t, e, i) {
          var r,
              n,
              s = t._gsTweenID;
          if (H[s || (t._gsTweenID = s = "t" + G++)] || (H[s] = {
            target: t,
            tweens: []
          }), e && (r = H[s].tweens, r[n = r.length] = e, i)) for (; --n > -1;) {
            r[n] === e && r.splice(n, 1);
          }
          return H[s].tweens;
        },
            it = function it(t, e, i, r) {
          var n,
              s,
              a = t.vars.onOverwrite;
          return a && (n = a(t, e, i, r)), a = L.onOverwrite, a && (s = a(t, e, i, r)), !1 !== n && !1 !== s;
        },
            rt = function rt(t, e, i, r, n) {
          var s, a, o, l;

          if (1 === r || r >= 4) {
            for (l = n.length, s = 0; s < l; s++) {
              if ((o = n[s]) !== e) o._gc || o._kill(null, t, e) && (a = !0);else if (5 === r) break;
            }

            return a;
          }

          var h,
              u = e._startTime + 1e-10,
              f = [],
              c = 0,
              _ = 0 === e._duration;

          for (s = n.length; --s > -1;) {
            (o = n[s]) === e || o._gc || o._paused || (o._timeline !== e._timeline ? (h = h || nt(e, 0, _), 0 === nt(o, h, _) && (f[c++] = o)) : o._startTime <= u && o._startTime + o.totalDuration() / o._timeScale > u && ((_ || !o._initted) && u - o._startTime <= 2e-10 || (f[c++] = o)));
          }

          for (s = c; --s > -1;) {
            if (o = f[s], 2 === r && o._kill(i, t, e) && (a = !0), 2 !== r || !o._firstPT && o._initted) {
              if (2 !== r && !it(o, e)) continue;
              o._enabled(!1, !1) && (a = !0);
            }
          }

          return a;
        },
            nt = function nt(t, e, i) {
          for (var r = t._timeline, n = r._timeScale, s = t._startTime; r._timeline;) {
            if (s += r._startTime, n *= r._timeScale, r._paused) return -100;
            r = r._timeline;
          }

          return s /= n, s > e ? s - e : i && s === e || !t._initted && s - e < 2e-10 ? 1e-10 : (s += t.totalDuration() / t._timeScale / n) > e + 1e-10 ? 0 : s - e - 1e-10;
        };

        f._init = function () {
          var t,
              e,
              i,
              r,
              n,
              s,
              a = this.vars,
              o = this._overwrittenProps,
              l = this._duration,
              h = !!a.immediateRender,
              u = a.ease;

          if (a.startAt) {
            this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), n = {};

            for (r in a.startAt) {
              n[r] = a.startAt[r];
            }

            if (n.data = "isStart", n.overwrite = !1, n.immediateRender = !0, n.lazy = h && !1 !== a.lazy, n.startAt = n.delay = null, n.onUpdate = a.onUpdate, n.onUpdateParams = a.onUpdateParams, n.onUpdateScope = a.onUpdateScope || a.callbackScope || this, this._startAt = L.to(this.target, 0, n), h) if (this._time > 0) this._startAt = null;else if (0 !== l) return;
          } else if (a.runBackwards && 0 !== l) if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null;else {
            0 !== this._time && (h = !1), i = {};

            for (r in a) {
              Z[r] && "autoCSS" !== r || (i[r] = a[r]);
            }

            if (i.overwrite = 0, i.data = "isFromStart", i.lazy = h && !1 !== a.lazy, i.immediateRender = h, this._startAt = L.to(this.target, 0, i), h) {
              if (0 === this._time) return;
            } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
          }

          if (this._ease = u = u ? u instanceof P ? u : "function" === typeof u ? new P(u, a.easeParams) : O[u] || L.defaultEase : L.defaultEase, a.easeParams instanceof Array && u.config && (this._ease = u.config.apply(u, a.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets) for (s = this._targets.length, t = 0; t < s; t++) {
            this._initProps(this._targets[t], this._propLookup[t] = {}, this._siblings[t], o ? o[t] : null, t) && (e = !0);
          } else e = this._initProps(this.target, this._propLookup, this._siblings, o, 0);
          if (e && L._onPluginEvent("_onInitAllProps", this), o && (this._firstPT || "function" !== typeof this.target && this._enabled(!1, !1)), a.runBackwards) for (i = this._firstPT; i;) {
            i.s += i.c, i.c = -i.c, i = i._next;
          }
          this._onUpdate = a.onUpdate, this._initted = !0;
        }, f._initProps = function (t, e, r, n, s) {
          var a, o, l, h, u, f;
          if (null == t) return !1;
          z[t._gsTweenID] && tt(), this.vars.css || t.style && t !== i && t.nodeType && W.css && !1 !== this.vars.autoCSS && I(this.vars, t);

          for (a in this.vars) {
            if (f = this.vars[a], Z[a]) f && (f instanceof Array || f.push && y(f)) && -1 !== f.join("").indexOf("{self}") && (this.vars[a] = f = this._swapSelfInParams(f, this));else if (W[a] && (h = new W[a]())._onInitTween(t, this.vars[a], this, s)) {
              for (this._firstPT = u = {
                _next: this._firstPT,
                t: h,
                p: "setRatio",
                s: 0,
                c: 1,
                f: 1,
                n: a,
                pg: 1,
                pr: h._priority,
                m: 0
              }, o = h._overwriteProps.length; --o > -1;) {
                e[h._overwriteProps[o]] = this._firstPT;
              }

              (h._priority || h._onInitAllProps) && (l = !0), (h._onDisable || h._onEnable) && (this._notifyPluginsOfEnabled = !0), u._next && (u._next._prev = u);
            } else e[a] = q.call(this, t, a, "get", f, a, 0, null, this.vars.stringFilter, s);
          }

          return n && this._kill(n, t) ? this._initProps(t, e, r, n, s) : this._overwrite > 1 && this._firstPT && r.length > 1 && rt(t, this, e, this._overwrite, r) ? (this._kill(e, t), this._initProps(t, e, r, n, s)) : (this._firstPT && (!1 !== this.vars.lazy && this._duration || this.vars.lazy && !this._duration) && (z[t._gsTweenID] = !0), l);
        }, f.render = function (t, e, i) {
          var r,
              n,
              s,
              a,
              o = this._time,
              l = this._duration,
              h = this._rawPrevTime;
          if (t >= l - 1e-7 && t >= 0) this._totalTime = this._time = l, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (r = !0, n = "onComplete", i = i || this._timeline.autoRemoveChildren), 0 === l && (this._initted || !this.vars.lazy || i) && (this._startTime === this._timeline._duration && (t = 0), (h < 0 || t <= 0 && t >= -1e-7 || 1e-10 === h && "isPause" !== this.data) && h !== t && (i = !0, h > 1e-10 && (n = "onReverseComplete")), this._rawPrevTime = a = !e || t || h === t ? t : 1e-10);else if (t < 1e-7) this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== o || 0 === l && h > 0) && (n = "onReverseComplete", r = this._reversed), t < 0 && (this._active = !1, 0 === l && (this._initted || !this.vars.lazy || i) && (h >= 0 && (1e-10 !== h || "isPause" !== this.data) && (i = !0), this._rawPrevTime = a = !e || t || h === t ? t : 1e-10)), (!this._initted || this._startAt && this._startAt.progress()) && (i = !0);else if (this._totalTime = this._time = t, this._easeType) {
            var u = t / l,
                f = this._easeType,
                c = this._easePower;
            (1 === f || 3 === f && u >= .5) && (u = 1 - u), 3 === f && (u *= 2), 1 === c ? u *= u : 2 === c ? u *= u * u : 3 === c ? u *= u * u * u : 4 === c && (u *= u * u * u * u), this.ratio = 1 === f ? 1 - u : 2 === f ? u : t / l < .5 ? u / 2 : 1 - u / 2;
          } else this.ratio = this._ease.getRatio(t / l);

          if (this._time !== o || i) {
            if (!this._initted) {
              if (this._init(), !this._initted || this._gc) return;
              if (!i && this._firstPT && (!1 !== this.vars.lazy && this._duration || this.vars.lazy && !this._duration)) return this._time = this._totalTime = o, this._rawPrevTime = h, N.push(this), void (this._lazy = [t, e]);
              this._time && !r ? this.ratio = this._ease.getRatio(this._time / l) : r && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1));
            }

            for (!1 !== this._lazy && (this._lazy = !1), this._active || !this._paused && this._time !== o && t >= 0 && (this._active = !0), 0 === o && (this._startAt && (t >= 0 ? this._startAt.render(t, !0, i) : n || (n = "_dummyGS")), this.vars.onStart && (0 === this._time && 0 !== l || e || this._callback("onStart"))), s = this._firstPT; s;) {
              s.f ? s.t[s.p](s.c * this.ratio + s.s) : s.t[s.p] = s.c * this.ratio + s.s, s = s._next;
            }

            this._onUpdate && (t < 0 && this._startAt && -1e-4 !== t && this._startAt.render(t, !0, i), e || (this._time !== o || r || i) && this._callback("onUpdate")), n && (this._gc && !i || (t < 0 && this._startAt && !this._onUpdate && -1e-4 !== t && this._startAt.render(t, !0, i), r && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[n] && this._callback(n), 0 === l && 1e-10 === this._rawPrevTime && 1e-10 !== a && (this._rawPrevTime = 0)));
          }
        }, f._kill = function (t, e, i) {
          if ("all" === t && (t = null), null == t && (null == e || e === this.target)) return this._lazy = !1, this._enabled(!1, !1);
          e = "string" !== typeof e ? e || this._targets || this.target : L.selector(e) || e;
          var r,
              n,
              s,
              a,
              o,
              l,
              h,
              u,
              f,
              c = i && this._time && i._startTime === this._startTime && this._timeline === i._timeline;
          if ((y(e) || j(e)) && "number" !== typeof e[0]) for (r = e.length; --r > -1;) {
            this._kill(t, e[r], i) && (l = !0);
          } else {
            if (this._targets) {
              for (r = this._targets.length; --r > -1;) {
                if (e === this._targets[r]) {
                  o = this._propLookup[r] || {}, this._overwrittenProps = this._overwrittenProps || [], n = this._overwrittenProps[r] = t ? this._overwrittenProps[r] || {} : "all";
                  break;
                }
              }
            } else {
              if (e !== this.target) return !1;
              o = this._propLookup, n = this._overwrittenProps = t ? this._overwrittenProps || {} : "all";
            }

            if (o) {
              if (h = t || o, u = t !== n && "all" !== n && t !== o && ("object" !== typeof t || !t._tempKill), i && (L.onOverwrite || this.vars.onOverwrite)) {
                for (s in h) {
                  o[s] && (f || (f = []), f.push(s));
                }

                if ((f || !t) && !it(this, i, e, f)) return !1;
              }

              for (s in h) {
                (a = o[s]) && (c && (a.f ? a.t[a.p](a.s) : a.t[a.p] = a.s, l = !0), a.pg && a.t._kill(h) && (l = !0), a.pg && 0 !== a.t._overwriteProps.length || (a._prev ? a._prev._next = a._next : a === this._firstPT && (this._firstPT = a._next), a._next && (a._next._prev = a._prev), a._next = a._prev = null), delete o[s]), u && (n[s] = 1);
              }

              !this._firstPT && this._initted && this._enabled(!1, !1);
            }
          }
          return l;
        }, f.invalidate = function () {
          return this._notifyPluginsOfEnabled && L._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], E.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -1e-10, this.render(Math.min(0, -this._delay))), this;
        }, f._enabled = function (t, e) {
          if (_ || c.wake(), t && this._gc) {
            var i,
                r = this._targets;
            if (r) for (i = r.length; --i > -1;) {
              this._siblings[i] = et(r[i], this, !0);
            } else this._siblings = et(this.target, this, !0);
          }

          return E.prototype._enabled.call(this, t, e), !(!this._notifyPluginsOfEnabled || !this._firstPT) && L._onPluginEvent(t ? "_onEnable" : "_onDisable", this);
        }, L.to = function (t, e, i) {
          return new L(t, e, i);
        }, L.from = function (t, e, i) {
          return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, new L(t, e, i);
        }, L.fromTo = function (t, e, i, r) {
          return r.startAt = i, r.immediateRender = 0 != r.immediateRender && 0 != i.immediateRender, new L(t, e, r);
        }, L.delayedCall = function (t, e, i, r, n) {
          return new L(e, 0, {
            delay: t,
            onComplete: e,
            onCompleteParams: i,
            callbackScope: r,
            onReverseComplete: e,
            onReverseCompleteParams: i,
            immediateRender: !1,
            lazy: !1,
            useFrames: n,
            overwrite: 0
          });
        }, L.set = function (t, e) {
          return new L(t, 0, e);
        }, L.getTweensOf = function (t, e) {
          if (null == t) return [];
          t = "string" !== typeof t ? t : L.selector(t) || t;
          var i, r, n, s;

          if ((y(t) || j(t)) && "number" !== typeof t[0]) {
            for (i = t.length, r = []; --i > -1;) {
              r = r.concat(L.getTweensOf(t[i], e));
            }

            for (i = r.length; --i > -1;) {
              for (s = r[i], n = i; --n > -1;) {
                s === r[n] && r.splice(i, 1);
              }
            }
          } else if (t._gsTweenID) for (r = et(t).concat(), i = r.length; --i > -1;) {
            (r[i]._gc || e && !r[i].isActive()) && r.splice(i, 1);
          }

          return r || [];
        }, L.killTweensOf = L.killDelayedCallsTo = function (t, e, i) {
          "object" === typeof e && (i = e, e = !1);

          for (var r = L.getTweensOf(t, e), n = r.length; --n > -1;) {
            r[n]._kill(i, t);
          }
        };
        var st = x("plugins.TweenPlugin", function (t, e) {
          this._overwriteProps = (t || "").split(","), this._propName = this._overwriteProps[0], this._priority = e || 0, this._super = st.prototype;
        }, !0);

        if (f = st.prototype, st.version = "1.19.0", st.API = 2, f._firstPT = null, f._addTween = q, f.setRatio = U, f._kill = function (t) {
          var e,
              i = this._overwriteProps,
              r = this._firstPT;
          if (null != t[this._propName]) this._overwriteProps = [];else for (e = i.length; --e > -1;) {
            null != t[i[e]] && i.splice(e, 1);
          }

          for (; r;) {
            null != t[r.n] && (r._next && (r._next._prev = r._prev), r._prev ? (r._prev._next = r._next, r._prev = null) : this._firstPT === r && (this._firstPT = r._next)), r = r._next;
          }

          return !1;
        }, f._mod = f._roundProps = function (t) {
          for (var e, i = this._firstPT; i;) {
            e = t[this._propName] || null != i.n && t[i.n.split(this._propName + "_").join("")], e && "function" === typeof e && (2 === i.f ? i.t._applyPT.m = e : i.m = e), i = i._next;
          }
        }, L._onPluginEvent = function (t, e) {
          var i,
              r,
              n,
              s,
              a,
              o = e._firstPT;

          if ("_onInitAllProps" === t) {
            for (; o;) {
              for (a = o._next, r = n; r && r.pr > o.pr;) {
                r = r._next;
              }

              (o._prev = r ? r._prev : s) ? o._prev._next = o : n = o, (o._next = r) ? r._prev = o : s = o, o = a;
            }

            o = e._firstPT = n;
          }

          for (; o;) {
            o.pg && "function" === typeof o.t[t] && o.t[t]() && (i = !0), o = o._next;
          }

          return i;
        }, st.activate = function (t) {
          for (var e = t.length; --e > -1;) {
            t[e].API === st.API && (W[new t[e]()._propName] = t[e]);
          }

          return !0;
        }, T.plugin = function (t) {
          if (!t || !t.propName || !t.init || !t.API) throw "illegal plugin definition.";
          var e,
              i = t.propName,
              r = t.priority || 0,
              n = t.overwriteProps,
              s = {
            init: "_onInitTween",
            set: "setRatio",
            kill: "_kill",
            round: "_mod",
            mod: "_mod",
            initAll: "_onInitAllProps"
          },
              a = x("plugins." + i.charAt(0).toUpperCase() + i.substr(1) + "Plugin", function () {
            st.call(this, i, r), this._overwriteProps = n || [];
          }, !0 === t.global),
              o = a.prototype = new st(i);
          o.constructor = a, a.API = t.API;

          for (e in s) {
            "function" === typeof t[e] && (o[s[e]] = t[e]);
          }

          return a.version = t.version, st.activate([a]), a;
        }, h = i._gsQueue) {
          for (u = 0; u < h.length; u++) {
            h[u]();
          }

          for (f in v) {
            v[f].func || i.console.log("GSAP encountered missing dependency: " + f);
          }
        }

        _ = !1;
      }
    }("undefined" !== typeof t && t.exports && "undefined" !== typeof i ? i : this || window);
  }).call(e, i(0));
}, function (t, e, i) {
  (function (i) {
    var r, n;
    !function (i, s) {
      "use strict";

      r = [], void 0 !== (n = function () {
        return s.apply(i);
      }.apply(e, r)) && (t.exports = n);
    }("object" === typeof i ? i : this, function () {
      "use strict";

      function t(t) {
        return null !== t && t === t.window;
      }

      function e(e) {
        return t(e) ? e : 9 === e.nodeType && e.defaultView;
      }

      function i(t) {
        var e = typeof t;
        return "function" === e || "object" === e && !!t;
      }

      function r(t) {
        return i(t) && t.nodeType > 0;
      }

      function n(t) {
        var e = c.call(t);
        return "[object String]" === e ? f(t) : i(t) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(e) && t.hasOwnProperty("length") ? t : r(t) ? [t] : [];
      }

      function s(t) {
        var i,
            r,
            n = {
          top: 0,
          left: 0
        },
            s = t && t.ownerDocument;
        return i = s.documentElement, "undefined" !== typeof t.getBoundingClientRect && (n = t.getBoundingClientRect()), r = e(s), {
          top: n.top + r.pageYOffset - i.clientTop,
          left: n.left + r.pageXOffset - i.clientLeft
        };
      }

      function a(t) {
        var e = "";

        for (var i in t) {
          t.hasOwnProperty(i) && (e += i + ":" + t[i] + ";");
        }

        return e;
      }

      function o(t, e, i) {
        if (i) {
          i.classList.remove("waves-rippling");
          var r = i.getAttribute("data-x"),
              n = i.getAttribute("data-y"),
              s = i.getAttribute("data-scale"),
              o = i.getAttribute("data-translate"),
              l = Date.now() - Number(i.getAttribute("data-hold")),
              h = 350 - l;
          h < 0 && (h = 0), "mousemove" === t.type && (h = 150);
          var u = "mousemove" === t.type ? 2500 : p.duration;
          setTimeout(function () {
            var t = {
              top: n + "px",
              left: r + "px",
              opacity: "0",
              "-webkit-transition-duration": u + "ms",
              "-moz-transition-duration": u + "ms",
              "-o-transition-duration": u + "ms",
              "transition-duration": u + "ms",
              "-webkit-transform": s + " " + o,
              "-moz-transform": s + " " + o,
              "-ms-transform": s + " " + o,
              "-o-transform": s + " " + o,
              transform: s + " " + o
            };
            i.setAttribute("style", a(t)), setTimeout(function () {
              try {
                e.removeChild(i);
              } catch (t) {
                return !1;
              }
            }, u);
          }, h);
        }
      }

      function l(t) {
        if (!1 === m.allowEvent(t)) return null;

        for (var e = null, i = t.target || t.srcElement; null !== i.parentElement;) {
          if (i.classList.contains("waves-effect") && !(i instanceof SVGElement)) {
            e = i;
            break;
          }

          i = i.parentElement;
        }

        return e;
      }

      function h(t) {
        var e = l(t);

        if (null !== e) {
          if (e.disabled || e.getAttribute("disabled") || e.classList.contains("disabled")) return;

          if (m.registerEvent(t), "touchstart" === t.type && p.delay) {
            var i = !1,
                r = setTimeout(function () {
              r = null, p.show(t, e);
            }, p.delay),
                n = function n(_n) {
              r && (clearTimeout(r), r = null, p.show(t, e)), i || (i = !0, p.hide(_n, e));
            },
                s = function s(t) {
              r && (clearTimeout(r), r = null), n(t);
            };

            e.addEventListener("touchmove", s, !1), e.addEventListener("touchend", n, !1), e.addEventListener("touchcancel", n, !1);
          } else p.show(t, e), _ && (e.addEventListener("touchend", p.hide, !1), e.addEventListener("touchcancel", p.hide, !1)), e.addEventListener("mouseup", p.hide, !1), e.addEventListener("mouseleave", p.hide, !1);
        }
      }

      var u = u || {},
          f = document.querySelectorAll.bind(document),
          c = Object.prototype.toString,
          _ = "ontouchstart" in window,
          p = {
        duration: 750,
        delay: 200,
        show: function show(t, e, i) {
          if (2 === t.button) return !1;
          e = e || this;
          var r = document.createElement("div");
          r.className = "waves-ripple waves-rippling", e.appendChild(r);
          var n = s(e),
              o = 0,
              l = 0;
          "touches" in t && t.touches.length ? (o = t.touches[0].pageY - n.top, l = t.touches[0].pageX - n.left) : (o = t.pageY - n.top, l = t.pageX - n.left), l = l >= 0 ? l : 0, o = o >= 0 ? o : 0;
          var h = "scale(" + e.clientWidth / 100 * 3 + ")",
              u = "translate(0,0)";
          i && (u = "translate(" + i.x + "px, " + i.y + "px)"), r.setAttribute("data-hold", Date.now()), r.setAttribute("data-x", l), r.setAttribute("data-y", o), r.setAttribute("data-scale", h), r.setAttribute("data-translate", u);
          var f = {
            top: o + "px",
            left: l + "px"
          };
          r.classList.add("waves-notransition"), r.setAttribute("style", a(f)), r.classList.remove("waves-notransition"), f["-webkit-transform"] = h + " " + u, f["-moz-transform"] = h + " " + u, f["-ms-transform"] = h + " " + u, f["-o-transform"] = h + " " + u, f.transform = h + " " + u, f.opacity = "1";
          var c = "mousemove" === t.type ? 2500 : p.duration;
          f["-webkit-transition-duration"] = c + "ms", f["-moz-transition-duration"] = c + "ms", f["-o-transition-duration"] = c + "ms", f["transition-duration"] = c + "ms", r.setAttribute("style", a(f));
        },
        hide: function hide(t, e) {
          e = e || this;

          for (var i = e.getElementsByClassName("waves-rippling"), r = 0, n = i.length; r < n; r++) {
            o(t, e, i[r]);
          }
        }
      },
          d = {
        input: function input(t) {
          var e = t.parentNode;

          if ("i" !== e.tagName.toLowerCase() || !e.classList.contains("waves-effect")) {
            var i = document.createElement("i");
            i.className = t.className + " waves-input-wrapper", t.className = "waves-button-input", e.replaceChild(i, t), i.appendChild(t);
            var r = window.getComputedStyle(t, null),
                n = r.color,
                s = r.backgroundColor;
            i.setAttribute("style", "color:" + n + ";background:" + s), t.setAttribute("style", "background-color:rgba(0,0,0,0);");
          }
        },
        img: function img(t) {
          var e = t.parentNode;

          if ("i" !== e.tagName.toLowerCase() || !e.classList.contains("waves-effect")) {
            var i = document.createElement("i");
            e.replaceChild(i, t), i.appendChild(t);
          }
        }
      },
          m = {
        touches: 0,
        allowEvent: function allowEvent(t) {
          var e = !0;
          return /^(mousedown|mousemove)$/.test(t.type) && m.touches && (e = !1), e;
        },
        registerEvent: function registerEvent(t) {
          var e = t.type;
          "touchstart" === e ? m.touches += 1 : /^(touchend|touchcancel)$/.test(e) && setTimeout(function () {
            m.touches && (m.touches -= 1);
          }, 500);
        }
      };

      return u.init = function (t) {
        var e = document.body;
        t = t || {}, "duration" in t && (p.duration = t.duration), "delay" in t && (p.delay = t.delay), _ && (e.addEventListener("touchstart", h, !1), e.addEventListener("touchcancel", m.registerEvent, !1), e.addEventListener("touchend", m.registerEvent, !1)), e.addEventListener("mousedown", h, !1);
      }, u.attach = function (t, e) {
        t = n(t), "[object Array]" === c.call(e) && (e = e.join(" ")), e = e ? " " + e : "";

        for (var i, r, s = 0, a = t.length; s < a; s++) {
          i = t[s], r = i.tagName.toLowerCase(), -1 !== ["input", "img"].indexOf(r) && (d[r](i), i = i.parentElement), -1 === i.className.indexOf("waves-effect") && (i.className += " waves-effect" + e);
        }
      }, u.ripple = function (t, e) {
        t = n(t);
        var i = t.length;
        if (e = e || {}, e.wait = e.wait || 0, e.position = e.position || null, i) for (var r, a, o, l = {}, h = 0, u = {
          type: "mousedown",
          button: 1
        }; h < i; h++) {
          if (r = t[h], a = e.position || {
            x: r.clientWidth / 2,
            y: r.clientHeight / 2
          }, o = s(r), l.x = o.left + a.x, l.y = o.top + a.y, u.pageX = l.x, u.pageY = l.y, p.show(u, r), e.wait >= 0 && null !== e.wait) {
            var f = {
              type: "mouseup",
              button: 1
            };
            setTimeout(function (t, e) {
              return function () {
                p.hide(t, e);
              };
            }(f, r), e.wait);
          }
        }
      }, u.calm = function (t) {
        t = n(t);

        for (var e = {
          type: "mouseup",
          button: 1
        }, i = 0, r = t.length; i < r; i++) {
          p.hide(e, t[i]);
        }
      }, u.displayEffect = function (t) {
        console.error("Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect"), u.init(t);
      }, u;
    });
  }).call(e, i(0));
}, function (t, e, i) {
  var r, n;
  !function () {
    "use strict";

    function i() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        var r = arguments[e];

        if (r) {
          var n = typeof r;
          if ("string" === n || "number" === n) t.push(r);else if (Array.isArray(r)) t.push(i.apply(null, r));else if ("object" === n) for (var a in r) {
            s.call(r, a) && r[a] && t.push(a);
          }
        }
      }

      return t.join(" ");
    }

    var s = {}.hasOwnProperty;
    "undefined" !== typeof t && t.exports ? t.exports = i : (r = [], void 0 !== (n = function () {
      return i;
    }.apply(e, r)) && (t.exports = n));
  }();
}, function (t, e) {}]);